(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5078"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5078"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
function $d1f26ac162b12b4a$var$assertNonEmptyString(str) {
    if (typeof str !== "string" || !str) throw new Error("expected a non-empty string, got: " + str);
}
function $d1f26ac162b12b4a$var$assertNumber(number) {
    if (typeof number !== "number") throw new Error("expected a number, got: " + number);
}
const $d1f26ac162b12b4a$var$DB_VERSION_CURRENT = 1;
const $d1f26ac162b12b4a$var$DB_VERSION_INITIAL = 1;
const $d1f26ac162b12b4a$var$STORE_EMOJI = "emoji";
const $d1f26ac162b12b4a$var$STORE_KEYVALUE = "keyvalue";
const $d1f26ac162b12b4a$var$STORE_FAVORITES = "favorites";
const $d1f26ac162b12b4a$var$FIELD_TOKENS = "tokens";
const $d1f26ac162b12b4a$var$INDEX_TOKENS = "tokens";
const $d1f26ac162b12b4a$var$FIELD_UNICODE = "unicode";
const $d1f26ac162b12b4a$var$INDEX_COUNT = "count";
const $d1f26ac162b12b4a$var$FIELD_GROUP = "group";
const $d1f26ac162b12b4a$var$FIELD_ORDER = "order";
const $d1f26ac162b12b4a$var$INDEX_GROUP_AND_ORDER = "group-order";
const $d1f26ac162b12b4a$var$KEY_ETAG = "eTag";
const $d1f26ac162b12b4a$var$KEY_URL = "url";
const $d1f26ac162b12b4a$var$KEY_PREFERRED_SKINTONE = "skinTone";
const $d1f26ac162b12b4a$var$MODE_READONLY = "readonly";
const $d1f26ac162b12b4a$var$MODE_READWRITE = "readwrite";
const $d1f26ac162b12b4a$var$INDEX_SKIN_UNICODE = "skinUnicodes";
const $d1f26ac162b12b4a$var$FIELD_SKIN_UNICODE = "skinUnicodes";
const $d1f26ac162b12b4a$var$DEFAULT_DATA_SOURCE = "https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json";
const $d1f26ac162b12b4a$var$DEFAULT_LOCALE = "en";
// like lodash's uniqBy but much smaller
function $d1f26ac162b12b4a$var$uniqBy(arr, func) {
    const set = new Set();
    const res = [];
    for (const item of arr){
        const key = func(item);
        if (!set.has(key)) {
            set.add(key);
            res.push(item);
        }
    }
    return res;
}
function $d1f26ac162b12b4a$var$uniqEmoji(emojis) {
    return $d1f26ac162b12b4a$var$uniqBy(emojis, (_)=>_.unicode);
}
function $d1f26ac162b12b4a$var$initialMigration(db) {
    function createObjectStore(name, keyPath, indexes) {
        const store = keyPath ? db.createObjectStore(name, {
            keyPath: keyPath
        }) : db.createObjectStore(name);
        if (indexes) for (const [indexName, [keyPath, multiEntry]] of Object.entries(indexes))store.createIndex(indexName, keyPath, {
            multiEntry: multiEntry
        });
        return store;
    }
    createObjectStore($d1f26ac162b12b4a$var$STORE_KEYVALUE);
    createObjectStore($d1f26ac162b12b4a$var$STORE_EMOJI, /* keyPath */ $d1f26ac162b12b4a$var$FIELD_UNICODE, {
        [$d1f26ac162b12b4a$var$INDEX_TOKENS]: [
            $d1f26ac162b12b4a$var$FIELD_TOKENS,
            /* multiEntry */ true
        ],
        [$d1f26ac162b12b4a$var$INDEX_GROUP_AND_ORDER]: [
            [
                $d1f26ac162b12b4a$var$FIELD_GROUP,
                $d1f26ac162b12b4a$var$FIELD_ORDER
            ]
        ],
        [$d1f26ac162b12b4a$var$INDEX_SKIN_UNICODE]: [
            $d1f26ac162b12b4a$var$FIELD_SKIN_UNICODE,
            /* multiEntry */ true
        ]
    });
    createObjectStore($d1f26ac162b12b4a$var$STORE_FAVORITES, undefined, {
        [$d1f26ac162b12b4a$var$INDEX_COUNT]: [
            ""
        ]
    });
}
const $d1f26ac162b12b4a$var$openIndexedDBRequests = {};
const $d1f26ac162b12b4a$var$databaseCache = {};
const $d1f26ac162b12b4a$var$onCloseListeners = {};
function $d1f26ac162b12b4a$var$handleOpenOrDeleteReq(resolve, reject, req) {
    // These things are almost impossible to test with fakeIndexedDB sadly
    /* istanbul ignore next */ req.onerror = ()=>reject(req.error);
    /* istanbul ignore next */ req.onblocked = ()=>reject(new Error("IDB blocked"));
    req.onsuccess = ()=>resolve(req.result);
}
async function $d1f26ac162b12b4a$var$createDatabase(dbName) {
    const db = await new Promise((resolve, reject)=>{
        const req = indexedDB.open(dbName, $d1f26ac162b12b4a$var$DB_VERSION_CURRENT);
        $d1f26ac162b12b4a$var$openIndexedDBRequests[dbName] = req;
        req.onupgradeneeded = (e)=>{
            // Technically there is only one version, so we don't need this `if` check
            // But if an old version of the JS is in another browser tab
            // and it gets upgraded in the future and we have a new DB version, well...
            // better safe than sorry.
            /* istanbul ignore else */ if (e.oldVersion < $d1f26ac162b12b4a$var$DB_VERSION_INITIAL) $d1f26ac162b12b4a$var$initialMigration(req.result);
        };
        $d1f26ac162b12b4a$var$handleOpenOrDeleteReq(resolve, reject, req);
    });
    // Handle abnormal closes, e.g. "delete database" in chrome dev tools.
    // No need for removeEventListener, because once the DB can no longer
    // fire "close" events, it will auto-GC.
    // Unfortunately cannot test in fakeIndexedDB: https://github.com/dumbmatter/fakeIndexedDB/issues/50
    /* istanbul ignore next */ db.onclose = ()=>$d1f26ac162b12b4a$var$closeDatabase(dbName);
    return db;
}
function $d1f26ac162b12b4a$var$openDatabase(dbName) {
    if (!$d1f26ac162b12b4a$var$databaseCache[dbName]) $d1f26ac162b12b4a$var$databaseCache[dbName] = $d1f26ac162b12b4a$var$createDatabase(dbName);
    return $d1f26ac162b12b4a$var$databaseCache[dbName];
}
function $d1f26ac162b12b4a$var$dbPromise(db, storeName, readOnlyOrReadWrite, cb) {
    return new Promise((resolve, reject)=>{
        // Use relaxed durability because neither the emoji data nor the favorites/preferred skin tone
        // are really irreplaceable data. IndexedDB is just a cache in this case.
        const txn = db.transaction(storeName, readOnlyOrReadWrite, {
            durability: "relaxed"
        });
        const store = typeof storeName === "string" ? txn.objectStore(storeName) : storeName.map((name)=>txn.objectStore(name));
        let res;
        cb(store, txn, (result)=>{
            res = result;
        });
        txn.oncomplete = ()=>resolve(res);
        /* istanbul ignore next */ txn.onerror = ()=>reject(txn.error);
    });
}
function $d1f26ac162b12b4a$var$closeDatabase(dbName) {
    // close any open requests
    const req = $d1f26ac162b12b4a$var$openIndexedDBRequests[dbName];
    const db = req && req.result;
    if (db) {
        db.close();
        const listeners = $d1f26ac162b12b4a$var$onCloseListeners[dbName];
        /* istanbul ignore else */ if (listeners) for (const listener of listeners)listener();
    }
    delete $d1f26ac162b12b4a$var$openIndexedDBRequests[dbName];
    delete $d1f26ac162b12b4a$var$databaseCache[dbName];
    delete $d1f26ac162b12b4a$var$onCloseListeners[dbName];
}
function $d1f26ac162b12b4a$var$deleteDatabase(dbName) {
    return new Promise((resolve, reject)=>{
        // close any open requests
        $d1f26ac162b12b4a$var$closeDatabase(dbName);
        const req = indexedDB.deleteDatabase(dbName);
        $d1f26ac162b12b4a$var$handleOpenOrDeleteReq(resolve, reject, req);
    });
}
// The "close" event occurs during an abnormal shutdown, e.g. a user clearing their browser data.
// However, it doesn't occur with the normal "close" event, so we handle that separately.
// https://www.w3.org/TR/IndexedDB/#close-a-database-connection
function $d1f26ac162b12b4a$var$addOnCloseListener(dbName, listener) {
    let listeners = $d1f26ac162b12b4a$var$onCloseListeners[dbName];
    if (!listeners) listeners = $d1f26ac162b12b4a$var$onCloseListeners[dbName] = [];
    listeners.push(listener);
}
// list of emoticons that don't match a simple \W+ regex
// extracted using:
// require('emoji-picker-element-data/en/emojibase/data.json').map(_ => _.emoticon).filter(Boolean).filter(_ => !/^\W+$/.test(_))
const $d1f26ac162b12b4a$var$irregularEmoticons = new Set([
    ":D",
    "XD",
    ":'D",
    "O:)",
    ":X",
    ":P",
    ";P",
    "XP",
    ":L",
    ":Z",
    ":j",
    "8D",
    "XO",
    "8)",
    ":B",
    ":O",
    ":S",
    ":'o",
    "Dx",
    "X(",
    "D:",
    ":C",
    ">0)",
    ":3",
    "</3",
    "<3",
    "\\M/",
    ":E",
    "8#"
]);
function $d1f26ac162b12b4a$var$extractTokens(str) {
    return str.split(/[\s_]+/).map((word)=>{
        if (!word.match(/\w/) || $d1f26ac162b12b4a$var$irregularEmoticons.has(word)) // for pure emoticons like :) or :-), just leave them as-is
        return word.toLowerCase();
        return word.replace(/[)(:,]/g, "").replace(/’/g, "'").toLowerCase();
    }).filter(Boolean);
}
const $d1f26ac162b12b4a$var$MIN_SEARCH_TEXT_LENGTH = 2;
// This is an extra step in addition to extractTokens(). The difference here is that we expect
// the input to have already been run through extractTokens(). This is useful for cases like
// emoticons, where we don't want to do any tokenization (because it makes no sense to split up
// ">:)" by the colon) but we do want to lowercase it to have consistent search results, so that
// the user can type ':P' or ':p' and still get the same result.
function $d1f26ac162b12b4a$var$normalizeTokens(str) {
    return str.filter(Boolean).map((_)=>_.toLowerCase()).filter((_)=>_.length >= $d1f26ac162b12b4a$var$MIN_SEARCH_TEXT_LENGTH);
}
// Transform emoji data for storage in IDB
function $d1f26ac162b12b4a$var$transformEmojiData(emojiData) {
    const res = emojiData.map(({ annotation: annotation, emoticon: emoticon, group: group, order: order, shortcodes: shortcodes, skins: skins, tags: tags, emoji: emoji, version: version })=>{
        const tokens = [
            ...new Set($d1f26ac162b12b4a$var$normalizeTokens([
                ...(shortcodes || []).map($d1f26ac162b12b4a$var$extractTokens).flat(),
                ...(tags || []).map($d1f26ac162b12b4a$var$extractTokens).flat(),
                ...$d1f26ac162b12b4a$var$extractTokens(annotation),
                emoticon
            ]))
        ].sort();
        const res = {
            annotation: annotation,
            group: group,
            order: order,
            tags: tags,
            tokens: tokens,
            unicode: emoji,
            version: version
        };
        if (emoticon) res.emoticon = emoticon;
        if (shortcodes) res.shortcodes = shortcodes;
        if (skins) {
            res.skinTones = [];
            res.skinUnicodes = [];
            res.skinVersions = [];
            for (const { tone: tone, emoji: emoji, version: version } of skins){
                res.skinTones.push(tone);
                res.skinUnicodes.push(emoji);
                res.skinVersions.push(version);
            }
        }
        return res;
    });
    return res;
}
// helper functions that help compress the code better
function $d1f26ac162b12b4a$var$callStore(store, method, key, cb) {
    store[method](key).onsuccess = (e)=>cb && cb(e.target.result);
}
function $d1f26ac162b12b4a$var$getIDB(store, key, cb) {
    $d1f26ac162b12b4a$var$callStore(store, "get", key, cb);
}
function $d1f26ac162b12b4a$var$getAllIDB(store, key, cb) {
    $d1f26ac162b12b4a$var$callStore(store, "getAll", key, cb);
}
function $d1f26ac162b12b4a$var$commit(txn) {
    /* istanbul ignore else */ if (txn.commit) txn.commit();
}
// like lodash's minBy
function $d1f26ac162b12b4a$var$minBy(array, func) {
    let minItem = array[0];
    for(let i = 1; i < array.length; i++){
        const item = array[i];
        if (func(minItem) > func(item)) minItem = item;
    }
    return minItem;
}
// return an array of results representing all items that are found in each one of the arrays
//
function $d1f26ac162b12b4a$var$findCommonMembers(arrays, uniqByFunc) {
    const shortestArray = $d1f26ac162b12b4a$var$minBy(arrays, (_)=>_.length);
    const results = [];
    for (const item of shortestArray)// if this item is included in every array in the intermediate results, add it to the final results
    if (!arrays.some((array)=>array.findIndex((_)=>uniqByFunc(_) === uniqByFunc(item)) === -1)) results.push(item);
    return results;
}
async function $d1f26ac162b12b4a$var$isEmpty(db) {
    return !await $d1f26ac162b12b4a$var$get(db, $d1f26ac162b12b4a$var$STORE_KEYVALUE, $d1f26ac162b12b4a$var$KEY_URL);
}
async function $d1f26ac162b12b4a$var$hasData(db, url, eTag) {
    const [oldETag, oldUrl] = await Promise.all([
        $d1f26ac162b12b4a$var$KEY_ETAG,
        $d1f26ac162b12b4a$var$KEY_URL
    ].map((key)=>$d1f26ac162b12b4a$var$get(db, $d1f26ac162b12b4a$var$STORE_KEYVALUE, key)));
    return oldETag === eTag && oldUrl === url;
}
async function $d1f26ac162b12b4a$var$doFullDatabaseScanForSingleResult(db, predicate) {
    // This batching algorithm is just a perf improvement over a basic
    // cursor. The BATCH_SIZE is an estimate of what would give the best
    // perf for doing a full DB scan (worst case).
    //
    // Mini-benchmark for determining the best batch size:
    //
    // PERF=1 pnpm build:rollup && pnpm test:adhoc
    //
    // (async () => {
    //   performance.mark('start')
    //   await $('emoji-picker').database.getEmojiByShortcode('doesnotexist')
    //   performance.measure('total', 'start')
    //   console.log(performance.getEntriesByName('total').slice(-1)[0].duration)
    // })()
    const BATCH_SIZE = 50; // Typically around 150ms for 6x slowdown in Chrome for above benchmark
    return $d1f26ac162b12b4a$var$dbPromise(db, $d1f26ac162b12b4a$var$STORE_EMOJI, $d1f26ac162b12b4a$var$MODE_READONLY, (emojiStore, txn, cb)=>{
        let lastKey;
        const processNextBatch = ()=>{
            emojiStore.getAll(lastKey && IDBKeyRange.lowerBound(lastKey, true), BATCH_SIZE).onsuccess = (e)=>{
                const results = e.target.result;
                for (const result of results){
                    lastKey = result.unicode;
                    if (predicate(result)) return cb(result);
                }
                if (results.length < BATCH_SIZE) return cb();
                processNextBatch();
            };
        };
        processNextBatch();
    });
}
async function $d1f26ac162b12b4a$var$loadData(db, emojiData, url, eTag) {
    {
        const transformedData = $d1f26ac162b12b4a$var$transformEmojiData(emojiData);
        await $d1f26ac162b12b4a$var$dbPromise(db, [
            $d1f26ac162b12b4a$var$STORE_EMOJI,
            $d1f26ac162b12b4a$var$STORE_KEYVALUE
        ], $d1f26ac162b12b4a$var$MODE_READWRITE, ([emojiStore, metaStore], txn)=>{
            let oldETag;
            let oldUrl;
            let todo = 0;
            function checkFetched() {
                if (++todo === 2) onFetched();
            }
            function onFetched() {
                if (oldETag === eTag && oldUrl === url) // check again within the transaction to guard against concurrency, e.g. multiple browser tabs
                return;
                // delete old data
                emojiStore.clear();
                // insert new data
                for (const data of transformedData)emojiStore.put(data);
                metaStore.put(eTag, $d1f26ac162b12b4a$var$KEY_ETAG);
                metaStore.put(url, $d1f26ac162b12b4a$var$KEY_URL);
                $d1f26ac162b12b4a$var$commit(txn);
            }
            $d1f26ac162b12b4a$var$getIDB(metaStore, $d1f26ac162b12b4a$var$KEY_ETAG, (result)=>{
                oldETag = result;
                checkFetched();
            });
            $d1f26ac162b12b4a$var$getIDB(metaStore, $d1f26ac162b12b4a$var$KEY_URL, (result)=>{
                oldUrl = result;
                checkFetched();
            });
        });
    }
}
async function $d1f26ac162b12b4a$var$getEmojiByGroup(db, group) {
    return $d1f26ac162b12b4a$var$dbPromise(db, $d1f26ac162b12b4a$var$STORE_EMOJI, $d1f26ac162b12b4a$var$MODE_READONLY, (emojiStore, txn, cb)=>{
        const range = IDBKeyRange.bound([
            group,
            0
        ], [
            group + 1,
            0
        ], false, true);
        $d1f26ac162b12b4a$var$getAllIDB(emojiStore.index($d1f26ac162b12b4a$var$INDEX_GROUP_AND_ORDER), range, cb);
    });
}
async function $d1f26ac162b12b4a$var$getEmojiBySearchQuery(db, query) {
    const tokens = $d1f26ac162b12b4a$var$normalizeTokens($d1f26ac162b12b4a$var$extractTokens(query));
    if (!tokens.length) return [];
    return $d1f26ac162b12b4a$var$dbPromise(db, $d1f26ac162b12b4a$var$STORE_EMOJI, $d1f26ac162b12b4a$var$MODE_READONLY, (emojiStore, txn, cb)=>{
        // get all results that contain all tokens (i.e. an AND query)
        const intermediateResults = [];
        const checkDone = ()=>{
            if (intermediateResults.length === tokens.length) onDone();
        };
        const onDone = ()=>{
            const results = $d1f26ac162b12b4a$var$findCommonMembers(intermediateResults, (_)=>_.unicode);
            cb(results.sort((a, b)=>a.order < b.order ? -1 : 1));
        };
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            const range = i === tokens.length - 1 ? IDBKeyRange.bound(token, token + "\uFFFF", false, true) // treat last token as a prefix search
             : IDBKeyRange.only(token); // treat all other tokens as an exact match
            $d1f26ac162b12b4a$var$getAllIDB(emojiStore.index($d1f26ac162b12b4a$var$INDEX_TOKENS), range, (result)=>{
                intermediateResults.push(result);
                checkDone();
            });
        }
    });
}
// This could have been implemented as an IDB index on shortcodes, but it seemed wasteful to do that
// when we can already query by tokens and this will give us what we're looking for 99.9% of the time
async function $d1f26ac162b12b4a$var$getEmojiByShortcode(db, shortcode) {
    const emojis = await $d1f26ac162b12b4a$var$getEmojiBySearchQuery(db, shortcode);
    // In very rare cases (e.g. the shortcode "v" as in "v for victory"), we cannot search because
    // there are no usable tokens (too short in this case). In that case, we have to do an inefficient
    // full-database scan, which I believe is an acceptable tradeoff for not having to have an extra
    // index on shortcodes.
    if (!emojis.length) {
        const predicate = (_)=>(_.shortcodes || []).includes(shortcode.toLowerCase());
        return await $d1f26ac162b12b4a$var$doFullDatabaseScanForSingleResult(db, predicate) || null;
    }
    return emojis.filter((_)=>{
        const lowerShortcodes = (_.shortcodes || []).map((_)=>_.toLowerCase());
        return lowerShortcodes.includes(shortcode.toLowerCase());
    })[0] || null;
}
async function $d1f26ac162b12b4a$var$getEmojiByUnicode(db, unicode) {
    return $d1f26ac162b12b4a$var$dbPromise(db, $d1f26ac162b12b4a$var$STORE_EMOJI, $d1f26ac162b12b4a$var$MODE_READONLY, (emojiStore, txn, cb)=>$d1f26ac162b12b4a$var$getIDB(emojiStore, unicode, (result)=>{
            if (result) return cb(result);
            $d1f26ac162b12b4a$var$getIDB(emojiStore.index($d1f26ac162b12b4a$var$INDEX_SKIN_UNICODE), unicode, (result)=>cb(result || null));
        }));
}
function $d1f26ac162b12b4a$var$get(db, storeName, key) {
    return $d1f26ac162b12b4a$var$dbPromise(db, storeName, $d1f26ac162b12b4a$var$MODE_READONLY, (store, txn, cb)=>$d1f26ac162b12b4a$var$getIDB(store, key, cb));
}
function $d1f26ac162b12b4a$var$set(db, storeName, key, value) {
    return $d1f26ac162b12b4a$var$dbPromise(db, storeName, $d1f26ac162b12b4a$var$MODE_READWRITE, (store, txn)=>{
        store.put(value, key);
        $d1f26ac162b12b4a$var$commit(txn);
    });
}
function $d1f26ac162b12b4a$var$incrementFavoriteEmojiCount(db, unicode) {
    return $d1f26ac162b12b4a$var$dbPromise(db, $d1f26ac162b12b4a$var$STORE_FAVORITES, $d1f26ac162b12b4a$var$MODE_READWRITE, (store, txn)=>$d1f26ac162b12b4a$var$getIDB(store, unicode, (result)=>{
            store.put((result || 0) + 1, unicode);
            $d1f26ac162b12b4a$var$commit(txn);
        }));
}
function $d1f26ac162b12b4a$var$getTopFavoriteEmoji(db, customEmojiIndex, limit) {
    if (limit === 0) return [];
    return $d1f26ac162b12b4a$var$dbPromise(db, [
        $d1f26ac162b12b4a$var$STORE_FAVORITES,
        $d1f26ac162b12b4a$var$STORE_EMOJI
    ], $d1f26ac162b12b4a$var$MODE_READONLY, ([favoritesStore, emojiStore], txn, cb)=>{
        const results = [];
        favoritesStore.index($d1f26ac162b12b4a$var$INDEX_COUNT).openCursor(undefined, "prev").onsuccess = (e)=>{
            const cursor = e.target.result;
            if (!cursor) return cb(results);
            function addResult(result) {
                results.push(result);
                if (results.length === limit) return cb(results) // done, reached the limit
                ;
                cursor.continue();
            }
            const unicodeOrName = cursor.primaryKey;
            const custom = customEmojiIndex.byName(unicodeOrName);
            if (custom) return addResult(custom);
            // This could be done in parallel (i.e. make the cursor and the get()s parallelized),
            // but my testing suggests it's not actually faster.
            $d1f26ac162b12b4a$var$getIDB(emojiStore, unicodeOrName, (emoji)=>{
                if (emoji) return addResult(emoji);
                // emoji not found somehow, ignore (may happen if custom emoji change)
                cursor.continue();
            });
        };
    });
}
// trie data structure for prefix searches
// loosely based on https://github.com/nolanlawson/substring-trie
const $d1f26ac162b12b4a$var$CODA_MARKER = ""; // marks the end of the string
function $d1f26ac162b12b4a$var$trie(arr, itemToTokens) {
    const map = new Map();
    for (const item of arr){
        const tokens = itemToTokens(item);
        for (const token of tokens){
            let currentMap = map;
            for(let i = 0; i < token.length; i++){
                const char = token.charAt(i);
                let nextMap = currentMap.get(char);
                if (!nextMap) {
                    nextMap = new Map();
                    currentMap.set(char, nextMap);
                }
                currentMap = nextMap;
            }
            let valuesAtCoda = currentMap.get($d1f26ac162b12b4a$var$CODA_MARKER);
            if (!valuesAtCoda) {
                valuesAtCoda = [];
                currentMap.set($d1f26ac162b12b4a$var$CODA_MARKER, valuesAtCoda);
            }
            valuesAtCoda.push(item);
        }
    }
    const search = (query, exact)=>{
        let currentMap = map;
        for(let i = 0; i < query.length; i++){
            const char = query.charAt(i);
            const nextMap = currentMap.get(char);
            if (nextMap) currentMap = nextMap;
            else return [];
        }
        if (exact) {
            const results = currentMap.get($d1f26ac162b12b4a$var$CODA_MARKER);
            return results || [];
        }
        const results = [];
        // traverse
        const queue = [
            currentMap
        ];
        while(queue.length){
            const currentMap = queue.shift();
            const entriesSortedByKey = [
                ...currentMap.entries()
            ].sort((a, b)=>a[0] < b[0] ? -1 : 1);
            for (const [key, value] of entriesSortedByKey)if (key === $d1f26ac162b12b4a$var$CODA_MARKER) results.push(...value);
            else queue.push(value);
        }
        return results;
    };
    return search;
}
const $d1f26ac162b12b4a$var$requiredKeys$1 = [
    "name",
    "url"
];
function $d1f26ac162b12b4a$var$assertCustomEmojis(customEmojis) {
    const isArray = customEmojis && Array.isArray(customEmojis);
    const firstItemIsFaulty = isArray && customEmojis.length && (!customEmojis[0] || $d1f26ac162b12b4a$var$requiredKeys$1.some((key)=>!(key in customEmojis[0])));
    if (!isArray || firstItemIsFaulty) throw new Error("Custom emojis are in the wrong format");
}
function $d1f26ac162b12b4a$var$customEmojiIndex(customEmojis) {
    $d1f26ac162b12b4a$var$assertCustomEmojis(customEmojis);
    const sortByName = (a, b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    //
    // all()
    //
    const all = customEmojis.sort(sortByName);
    //
    // search()
    //
    const emojiToTokens = (emoji)=>{
        const set = new Set();
        if (emoji.shortcodes) {
            for (const shortcode of emoji.shortcodes)for (const token of $d1f26ac162b12b4a$var$extractTokens(shortcode))set.add(token);
        }
        return set;
    };
    const searchTrie = $d1f26ac162b12b4a$var$trie(customEmojis, emojiToTokens);
    const searchByExactMatch = (_)=>searchTrie(_, true);
    const searchByPrefix = (_)=>searchTrie(_, false);
    // Search by query for custom emoji. Similar to how we do this in IDB, the last token
    // is treated as a prefix search, but every other one is treated as an exact match.
    // Then we AND the results together
    const search = (query)=>{
        const tokens = $d1f26ac162b12b4a$var$extractTokens(query);
        const intermediateResults = tokens.map((token, i)=>(i < tokens.length - 1 ? searchByExactMatch : searchByPrefix)(token));
        return $d1f26ac162b12b4a$var$findCommonMembers(intermediateResults, (_)=>_.name).sort(sortByName);
    };
    //
    // byShortcode, byName
    //
    const shortcodeToEmoji = new Map();
    const nameToEmoji = new Map();
    for (const customEmoji of customEmojis){
        nameToEmoji.set(customEmoji.name.toLowerCase(), customEmoji);
        for (const shortcode of customEmoji.shortcodes || [])shortcodeToEmoji.set(shortcode.toLowerCase(), customEmoji);
    }
    const byShortcode = (shortcode)=>shortcodeToEmoji.get(shortcode.toLowerCase());
    const byName = (name)=>nameToEmoji.get(name.toLowerCase());
    return {
        all: all,
        search: search,
        byShortcode: byShortcode,
        byName: byName
    };
}
const $d1f26ac162b12b4a$var$isFirefoxContentScript = typeof wrappedJSObject !== "undefined";
// remove some internal implementation details, i.e. the "tokens" array on the emoji object
// essentially, convert the emoji from the version stored in IDB to the version used in-memory
function $d1f26ac162b12b4a$var$cleanEmoji(emoji) {
    if (!emoji) return emoji;
    // if inside a Firefox content script, need to clone the emoji object to prevent Firefox from complaining about
    // cross-origin object. See: https://github.com/nolanlawson/emoji-picker-element/issues/356
    /* istanbul ignore if */ if ($d1f26ac162b12b4a$var$isFirefoxContentScript) emoji = structuredClone(emoji);
    delete emoji.tokens;
    if (emoji.skinTones) {
        const len = emoji.skinTones.length;
        emoji.skins = Array(len);
        for(let i = 0; i < len; i++)emoji.skins[i] = {
            tone: emoji.skinTones[i],
            unicode: emoji.skinUnicodes[i],
            version: emoji.skinVersions[i]
        };
        delete emoji.skinTones;
        delete emoji.skinUnicodes;
        delete emoji.skinVersions;
    }
    return emoji;
}
function $d1f26ac162b12b4a$var$warnETag(eTag) {
    if (!eTag) console.warn("emoji-picker-element is more efficient if the dataSource server exposes an ETag header.");
}
const $d1f26ac162b12b4a$var$requiredKeys = [
    "annotation",
    "emoji",
    "group",
    "order",
    "version"
];
function $d1f26ac162b12b4a$var$assertEmojiData(emojiData) {
    if (!emojiData || !Array.isArray(emojiData) || !emojiData[0] || typeof emojiData[0] !== "object" || $d1f26ac162b12b4a$var$requiredKeys.some((key)=>!(key in emojiData[0]))) throw new Error("Emoji data is in the wrong format");
}
function $d1f26ac162b12b4a$var$assertStatus(response, dataSource) {
    if (Math.floor(response.status / 100) !== 2) throw new Error("Failed to fetch: " + dataSource + ":  " + response.status);
}
async function $d1f26ac162b12b4a$var$getETag(dataSource) {
    const response = await fetch(dataSource, {
        method: "HEAD"
    });
    $d1f26ac162b12b4a$var$assertStatus(response, dataSource);
    const eTag = response.headers.get("etag");
    $d1f26ac162b12b4a$var$warnETag(eTag);
    return eTag;
}
async function $d1f26ac162b12b4a$var$getETagAndData(dataSource) {
    const response = await fetch(dataSource);
    $d1f26ac162b12b4a$var$assertStatus(response, dataSource);
    const eTag = response.headers.get("etag");
    $d1f26ac162b12b4a$var$warnETag(eTag);
    const emojiData = await response.json();
    $d1f26ac162b12b4a$var$assertEmojiData(emojiData);
    return [
        eTag,
        emojiData
    ];
}
// TODO: including these in blob-util.ts causes typedoc to generate docs for them,
// even with --excludePrivate ¯\_(ツ)_/¯
/** @private */ /**
 * Convert an `ArrayBuffer` to a binary string.
 *
 * Example:
 *
 * ```js
 * var myString = blobUtil.arrayBufferToBinaryString(arrayBuff)
 * ```
 *
 * @param buffer - array buffer
 * @returns binary string
 */ function $d1f26ac162b12b4a$var$arrayBufferToBinaryString(buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var length = bytes.byteLength;
    var i = -1;
    while(++i < length)binary += String.fromCharCode(bytes[i]);
    return binary;
}
/**
 * Convert a binary string to an `ArrayBuffer`.
 *
 * ```js
 * var myBuffer = blobUtil.binaryStringToArrayBuffer(binaryString)
 * ```
 *
 * @param binary - binary string
 * @returns array buffer
 */ function $d1f26ac162b12b4a$var$binaryStringToArrayBuffer(binary) {
    var length = binary.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    var i = -1;
    while(++i < length)arr[i] = binary.charCodeAt(i);
    return buf;
}
// generate a checksum based on the stringified JSON
async function $d1f26ac162b12b4a$var$jsonChecksum(object) {
    const inString = JSON.stringify(object);
    let inBuffer = $d1f26ac162b12b4a$var$binaryStringToArrayBuffer(inString);
    // this does not need to be cryptographically secure, SHA-1 is fine
    const outBuffer = await crypto.subtle.digest("SHA-1", inBuffer);
    const outBinString = $d1f26ac162b12b4a$var$arrayBufferToBinaryString(outBuffer);
    const res = btoa(outBinString);
    return res;
}
async function $d1f26ac162b12b4a$var$checkForUpdates(db, dataSource) {
    // just do a simple HEAD request first to see if the eTags match
    let emojiData;
    let eTag = await $d1f26ac162b12b4a$var$getETag(dataSource);
    if (!eTag) {
        const eTagAndData = await $d1f26ac162b12b4a$var$getETagAndData(dataSource);
        eTag = eTagAndData[0];
        emojiData = eTagAndData[1];
        if (!eTag) eTag = await $d1f26ac162b12b4a$var$jsonChecksum(emojiData);
    }
    if (await $d1f26ac162b12b4a$var$hasData(db, dataSource, eTag)) ;
    else {
        if (!emojiData) {
            const eTagAndData = await $d1f26ac162b12b4a$var$getETagAndData(dataSource);
            emojiData = eTagAndData[1];
        }
        await $d1f26ac162b12b4a$var$loadData(db, emojiData, dataSource, eTag);
    }
}
async function $d1f26ac162b12b4a$var$loadDataForFirstTime(db, dataSource) {
    let [eTag, emojiData] = await $d1f26ac162b12b4a$var$getETagAndData(dataSource);
    if (!eTag) // Handle lack of support for ETag or Access-Control-Expose-Headers
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Expose-Headers#Browser_compatibility
    eTag = await $d1f26ac162b12b4a$var$jsonChecksum(emojiData);
    await $d1f26ac162b12b4a$var$loadData(db, emojiData, dataSource, eTag);
}
class $d1f26ac162b12b4a$export$2e2bcd8739ae039 {
    constructor({ dataSource: dataSource = $d1f26ac162b12b4a$var$DEFAULT_DATA_SOURCE, locale: locale = $d1f26ac162b12b4a$var$DEFAULT_LOCALE, customEmoji: customEmoji = [] } = {}){
        this.dataSource = dataSource;
        this.locale = locale;
        this._dbName = `emoji-picker-element-${this.locale}`;
        this._db = undefined;
        this._lazyUpdate = undefined;
        this._custom = $d1f26ac162b12b4a$var$customEmojiIndex(customEmoji);
        this._clear = this._clear.bind(this);
        this._ready = this._init();
    }
    async _init() {
        const db = this._db = await $d1f26ac162b12b4a$var$openDatabase(this._dbName);
        $d1f26ac162b12b4a$var$addOnCloseListener(this._dbName, this._clear);
        const dataSource = this.dataSource;
        const empty = await $d1f26ac162b12b4a$var$isEmpty(db);
        if (empty) await $d1f26ac162b12b4a$var$loadDataForFirstTime(db, dataSource);
        else this._lazyUpdate = $d1f26ac162b12b4a$var$checkForUpdates(db, dataSource);
    }
    async ready() {
        const checkReady = async ()=>{
            if (!this._ready) this._ready = this._init();
            return this._ready;
        };
        await checkReady();
        // There's a possibility of a race condition where the element gets added, removed, and then added again
        // with a particular timing, which would set the _db to undefined.
        // We *could* do a while loop here, but that seems excessive and could lead to an infinite loop.
        if (!this._db) await checkReady();
    }
    async getEmojiByGroup(group) {
        $d1f26ac162b12b4a$var$assertNumber(group);
        await this.ready();
        return $d1f26ac162b12b4a$var$uniqEmoji(await $d1f26ac162b12b4a$var$getEmojiByGroup(this._db, group)).map($d1f26ac162b12b4a$var$cleanEmoji);
    }
    async getEmojiBySearchQuery(query) {
        $d1f26ac162b12b4a$var$assertNonEmptyString(query);
        await this.ready();
        const customs = this._custom.search(query);
        const natives = $d1f26ac162b12b4a$var$uniqEmoji(await $d1f26ac162b12b4a$var$getEmojiBySearchQuery(this._db, query)).map($d1f26ac162b12b4a$var$cleanEmoji);
        return [
            ...customs,
            ...natives
        ];
    }
    async getEmojiByShortcode(shortcode) {
        $d1f26ac162b12b4a$var$assertNonEmptyString(shortcode);
        await this.ready();
        const custom = this._custom.byShortcode(shortcode);
        if (custom) return custom;
        return $d1f26ac162b12b4a$var$cleanEmoji(await $d1f26ac162b12b4a$var$getEmojiByShortcode(this._db, shortcode));
    }
    async getEmojiByUnicodeOrName(unicodeOrName) {
        $d1f26ac162b12b4a$var$assertNonEmptyString(unicodeOrName);
        await this.ready();
        const custom = this._custom.byName(unicodeOrName);
        if (custom) return custom;
        return $d1f26ac162b12b4a$var$cleanEmoji(await $d1f26ac162b12b4a$var$getEmojiByUnicode(this._db, unicodeOrName));
    }
    async getPreferredSkinTone() {
        await this.ready();
        return await $d1f26ac162b12b4a$var$get(this._db, $d1f26ac162b12b4a$var$STORE_KEYVALUE, $d1f26ac162b12b4a$var$KEY_PREFERRED_SKINTONE) || 0;
    }
    async setPreferredSkinTone(skinTone) {
        $d1f26ac162b12b4a$var$assertNumber(skinTone);
        await this.ready();
        return $d1f26ac162b12b4a$var$set(this._db, $d1f26ac162b12b4a$var$STORE_KEYVALUE, $d1f26ac162b12b4a$var$KEY_PREFERRED_SKINTONE, skinTone);
    }
    async incrementFavoriteEmojiCount(unicodeOrName) {
        $d1f26ac162b12b4a$var$assertNonEmptyString(unicodeOrName);
        await this.ready();
        return $d1f26ac162b12b4a$var$incrementFavoriteEmojiCount(this._db, unicodeOrName);
    }
    async getTopFavoriteEmoji(limit) {
        $d1f26ac162b12b4a$var$assertNumber(limit);
        await this.ready();
        return (await $d1f26ac162b12b4a$var$getTopFavoriteEmoji(this._db, this._custom, limit)).map($d1f26ac162b12b4a$var$cleanEmoji);
    }
    set customEmoji(customEmojis) {
        this._custom = $d1f26ac162b12b4a$var$customEmojiIndex(customEmojis);
    }
    get customEmoji() {
        return this._custom.all;
    }
    async _shutdown() {
        await this.ready(); // reopen if we've already been closed/deleted
        try {
            await this._lazyUpdate; // allow any lazy updates to process before closing/deleting
        } catch (err) {}
    }
    // clear references to IDB, e.g. during a close event
    _clear() {
        // We don't need to call removeEventListener or remove the manual "close" listeners.
        // The memory leak tests prove this is unnecessary. It's because:
        // 1) IDBDatabases that can no longer fire "close" automatically have listeners GCed
        // 2) we clear the manual close listeners in databaseLifecycle.js.
        this._db = this._ready = this._lazyUpdate = undefined;
    }
    async close() {
        await this._shutdown();
        await $d1f26ac162b12b4a$var$closeDatabase(this._dbName);
    }
    async delete() {
        await this._shutdown();
        await $d1f26ac162b12b4a$var$deleteDatabase(this._dbName);
    }
}


// via https://unpkg.com/browse/emojibase-data@6.0.0/meta/groups.json
const $1e5dc5e467331cb9$var$allGroups = [
    [
        -1,
        "\u2728",
        "custom"
    ],
    [
        0,
        "\uD83D\uDE00",
        "smileys-emotion"
    ],
    [
        1,
        "\uD83D\uDC4B",
        "people-body"
    ],
    [
        3,
        "\uD83D\uDC31",
        "animals-nature"
    ],
    [
        4,
        "\uD83C\uDF4E",
        "food-drink"
    ],
    [
        5,
        "\uD83C\uDFE0\uFE0F",
        "travel-places"
    ],
    [
        6,
        "\u26BD",
        "activities"
    ],
    [
        7,
        "\uD83D\uDCDD",
        "objects"
    ],
    [
        8,
        "\u26D4\uFE0F",
        "symbols"
    ],
    [
        9,
        "\uD83C\uDFC1",
        "flags"
    ]
].map(([id, emoji, name])=>({
        id: id,
        emoji: emoji,
        name: name
    }));
const $1e5dc5e467331cb9$var$groups = $1e5dc5e467331cb9$var$allGroups.slice(1);
const $1e5dc5e467331cb9$var$MIN_SEARCH_TEXT_LENGTH = 2;
const $1e5dc5e467331cb9$var$NUM_SKIN_TONES = 6;
/* istanbul ignore next */ const $1e5dc5e467331cb9$var$rIC = typeof requestIdleCallback === "function" ? requestIdleCallback : setTimeout;
// check for ZWJ (zero width joiner) character
function $1e5dc5e467331cb9$var$hasZwj(emoji) {
    return emoji.unicode.includes("\u200D");
}
// Find one good representative emoji from each version to test by checking its color.
// Ideally it should have color in the center. For some inspiration, see:
// https://about.gitlab.com/blog/2018/05/30/journey-in-native-unicode-emoji/
//
// Note that for certain versions (12.1, 13.1), there is no point in testing them explicitly, because
// all the emoji from this version are compound-emoji from previous versions. So they would pass a color
// test, even in browsers that display them as double emoji. (E.g. "face in clouds" might render as
// "face without mouth" plus "fog".) These emoji can only be filtered using the width test,
// which happens in checkZwjSupport.js.
const $1e5dc5e467331cb9$var$versionsAndTestEmoji = {
    "\uD83E\uDEE8": 15.1,
    "\uD83E\uDEE0": 14,
    "\uD83E\uDD72": 13.1,
    "\uD83E\uDD7B": 12.1,
    "\uD83E\uDD70": 11,
    "\uD83E\uDD29": 5,
    "\uD83D\uDC71\u200D\u2640\uFE0F": 4,
    "\uD83E\uDD23": 3,
    "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F": 2,
    "\uD83D\uDE00": 1,
    "\uD83D\uDE10\uFE0F": 0.7,
    "\uD83D\uDE03": 0.6
};
const $1e5dc5e467331cb9$var$TIMEOUT_BEFORE_LOADING_MESSAGE = 1000; // 1 second
const $1e5dc5e467331cb9$var$DEFAULT_SKIN_TONE_EMOJI = "\uD83D\uDD90\uFE0F";
const $1e5dc5e467331cb9$var$DEFAULT_NUM_COLUMNS = 8;
// Based on https://fivethirtyeight.com/features/the-100-most-used-emojis/ and
// https://blog.emojipedia.org/facebook-reveals-most-and-least-used-emojis/ with
// a bit of my own curation. (E.g. avoid the "OK" gesture because of connotations:
// https://emojipedia.org/ok-hand/)
const $1e5dc5e467331cb9$var$MOST_COMMONLY_USED_EMOJI = [
    "\uD83D\uDE0A",
    "\uD83D\uDE12",
    "\u2764\uFE0F",
    "\uD83D\uDC4D\uFE0F",
    "\uD83D\uDE0D",
    "\uD83D\uDE02",
    "\uD83D\uDE2D",
    "\u263A\uFE0F",
    "\uD83D\uDE14",
    "\uD83D\uDE29",
    "\uD83D\uDE0F",
    "\uD83D\uDC95",
    "\uD83D\uDE4C",
    "\uD83D\uDE18"
];
// It's important to list Twemoji Mozilla before everything else, because Mozilla bundles their
// own font on some platforms (notably Windows and Linux as of this writing). Typically, Mozilla
// updates faster than the underlying OS, and we don't want to render older emoji in one font and
// newer emoji in another font:
// https://github.com/nolanlawson/emoji-picker-element/pull/268#issuecomment-1073347283
const $1e5dc5e467331cb9$var$FONT_FAMILY = '"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji","EmojiOne Color","Android Emoji",sans-serif';
/* istanbul ignore next */ const $1e5dc5e467331cb9$var$DEFAULT_CATEGORY_SORTING = (a, b)=>a < b ? -1 : a > b ? 1 : 0;
// Test if an emoji is supported by rendering it to canvas and checking that the color is not black
// See https://about.gitlab.com/blog/2018/05/30/journey-in-native-unicode-emoji/
// and https://www.npmjs.com/package/if-emoji for inspiration
// This implementation is largely borrowed from if-emoji, adding the font-family
const $1e5dc5e467331cb9$var$getTextFeature = (text, color)=>{
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext("2d", {
        // Improves the performance of `getImageData()`
        // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/getContextAttributes#willreadfrequently
        willReadFrequently: true
    });
    ctx.textBaseline = "top";
    ctx.font = `100px ${$1e5dc5e467331cb9$var$FONT_FAMILY}`;
    ctx.fillStyle = color;
    ctx.scale(0.01, 0.01);
    ctx.fillText(text, 0, 0);
    return ctx.getImageData(0, 0, 1, 1).data;
};
const $1e5dc5e467331cb9$var$compareFeatures = (feature1, feature2)=>{
    const feature1Str = [
        ...feature1
    ].join(",");
    const feature2Str = [
        ...feature2
    ].join(",");
    // This is RGBA, so for 0,0,0, we are checking that the first RGB is not all zeroes.
    // Most of the time when unsupported this is 0,0,0,0, but on Chrome on Mac it is
    // 0,0,0,61 - there is a transparency here.
    return feature1Str === feature2Str && !feature1Str.startsWith("0,0,0,");
};
function $1e5dc5e467331cb9$var$testColorEmojiSupported(text) {
    // Render white and black and then compare them to each other and ensure they're the same
    // color, and neither one is black. This shows that the emoji was rendered in color.
    const feature1 = $1e5dc5e467331cb9$var$getTextFeature(text, "#000");
    const feature2 = $1e5dc5e467331cb9$var$getTextFeature(text, "#fff");
    return feature1 && feature2 && $1e5dc5e467331cb9$var$compareFeatures(feature1, feature2);
}
// rather than check every emoji ever, which would be expensive, just check some representatives from the
// different emoji releases to determine what the font supports
function $1e5dc5e467331cb9$var$determineEmojiSupportLevel() {
    const entries = Object.entries($1e5dc5e467331cb9$var$versionsAndTestEmoji);
    try {
        // start with latest emoji and work backwards
        for (const [emoji, version] of entries){
            if ($1e5dc5e467331cb9$var$testColorEmojiSupported(emoji)) return version;
        }
    } catch (e) {} finally{}
    // In case of an error, be generous and just assume all emoji are supported (e.g. for canvas errors
    // due to anti-fingerprinting add-ons). Better to show some gray boxes than nothing at all.
    return entries[0][1] // first one in the list is the most recent version
    ;
}
// Check which emojis we know for sure aren't supported, based on Unicode version level
let $1e5dc5e467331cb9$var$promise;
const $1e5dc5e467331cb9$var$detectEmojiSupportLevel = ()=>{
    if (!$1e5dc5e467331cb9$var$promise) // Delay so it can run while the IDB database is being created by the browser (on another thread).
    // This helps especially with first load – we want to start pre-populating the database on the main thread,
    // and then wait for IDB to commit everything, and while waiting we run this check.
    $1e5dc5e467331cb9$var$promise = new Promise((resolve)=>$1e5dc5e467331cb9$var$rIC(()=>resolve($1e5dc5e467331cb9$var$determineEmojiSupportLevel()) // delay so ideally this can run while IDB is first populating
        ));
    return $1e5dc5e467331cb9$var$promise;
};
// determine which emojis containing ZWJ (zero width joiner) characters
// are supported (rendered as one glyph) rather than unsupported (rendered as two or more glyphs)
const $1e5dc5e467331cb9$var$supportedZwjEmojis = new Map();
const $1e5dc5e467331cb9$var$VARIATION_SELECTOR = "\uFE0F";
const $1e5dc5e467331cb9$var$SKINTONE_MODIFIER = "\ud83c";
const $1e5dc5e467331cb9$var$ZWJ = "\u200D";
const $1e5dc5e467331cb9$var$LIGHT_SKIN_TONE = 0x1F3FB;
const $1e5dc5e467331cb9$var$LIGHT_SKIN_TONE_MODIFIER = 0xdffb;
// TODO: this is a naive implementation, we can improve it later
// It's only used for the skintone picker, so as long as people don't customize with
// really exotic emoji then it should work fine
function $1e5dc5e467331cb9$var$applySkinTone(str, skinTone) {
    if (skinTone === 0) return str;
    const zwjIndex = str.indexOf($1e5dc5e467331cb9$var$ZWJ);
    if (zwjIndex !== -1) return str.substring(0, zwjIndex) + String.fromCodePoint($1e5dc5e467331cb9$var$LIGHT_SKIN_TONE + skinTone - 1) + str.substring(zwjIndex);
    if (str.endsWith($1e5dc5e467331cb9$var$VARIATION_SELECTOR)) str = str.substring(0, str.length - 1);
    return str + $1e5dc5e467331cb9$var$SKINTONE_MODIFIER + String.fromCodePoint($1e5dc5e467331cb9$var$LIGHT_SKIN_TONE_MODIFIER + skinTone - 1);
}
function $1e5dc5e467331cb9$var$halt(event) {
    event.preventDefault();
    event.stopPropagation();
}
// Implementation left/right or up/down navigation, circling back when you
// reach the start/end of the list
function $1e5dc5e467331cb9$var$incrementOrDecrement(decrement, val, arr) {
    val += decrement ? -1 : 1;
    if (val < 0) val = arr.length - 1;
    else if (val >= arr.length) val = 0;
    return val;
}
// like lodash's uniqBy but much smaller
function $1e5dc5e467331cb9$var$uniqBy(arr, func) {
    const set = new Set();
    const res = [];
    for (const item of arr){
        const key = func(item);
        if (!set.has(key)) {
            set.add(key);
            res.push(item);
        }
    }
    return res;
}
// We don't need all the data on every emoji, and there are specific things we need
// for the UI, so build a "view model" from the emoji object we got from the database
function $1e5dc5e467331cb9$var$summarizeEmojisForUI(emojis, emojiSupportLevel) {
    const toSimpleSkinsMap = (skins)=>{
        const res = {};
        for (const skin of skins)// ignore arrays like [1, 2] with multiple skin tones
        // also ignore variants that are in an unsupported emoji version
        // (these do exist - variants from a different version than their base emoji)
        if (typeof skin.tone === "number" && skin.version <= emojiSupportLevel) res[skin.tone] = skin.unicode;
        return res;
    };
    return emojis.map(({ unicode: unicode, skins: skins, shortcodes: shortcodes, url: url, name: name, category: category, annotation: annotation })=>({
            unicode: unicode,
            name: name,
            shortcodes: shortcodes,
            url: url,
            category: category,
            annotation: annotation,
            id: unicode || name,
            skins: skins && toSimpleSkinsMap(skins)
        }));
}
// import rAF from one place so that the bundle size is a bit smaller
const $1e5dc5e467331cb9$var$rAF = requestAnimationFrame;
// "Svelte action"-like utility to detect layout changes via ResizeObserver.
// If ResizeObserver is unsupported, we just use rAF once and don't bother to update.
let $1e5dc5e467331cb9$var$resizeObserverSupported = typeof ResizeObserver === "function";
function $1e5dc5e467331cb9$var$resizeObserverAction(node, abortSignal, onUpdate) {
    let resizeObserver;
    if ($1e5dc5e467331cb9$var$resizeObserverSupported) {
        resizeObserver = new ResizeObserver(onUpdate);
        resizeObserver.observe(node);
    } else $1e5dc5e467331cb9$var$rAF(onUpdate);
    // cleanup function (called on destroy)
    abortSignal.addEventListener("abort", ()=>{
        if (resizeObserver) resizeObserver.disconnect();
    });
}
// get the width of the text inside of a DOM node, via https://stackoverflow.com/a/59525891/680742
function $1e5dc5e467331cb9$var$calculateTextWidth(node) {
    // skip running this in jest/vitest because we don't need to check for emoji support in that environment
    /* istanbul ignore else */ {
        const range = document.createRange();
        range.selectNode(node.firstChild);
        return range.getBoundingClientRect().width;
    }
}
let $1e5dc5e467331cb9$var$baselineEmojiWidth;
/**
 * Check if the given emojis containing ZWJ characters are supported by the current browser (don't render
 * as double characters) and return true if all are supported.
 * @param zwjEmojisToCheck
 * @param baselineEmoji
 * @param emojiToDomNode
 */ function $1e5dc5e467331cb9$var$checkZwjSupport(zwjEmojisToCheck, baselineEmoji, emojiToDomNode) {
    let allSupported = true;
    for (const emoji of zwjEmojisToCheck){
        const domNode = emojiToDomNode(emoji);
        const emojiWidth = $1e5dc5e467331cb9$var$calculateTextWidth(domNode);
        if (typeof $1e5dc5e467331cb9$var$baselineEmojiWidth === "undefined") $1e5dc5e467331cb9$var$baselineEmojiWidth = $1e5dc5e467331cb9$var$calculateTextWidth(baselineEmoji);
        // On Windows, some supported emoji are ~50% bigger than the baseline emoji, but what we really want to guard
        // against are the ones that are 2x the size, because those are truly broken (person with red hair = person with
        // floating red wig, black cat = cat with black square, polar bear = bear with snowflake, etc.)
        // So here we set the threshold at 1.8 times the size of the baseline emoji.
        const supported = emojiWidth / 1.8 < $1e5dc5e467331cb9$var$baselineEmojiWidth;
        $1e5dc5e467331cb9$var$supportedZwjEmojis.set(emoji.unicode, supported);
        if (!supported) allSupported = false;
    }
    return allSupported;
}
// like lodash's uniq
function $1e5dc5e467331cb9$var$uniq(arr) {
    return $1e5dc5e467331cb9$var$uniqBy(arr, (_)=>_);
}
// Note we put this in its own function outside Picker.js to avoid Svelte doing an invalidation on the "setter" here.
// At best the invalidation is useless, at worst it can cause infinite loops:
// https://github.com/nolanlawson/emoji-picker-element/pull/180
// https://github.com/sveltejs/svelte/issues/6521
// Also note tabpanelElement can be null if the element is disconnected immediately after connected
function $1e5dc5e467331cb9$var$resetScrollTopIfPossible(element) {
    /* istanbul ignore else */ if (element) element.scrollTop = 0;
}
function $1e5dc5e467331cb9$var$getFromMap(cache, key, func) {
    let cached = cache.get(key);
    if (!cached) {
        cached = func();
        cache.set(key, cached);
    }
    return cached;
}
function $1e5dc5e467331cb9$var$toString(value) {
    return "" + value;
}
function $1e5dc5e467331cb9$var$parseTemplate(htmlString) {
    const template = document.createElement("template");
    template.innerHTML = htmlString;
    return template;
}
const $1e5dc5e467331cb9$var$parseCache = new WeakMap();
const $1e5dc5e467331cb9$var$domInstancesCache = new WeakMap();
// This needs to be a symbol because it needs to be different from any possible output of a key function
const $1e5dc5e467331cb9$var$unkeyedSymbol = Symbol("un-keyed");
// Not supported in Safari <=13
const $1e5dc5e467331cb9$var$hasReplaceChildren = "replaceChildren" in Element.prototype;
function $1e5dc5e467331cb9$var$replaceChildren(parentNode, newChildren) {
    /* istanbul ignore else */ if ($1e5dc5e467331cb9$var$hasReplaceChildren) parentNode.replaceChildren(...newChildren);
    else {
        parentNode.innerHTML = "";
        parentNode.append(...newChildren);
    }
}
function $1e5dc5e467331cb9$var$doChildrenNeedRerender(parentNode, newChildren) {
    let oldChild = parentNode.firstChild;
    let oldChildrenCount = 0;
    // iterate using firstChild/nextSibling because browsers use a linked list under the hood
    while(oldChild){
        const newChild = newChildren[oldChildrenCount];
        // check if the old child and new child are the same
        if (newChild !== oldChild) return true;
        oldChild = oldChild.nextSibling;
        oldChildrenCount++;
    }
    // if new children length is different from old, we must re-render
    return oldChildrenCount !== newChildren.length;
}
function $1e5dc5e467331cb9$var$patchChildren(newChildren, instanceBinding) {
    const { targetNode: targetNode } = instanceBinding;
    let { targetParentNode: targetParentNode } = instanceBinding;
    let needsRerender = false;
    if (targetParentNode) needsRerender = $1e5dc5e467331cb9$var$doChildrenNeedRerender(targetParentNode, newChildren);
    else {
        needsRerender = true;
        instanceBinding.targetNode = undefined; // placeholder node not needed anymore, free memory
        instanceBinding.targetParentNode = targetParentNode = targetNode.parentNode;
    }
    // avoid re-rendering list if the dom nodes are exactly the same before and after
    if (needsRerender) $1e5dc5e467331cb9$var$replaceChildren(targetParentNode, newChildren);
}
function $1e5dc5e467331cb9$var$patch(expressions, instanceBindings) {
    for (const instanceBinding of instanceBindings){
        const { targetNode: targetNode, currentExpression: currentExpression, binding: { expressionIndex: expressionIndex, attributeName: attributeName, attributeValuePre: attributeValuePre, attributeValuePost: attributeValuePost } } = instanceBinding;
        const expression = expressions[expressionIndex];
        if (currentExpression === expression) continue;
        instanceBinding.currentExpression = expression;
        if (attributeName) targetNode.setAttribute(attributeName, attributeValuePre + $1e5dc5e467331cb9$var$toString(expression) + attributeValuePost);
        else {
            let newNode;
            if (Array.isArray(expression)) $1e5dc5e467331cb9$var$patchChildren(expression, instanceBinding);
            else if (expression instanceof Element) {
                newNode = expression;
                targetNode.replaceWith(newNode);
            } else // nodeValue is faster than textContent supposedly https://www.youtube.com/watch?v=LY6y3HbDVmg
            // note we may be replacing the value in a placeholder text node
            targetNode.nodeValue = $1e5dc5e467331cb9$var$toString(expression);
            if (newNode) instanceBinding.targetNode = newNode;
        }
    }
}
function $1e5dc5e467331cb9$var$parse(tokens) {
    let htmlString = "";
    let withinTag = false;
    let withinAttribute = false;
    let elementIndexCounter = -1; // depth-first traversal order
    const elementsToBindings = new Map();
    const elementIndexes = [];
    for(let i = 0, len = tokens.length; i < len; i++){
        const token = tokens[i];
        htmlString += token;
        if (i === len - 1) break; // no need to process characters - no more expressions to be found
        for(let j = 0; j < token.length; j++){
            const char = token.charAt(j);
            switch(char){
                case "<":
                    {
                        const nextChar = token.charAt(j + 1);
                        if (nextChar === "/") // leaving an element
                        elementIndexes.pop();
                        else {
                            withinTag = true;
                            elementIndexes.push(++elementIndexCounter);
                        }
                        break;
                    }
                case ">":
                    withinTag = false;
                    withinAttribute = false;
                    break;
                case "=":
                    withinAttribute = true;
                    break;
            }
        }
        const elementIndex = elementIndexes[elementIndexes.length - 1];
        const bindings = $1e5dc5e467331cb9$var$getFromMap(elementsToBindings, elementIndex, ()=>[]);
        let attributeName;
        let attributeValuePre;
        let attributeValuePost;
        if (withinAttribute) {
            // I never use single-quotes for attribute values in HTML, so just support double-quotes or no-quotes
            const match = /(\S+)="?([^"=]*)$/.exec(token);
            attributeName = match[1];
            attributeValuePre = match[2];
            attributeValuePost = /^[^">]*/.exec(tokens[i + 1])[0];
        }
        const binding = {
            attributeName: attributeName,
            attributeValuePre: attributeValuePre,
            attributeValuePost: attributeValuePost,
            expressionIndex: i
        };
        bindings.push(binding);
        if (!withinTag && !withinAttribute) // Add a placeholder text node, so we can find it later. Note we only support one dynamic child text node
        htmlString += " ";
    }
    const template = $1e5dc5e467331cb9$var$parseTemplate(htmlString);
    return {
        template: template,
        elementsToBindings: elementsToBindings
    };
}
function $1e5dc5e467331cb9$var$applyBindings(bindings, element, instanceBindings) {
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        const targetNode = binding.attributeName ? element // attribute binding, just use the element itself
         : element.firstChild; // not an attribute binding, so has a placeholder text node
        const instanceBinding = {
            binding: binding,
            targetNode: targetNode,
            targetParentNode: undefined,
            currentExpression: undefined
        };
        instanceBindings.push(instanceBinding);
    }
}
function $1e5dc5e467331cb9$var$traverseAndSetupBindings(rootElement, elementsToBindings) {
    const instanceBindings = [];
    let topLevelBindings;
    if (elementsToBindings.size === 1 && (topLevelBindings = elementsToBindings.get(0))) // Optimization for the common case where there's only one element and one binding
    // Skip creating a TreeWalker entirely and just handle the root DOM element
    $1e5dc5e467331cb9$var$applyBindings(topLevelBindings, rootElement, instanceBindings);
    else {
        // traverse dom
        const treeWalker = document.createTreeWalker(rootElement, NodeFilter.SHOW_ELEMENT);
        let element = rootElement;
        let elementIndex = -1;
        do {
            const bindings = elementsToBindings.get(++elementIndex);
            if (bindings) $1e5dc5e467331cb9$var$applyBindings(bindings, element, instanceBindings);
        }while (element = treeWalker.nextNode());
    }
    return instanceBindings;
}
function $1e5dc5e467331cb9$var$parseHtml(tokens) {
    // All templates and bound expressions are unique per tokens array
    const { template: template, elementsToBindings: elementsToBindings } = $1e5dc5e467331cb9$var$getFromMap($1e5dc5e467331cb9$var$parseCache, tokens, ()=>$1e5dc5e467331cb9$var$parse(tokens));
    // When we parseHtml, we always return a fresh DOM instance ready to be updated
    const dom = template.cloneNode(true).content.firstElementChild;
    const instanceBindings = $1e5dc5e467331cb9$var$traverseAndSetupBindings(dom, elementsToBindings);
    return function updateDomInstance(expressions) {
        $1e5dc5e467331cb9$var$patch(expressions, instanceBindings);
        return dom;
    };
}
function $1e5dc5e467331cb9$var$createFramework(state) {
    const domInstances = $1e5dc5e467331cb9$var$getFromMap($1e5dc5e467331cb9$var$domInstancesCache, state, ()=>new Map());
    let domInstanceCacheKey = $1e5dc5e467331cb9$var$unkeyedSymbol;
    function html(tokens, ...expressions) {
        // Each unique lexical usage of map() is considered unique due to the html`` tagged template call it makes,
        // which has lexically unique tokens. The unkeyed symbol is just used for html`` usage outside of a map().
        const domInstancesForTokens = $1e5dc5e467331cb9$var$getFromMap(domInstances, tokens, ()=>new Map());
        const updateDomInstance = $1e5dc5e467331cb9$var$getFromMap(domInstancesForTokens, domInstanceCacheKey, ()=>$1e5dc5e467331cb9$var$parseHtml(tokens));
        return updateDomInstance(expressions) // update with expressions
        ;
    }
    function map(array, callback, keyFunction) {
        return array.map((item, index)=>{
            const originalCacheKey = domInstanceCacheKey;
            domInstanceCacheKey = keyFunction(item);
            try {
                return callback(item, index);
            } finally{
                domInstanceCacheKey = originalCacheKey;
            }
        });
    }
    return {
        map: map,
        html: html
    };
}
function $1e5dc5e467331cb9$var$render(container, state, helpers, events, actions, refs, abortSignal, actionContext, firstRender) {
    const { labelWithSkin: labelWithSkin, titleForEmoji: titleForEmoji, unicodeWithSkin: unicodeWithSkin } = helpers;
    const { html: html, map: map } = $1e5dc5e467331cb9$var$createFramework(state);
    function emojiList(emojis, searchMode, prefix) {
        return map(emojis, (emoji, i)=>{
            return html`<button role="${searchMode ? "option" : "menuitem"}" aria-selected="${searchMode ? i === state.activeSearchItem : ""}" aria-label="${labelWithSkin(emoji, state.currentSkinTone)}" title="${titleForEmoji(emoji)}" class="${"emoji" + (searchMode && i === state.activeSearchItem ? " active" : "") + (emoji.unicode ? "" : " custom-emoji")}" id="${`${prefix}-${emoji.id}`}" style="${emoji.unicode ? "" : `--custom-emoji-background: url(${JSON.stringify(emoji.url)})`}">${emoji.unicode ? unicodeWithSkin(emoji, state.currentSkinTone) : ""}</button>`;
        // It's important for the cache key to be unique based on the prefix, because the framework caches based on the
        // unique tokens + cache key, and the same emoji may be used in the tab as well as in the fav bar
        }, (emoji)=>`${prefix}-${emoji.id}`);
    }
    const section = ()=>{
        return html`<section data-ref="rootElement" class="picker" aria-label="${state.i18n.regionLabel}" style="${state.pickerStyle || ""}"><div class="pad-top"></div><div class="search-row"><div class="search-wrapper"><input id="search" class="search" type="search" role="combobox" enterkeyhint="search" placeholder="${state.i18n.searchLabel}" autocapitalize="none" autocomplete="off" spellcheck="true" aria-expanded="${!!(state.searchMode && state.currentEmojis.length)}" aria-controls="search-results" aria-describedby="search-description" aria-autocomplete="list" aria-activedescendant="${state.activeSearchItemId ? `emo-${state.activeSearchItemId}` : ""}" data-ref="searchElement" data-on-input="onSearchInput" data-on-keydown="onSearchKeydown"><label class="sr-only" for="search">${state.i18n.searchLabel}</label> <span id="search-description" class="sr-only">${state.i18n.searchDescription}</span></div><div class="skintone-button-wrapper ${state.skinTonePickerExpandedAfterAnimation ? "expanded" : ""}"><button id="skintone-button" class="emoji ${state.skinTonePickerExpanded ? "hide-focus" : ""}" aria-label="${state.skinToneButtonLabel}" title="${state.skinToneButtonLabel}" aria-describedby="skintone-description" aria-haspopup="listbox" aria-expanded="${state.skinTonePickerExpanded}" aria-controls="skintone-list" data-on-click="onClickSkinToneButton">${state.skinToneButtonText || ""}</button></div><span id="skintone-description" class="sr-only">${state.i18n.skinToneDescription}</span><div data-ref="skinToneDropdown" id="skintone-list" class="skintone-list hide-focus ${state.skinTonePickerExpanded ? "" : "hidden no-animate"}" style="transform:translateY(${state.skinTonePickerExpanded ? 0 : "calc(-1 * var(--num-skintones) * var(--total-emoji-size))"})" role="listbox" aria-label="${state.i18n.skinTonesLabel}" aria-activedescendant="skintone-${state.activeSkinTone}" aria-hidden="${!state.skinTonePickerExpanded}" tabIndex="-1" data-on-focusout="onSkinToneOptionsFocusOut" data-on-click="onSkinToneOptionsClick" data-on-keydown="onSkinToneOptionsKeydown" data-on-keyup="onSkinToneOptionsKeyup">${map(state.skinTones, (skinTone, i)=>{
            return html`<div id="skintone-${i}" class="emoji ${i === state.activeSkinTone ? "active" : ""}" aria-selected="${i === state.activeSkinTone}" role="option" title="${state.i18n.skinTones[i]}" aria-label="${state.i18n.skinTones[i]}">${skinTone}</div>`;
        }, (skinTone)=>skinTone)}</div></div><div class="nav" role="tablist" style="grid-template-columns:repeat(${state.groups.length},1fr)" aria-label="${state.i18n.categoriesLabel}" data-on-keydown="onNavKeydown" data-on-click="onNavClick">${map(state.groups, (group)=>{
            return html`<button role="tab" class="nav-button" aria-controls="tab-${group.id}" aria-label="${state.i18n.categories[group.name]}" aria-selected="${!state.searchMode && state.currentGroup.id === group.id}" title="${state.i18n.categories[group.name]}" data-group-id="${group.id}"><div class="nav-emoji emoji">${group.emoji}</div></button>`;
        }, (group)=>group.id)}</div><div class="indicator-wrapper"><div class="indicator" style="transform:translateX(${/* istanbul ignore next */ (state.isRtl ? -1 : 1) * state.currentGroupIndex * 100}%)"></div></div><div class="message ${state.message ? "" : "gone"}" role="alert" aria-live="polite">${state.message || ""}</div><div data-ref="tabpanelElement" class="tabpanel ${!state.databaseLoaded || state.message ? "gone" : ""}" role="${state.searchMode ? "region" : "tabpanel"}" aria-label="${state.searchMode ? state.i18n.searchResultsLabel : state.i18n.categories[state.currentGroup.name]}" id="${state.searchMode ? "" : `tab-${state.currentGroup.id}`}" tabIndex="0" data-on-click="onEmojiClick"><div data-action="calculateEmojiGridStyle">${map(state.currentEmojisWithCategories, (emojiWithCategory, i)=>{
            return html`<div><div id="menu-label-${i}" class="category ${state.currentEmojisWithCategories.length === 1 && state.currentEmojisWithCategories[0].category === "" ? "gone" : ""}" aria-hidden="true">${state.searchMode ? state.i18n.searchResultsLabel : emojiWithCategory.category ? emojiWithCategory.category : state.currentEmojisWithCategories.length > 1 ? state.i18n.categories.custom : state.i18n.categories[state.currentGroup.name]}</div><div class="emoji-menu ${i !== 0 && !state.searchMode && state.currentGroup.id === -1 ? "visibility-auto" : ""}" style="${`--num-rows: ${Math.ceil(emojiWithCategory.emojis.length / state.numColumns)}`}" data-action="updateOnIntersection" role="${state.searchMode ? "listbox" : "menu"}" aria-labelledby="menu-label-${i}" id="${state.searchMode ? "search-results" : ""}">${emojiList(emojiWithCategory.emojis, state.searchMode, /* prefix */ "emo")}</div></div>`;
        }, (emojiWithCategory)=>emojiWithCategory.category)}</div></div><div class="favorites onscreen emoji-menu ${state.message ? "gone" : ""}" role="menu" aria-label="${state.i18n.favoritesLabel}" data-on-click="onEmojiClick">${emojiList(state.currentFavorites, /* searchMode */ false, /* prefix */ "fav")}</div><button data-ref="baselineEmoji" aria-hidden="true" tabindex="-1" class="abs-pos hidden emoji baseline-emoji">😀</button></section>`;
    };
    const rootDom = section();
    // helper for traversing the dom, finding elements by an attribute, and getting the attribute value
    const forElementWithAttribute = (attributeName, callback)=>{
        for (const element of container.querySelectorAll(`[${attributeName}]`))callback(element, element.getAttribute(attributeName));
    };
    if (firstRender) {
        container.appendChild(rootDom);
        // we only bind events/refs once - there is no need to find them again given this component structure
        // bind events
        for (const eventName of [
            "click",
            "focusout",
            "input",
            "keydown",
            "keyup"
        ])forElementWithAttribute(`data-on-${eventName}`, (element, listenerName)=>{
            element.addEventListener(eventName, events[listenerName]);
        });
        // find refs
        forElementWithAttribute("data-ref", (element, ref)=>{
            refs[ref] = element;
        });
        // destroy/abort logic
        abortSignal.addEventListener("abort", ()=>{
            container.removeChild(rootDom);
        });
    }
    // set up actions - these are re-bound on every render
    forElementWithAttribute("data-action", (element, action)=>{
        let boundActions = actionContext.get(action);
        if (!boundActions) actionContext.set(action, boundActions = new WeakSet());
        // avoid applying the same action to the same element multiple times
        if (!boundActions.has(element)) {
            boundActions.add(element);
            actions[action](element);
        }
    });
}
/* istanbul ignore next */ const $1e5dc5e467331cb9$var$qM = typeof queueMicrotask === "function" ? queueMicrotask : (callback)=>Promise.resolve().then(callback);
function $1e5dc5e467331cb9$var$createState(abortSignal) {
    let destroyed = false;
    let currentObserver;
    const propsToObservers = new Map();
    const dirtyObservers = new Set();
    let queued;
    const flush = ()=>{
        if (destroyed) return;
        const observersToRun = [
            ...dirtyObservers
        ];
        dirtyObservers.clear(); // clear before running to force any new updates to run in another tick of the loop
        try {
            for (const observer of observersToRun)observer();
        } finally{
            queued = false;
            if (dirtyObservers.size) {
                queued = true;
                $1e5dc5e467331cb9$var$qM(flush);
            }
        }
    };
    const state = new Proxy({}, {
        get (target, prop) {
            if (currentObserver) {
                let observers = propsToObservers.get(prop);
                if (!observers) {
                    observers = new Set();
                    propsToObservers.set(prop, observers);
                }
                observers.add(currentObserver);
            }
            return target[prop];
        },
        set (target, prop, newValue) {
            if (target[prop] !== newValue) {
                target[prop] = newValue;
                const observers = propsToObservers.get(prop);
                if (observers) {
                    for (const observer of observers)dirtyObservers.add(observer);
                    if (!queued) {
                        queued = true;
                        $1e5dc5e467331cb9$var$qM(flush);
                    }
                }
            }
            return true;
        }
    });
    const createEffect = (callback)=>{
        const runnable = ()=>{
            const oldObserver = currentObserver;
            currentObserver = runnable;
            try {
                return callback();
            } finally{
                currentObserver = oldObserver;
            }
        };
        return runnable();
    };
    // destroy logic
    abortSignal.addEventListener("abort", ()=>{
        destroyed = true;
    });
    return {
        state: state,
        createEffect: createEffect
    };
}
// Compare two arrays, with a function called on each item in the two arrays that returns true if the items are equal
function $1e5dc5e467331cb9$var$arraysAreEqualByFunction(left, right, areEqualFunc) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (!areEqualFunc(left[i], right[i])) return false;
    }
    return true;
}
const $1e5dc5e467331cb9$var$intersectionObserverCache = new WeakMap();
function $1e5dc5e467331cb9$var$intersectionObserverAction(node, abortSignal, listener) {
    /* istanbul ignore else */ {
        // The scroll root is always `.tabpanel`
        const root = node.closest(".tabpanel");
        let observer = $1e5dc5e467331cb9$var$intersectionObserverCache.get(root);
        if (!observer) {
            // TODO: replace this with the contentvisibilityautostatechange event when all supported browsers support it.
            // For now we use IntersectionObserver because it has better cross-browser support, and it would be bad for
            // old Safari versions if they eagerly downloaded all custom emoji all at once.
            observer = new IntersectionObserver(listener, {
                root: root,
                // trigger if we are 1/2 scroll container height away so that the images load a bit quicker while scrolling
                rootMargin: "50% 0px 50% 0px",
                // trigger if any part of the emoji grid is intersecting
                threshold: 0
            });
            // avoid creating a new IntersectionObserver for every category; just use one for the whole root
            $1e5dc5e467331cb9$var$intersectionObserverCache.set(root, observer);
            // assume that the abortSignal is always the same for this root node; just add one event listener
            abortSignal.addEventListener("abort", ()=>{
                observer.disconnect();
            });
        }
        observer.observe(node);
    }
}
/* eslint-disable prefer-const,no-labels,no-inner-declarations */ // constants
const $1e5dc5e467331cb9$var$EMPTY_ARRAY = [];
const { assign: $1e5dc5e467331cb9$var$assign } = Object;
function $1e5dc5e467331cb9$var$createRoot(shadowRoot, props) {
    const refs = {};
    const abortController = new AbortController();
    const abortSignal = abortController.signal;
    const { state: state, createEffect: createEffect } = $1e5dc5e467331cb9$var$createState(abortSignal);
    const actionContext = new Map();
    // initial state
    $1e5dc5e467331cb9$var$assign(state, {
        skinToneEmoji: undefined,
        i18n: undefined,
        database: undefined,
        customEmoji: undefined,
        customCategorySorting: undefined,
        emojiVersion: undefined
    });
    // public props
    $1e5dc5e467331cb9$var$assign(state, props);
    // private props
    $1e5dc5e467331cb9$var$assign(state, {
        initialLoad: true,
        currentEmojis: [],
        currentEmojisWithCategories: [],
        rawSearchText: "",
        searchText: "",
        searchMode: false,
        activeSearchItem: -1,
        message: undefined,
        skinTonePickerExpanded: false,
        skinTonePickerExpandedAfterAnimation: false,
        currentSkinTone: 0,
        activeSkinTone: 0,
        skinToneButtonText: undefined,
        pickerStyle: undefined,
        skinToneButtonLabel: "",
        skinTones: [],
        currentFavorites: [],
        defaultFavoriteEmojis: undefined,
        numColumns: $1e5dc5e467331cb9$var$DEFAULT_NUM_COLUMNS,
        isRtl: false,
        currentGroupIndex: 0,
        groups: $1e5dc5e467331cb9$var$groups,
        databaseLoaded: false,
        activeSearchItemId: undefined
    });
    //
    // Update the current group based on the currentGroupIndex
    //
    createEffect(()=>{
        if (state.currentGroup !== state.groups[state.currentGroupIndex]) state.currentGroup = state.groups[state.currentGroupIndex];
    });
    //
    // Utils/helpers
    //
    const focus = (id)=>{
        shadowRoot.getElementById(id).focus();
    };
    const emojiToDomNode = (emoji)=>shadowRoot.getElementById(`emo-${emoji.id}`);
    // fire a custom event that crosses the shadow boundary
    const fireEvent = (name, detail)=>{
        refs.rootElement.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    };
    //
    // Comparison utils
    //
    const compareEmojiArrays = (a, b)=>a.id === b.id;
    const compareCurrentEmojisWithCategories = (a, b)=>{
        const { category: aCategory, emojis: aEmojis } = a;
        const { category: bCategory, emojis: bEmojis } = b;
        if (aCategory !== bCategory) return false;
        return $1e5dc5e467331cb9$var$arraysAreEqualByFunction(aEmojis, bEmojis, compareEmojiArrays);
    };
    //
    // Update utils to avoid excessive re-renders
    //
    // avoid excessive re-renders by checking the value before setting
    const updateCurrentEmojis = (newEmojis)=>{
        if (!$1e5dc5e467331cb9$var$arraysAreEqualByFunction(state.currentEmojis, newEmojis, compareEmojiArrays)) state.currentEmojis = newEmojis;
    };
    // avoid excessive re-renders
    const updateSearchMode = (newSearchMode)=>{
        if (state.searchMode !== newSearchMode) state.searchMode = newSearchMode;
    };
    // avoid excessive re-renders
    const updateCurrentEmojisWithCategories = (newEmojisWithCategories)=>{
        if (!$1e5dc5e467331cb9$var$arraysAreEqualByFunction(state.currentEmojisWithCategories, newEmojisWithCategories, compareCurrentEmojisWithCategories)) state.currentEmojisWithCategories = newEmojisWithCategories;
    };
    // Helpers used by PickerTemplate
    const unicodeWithSkin = (emoji, currentSkinTone)=>currentSkinTone && emoji.skins && emoji.skins[currentSkinTone] || emoji.unicode;
    const labelWithSkin = (emoji, currentSkinTone)=>$1e5dc5e467331cb9$var$uniq([
            emoji.name || unicodeWithSkin(emoji, currentSkinTone),
            emoji.annotation,
            ...emoji.shortcodes || $1e5dc5e467331cb9$var$EMPTY_ARRAY
        ].filter(Boolean)).join(", ");
    const titleForEmoji = (emoji)=>emoji.annotation || (emoji.shortcodes || $1e5dc5e467331cb9$var$EMPTY_ARRAY).join(", ");
    const helpers = {
        labelWithSkin: labelWithSkin,
        titleForEmoji: titleForEmoji,
        unicodeWithSkin: unicodeWithSkin
    };
    const events = {
        onClickSkinToneButton: onClickSkinToneButton,
        onEmojiClick: onEmojiClick,
        onNavClick: onNavClick,
        onNavKeydown: onNavKeydown,
        onSearchKeydown: onSearchKeydown,
        onSkinToneOptionsClick: onSkinToneOptionsClick,
        onSkinToneOptionsFocusOut: onSkinToneOptionsFocusOut,
        onSkinToneOptionsKeydown: onSkinToneOptionsKeydown,
        onSkinToneOptionsKeyup: onSkinToneOptionsKeyup,
        onSearchInput: onSearchInput
    };
    const actions = {
        calculateEmojiGridStyle: calculateEmojiGridStyle,
        updateOnIntersection: updateOnIntersection
    };
    let firstRender = true;
    createEffect(()=>{
        $1e5dc5e467331cb9$var$render(shadowRoot, state, helpers, events, actions, refs, abortSignal, actionContext, firstRender);
        firstRender = false;
    });
    //
    // Determine the emoji support level (in requestIdleCallback)
    //
    // mount logic
    if (!state.emojiVersion) $1e5dc5e467331cb9$var$detectEmojiSupportLevel().then((level)=>{
        // Can't actually test emoji support in Jest/Vitest/JSDom, emoji never render in color in Cairo
        /* istanbul ignore next */ if (!level) state.message = state.i18n.emojiUnsupportedMessage;
    });
    //
    // Set or update the database object
    //
    createEffect(()=>{
        // show a Loading message if it takes a long time, or show an error if there's a network/IDB error
        async function handleDatabaseLoading() {
            let showingLoadingMessage = false;
            const timeoutHandle = setTimeout(()=>{
                showingLoadingMessage = true;
                state.message = state.i18n.loadingMessage;
            }, $1e5dc5e467331cb9$var$TIMEOUT_BEFORE_LOADING_MESSAGE);
            try {
                await state.database.ready();
                state.databaseLoaded = true; // eslint-disable-line no-unused-vars
            } catch (err) {
                console.error(err);
                state.message = state.i18n.networkErrorMessage;
            } finally{
                clearTimeout(timeoutHandle);
                if (showingLoadingMessage) {
                    showingLoadingMessage = false;
                    state.message = ""; // eslint-disable-line no-unused-vars
                }
            }
        }
        if (state.database) /* no await */ handleDatabaseLoading();
    });
    //
    // Global styles for the entire picker
    //
    createEffect(()=>{
        state.pickerStyle = `
      --num-groups: ${state.groups.length}; 
      --indicator-opacity: ${state.searchMode ? 0 : 1}; 
      --num-skintones: ${$1e5dc5e467331cb9$var$NUM_SKIN_TONES};`;
    });
    //
    // Set or update the customEmoji
    //
    createEffect(()=>{
        if (state.customEmoji && state.database) updateCustomEmoji(); // re-run whenever customEmoji change
    });
    createEffect(()=>{
        if (state.customEmoji && state.customEmoji.length) {
            if (state.groups !== $1e5dc5e467331cb9$var$allGroups) state.groups = $1e5dc5e467331cb9$var$allGroups;
        } else if (state.groups !== $1e5dc5e467331cb9$var$groups) {
            if (state.currentGroupIndex) // If the current group is anything other than "custom" (which is first), decrement.
            // This fixes the odd case where you set customEmoji, then pick a category, then unset customEmoji
            state.currentGroupIndex--;
            state.groups = $1e5dc5e467331cb9$var$groups;
        }
    });
    //
    // Set or update the preferred skin tone
    //
    createEffect(()=>{
        async function updatePreferredSkinTone() {
            if (state.databaseLoaded) state.currentSkinTone = await state.database.getPreferredSkinTone();
        }
        /* no await */ updatePreferredSkinTone();
    });
    createEffect(()=>{
        state.skinTones = Array($1e5dc5e467331cb9$var$NUM_SKIN_TONES).fill().map((_, i)=>$1e5dc5e467331cb9$var$applySkinTone(state.skinToneEmoji, i));
    });
    createEffect(()=>{
        state.skinToneButtonText = state.skinTones[state.currentSkinTone];
    });
    createEffect(()=>{
        state.skinToneButtonLabel = state.i18n.skinToneLabel.replace("{skinTone}", state.i18n.skinTones[state.currentSkinTone]);
    });
    //
    // Set or update the favorites emojis
    //
    createEffect(()=>{
        async function updateDefaultFavoriteEmojis() {
            const { database: database } = state;
            const favs = (await Promise.all($1e5dc5e467331cb9$var$MOST_COMMONLY_USED_EMOJI.map((unicode)=>database.getEmojiByUnicodeOrName(unicode)))).filter(Boolean); // filter because in Jest/Vitest tests we don't have all the emoji in the DB
            state.defaultFavoriteEmojis = favs;
        }
        if (state.databaseLoaded) /* no await */ updateDefaultFavoriteEmojis();
    });
    function updateCustomEmoji() {
        // Certain effects have an implicit dependency on customEmoji since it affects the database
        // Getting it here on the state ensures this effect re-runs when customEmoji change.
        const { customEmoji: customEmoji, database: database } = state;
        const databaseCustomEmoji = customEmoji || $1e5dc5e467331cb9$var$EMPTY_ARRAY;
        if (database.customEmoji !== databaseCustomEmoji) // Avoid setting this if the customEmoji have _not_ changed, because the setter triggers a re-computation of the
        // `customEmojiIndex`. Note we don't bother with deep object changes.
        database.customEmoji = databaseCustomEmoji;
    }
    createEffect(()=>{
        async function updateFavorites() {
            updateCustomEmoji(); // re-run whenever customEmoji change
            const { database: database, defaultFavoriteEmojis: defaultFavoriteEmojis, numColumns: numColumns } = state;
            const dbFavorites = await database.getTopFavoriteEmoji(numColumns);
            const favorites = await summarizeEmojis($1e5dc5e467331cb9$var$uniqBy([
                ...dbFavorites,
                ...defaultFavoriteEmojis
            ], (_)=>_.unicode || _.name).slice(0, numColumns));
            state.currentFavorites = favorites;
        }
        if (state.databaseLoaded && state.defaultFavoriteEmojis) /* no await */ updateFavorites();
    });
    //
    // Re-run whenever the emoji grid changes size, and re-calc style/layout-related state variables:
    // 1) Re-calculate the --num-columns var because it may have changed
    // 2) Re-calculate whether we're in RTL mode or not.
    //
    // The benefit of doing this in one place is to align with rAF/ResizeObserver
    // and do all the calculations in one go. RTL vs LTR is not strictly layout-related,
    // but since we're already reading the style here, and since it's already aligned with
    // the rAF loop, this is the most appropriate place to do it perf-wise.
    //
    function calculateEmojiGridStyle(node) {
        $1e5dc5e467331cb9$var$resizeObserverAction(node, abortSignal, ()=>{
            /* istanbul ignore next */ {
                // read all the style/layout calculations we need to make
                const style = getComputedStyle(refs.rootElement);
                const newNumColumns = parseInt(style.getPropertyValue("--num-columns"), 10);
                const newIsRtl = style.getPropertyValue("direction") === "rtl";
                // write to state variables
                state.numColumns = newNumColumns;
                state.isRtl = newIsRtl;
            }
        });
    }
    // Re-run whenever the custom emoji in a category are shown/hidden. This is an optimization that simulates
    // what we'd get from `<img loading=lazy>` but without rendering an `<img>`.
    function updateOnIntersection(node) {
        $1e5dc5e467331cb9$var$intersectionObserverAction(node, abortSignal, (entries)=>{
            for (const { target: target, isIntersecting: isIntersecting } of entries)target.classList.toggle("onscreen", isIntersecting);
        });
    }
    //
    // Set or update the currentEmojis. Check for invalid ZWJ renderings
    // (i.e. double emoji).
    //
    createEffect(()=>{
        async function updateEmojis() {
            const { searchText: searchText, currentGroup: currentGroup, databaseLoaded: databaseLoaded, customEmoji: customEmoji } = state;
            if (!databaseLoaded) {
                state.currentEmojis = [];
                state.searchMode = false;
            } else if (searchText.length >= $1e5dc5e467331cb9$var$MIN_SEARCH_TEXT_LENGTH) {
                const newEmojis = await getEmojisBySearchQuery(searchText);
                if (state.searchText === searchText) {
                    updateCurrentEmojis(newEmojis);
                    updateSearchMode(true);
                }
            } else {
                const { id: currentGroupId } = currentGroup;
                // avoid race condition where currentGroupId is -1 and customEmoji is undefined/empty
                if (currentGroupId !== -1 || customEmoji && customEmoji.length) {
                    const newEmojis = await getEmojisByGroup(currentGroupId);
                    if (state.currentGroup.id === currentGroupId) {
                        updateCurrentEmojis(newEmojis);
                        updateSearchMode(false);
                    }
                }
            }
        }
        /* no await */ updateEmojis();
    });
    const resetScrollTopInRaf = ()=>{
        $1e5dc5e467331cb9$var$rAF(()=>$1e5dc5e467331cb9$var$resetScrollTopIfPossible(refs.tabpanelElement));
    };
    // Some emojis have their ligatures rendered as two or more consecutive emojis
    // We want to treat these the same as unsupported emojis, so we compare their
    // widths against the baseline widths and remove them as necessary
    createEffect(()=>{
        const { currentEmojis: currentEmojis, emojiVersion: emojiVersion } = state;
        const zwjEmojisToCheck = currentEmojis.filter((emoji)=>emoji.unicode) // filter custom emoji
        .filter((emoji)=>$1e5dc5e467331cb9$var$hasZwj(emoji) && !$1e5dc5e467331cb9$var$supportedZwjEmojis.has(emoji.unicode));
        if (!emojiVersion && zwjEmojisToCheck.length) {
            // render now, check their length later
            updateCurrentEmojis(currentEmojis);
            $1e5dc5e467331cb9$var$rAF(()=>checkZwjSupportAndUpdate(zwjEmojisToCheck));
        } else {
            const newEmojis = emojiVersion ? currentEmojis : currentEmojis.filter(isZwjSupported);
            updateCurrentEmojis(newEmojis);
            // Reset scroll top to 0 when emojis change
            resetScrollTopInRaf();
        }
    });
    function checkZwjSupportAndUpdate(zwjEmojisToCheck) {
        const allSupported = $1e5dc5e467331cb9$var$checkZwjSupport(zwjEmojisToCheck, refs.baselineEmoji, emojiToDomNode);
        if (allSupported) // Even if all emoji are supported, we still need to reset the scroll top to 0 when emojis change
        resetScrollTopInRaf();
        else // Force update. We only do this if there are any unsupported ZWJ characters since otherwise,
        // for browsers that support all emoji, it would be an unnecessary extra re-render.
        state.currentEmojis = [
            ...state.currentEmojis
        ];
    }
    function isZwjSupported(emoji) {
        return !emoji.unicode || !$1e5dc5e467331cb9$var$hasZwj(emoji) || $1e5dc5e467331cb9$var$supportedZwjEmojis.get(emoji.unicode);
    }
    async function filterEmojisByVersion(emojis) {
        const emojiSupportLevel = state.emojiVersion || await $1e5dc5e467331cb9$var$detectEmojiSupportLevel();
        // !version corresponds to custom emoji
        return emojis.filter(({ version: version })=>!version || version <= emojiSupportLevel);
    }
    async function summarizeEmojis(emojis) {
        return $1e5dc5e467331cb9$var$summarizeEmojisForUI(emojis, state.emojiVersion || await $1e5dc5e467331cb9$var$detectEmojiSupportLevel());
    }
    async function getEmojisByGroup(group) {
        // -1 is custom emoji
        const emoji = group === -1 ? state.customEmoji : await state.database.getEmojiByGroup(group);
        return summarizeEmojis(await filterEmojisByVersion(emoji));
    }
    async function getEmojisBySearchQuery(query) {
        return summarizeEmojis(await filterEmojisByVersion(await state.database.getEmojiBySearchQuery(query)));
    }
    createEffect(()=>{});
    //
    // Derive currentEmojisWithCategories from currentEmojis. This is always done even if there
    // are no categories, because it's just easier to code the HTML this way.
    //
    createEffect(()=>{
        function calculateCurrentEmojisWithCategories() {
            const { searchMode: searchMode, currentEmojis: currentEmojis } = state;
            if (searchMode) return [
                {
                    category: "",
                    emojis: currentEmojis
                }
            ];
            const categoriesToEmoji = new Map();
            for (const emoji of currentEmojis){
                const category = emoji.category || "";
                let emojis = categoriesToEmoji.get(category);
                if (!emojis) {
                    emojis = [];
                    categoriesToEmoji.set(category, emojis);
                }
                emojis.push(emoji);
            }
            return [
                ...categoriesToEmoji.entries()
            ].map(([category, emojis])=>({
                    category: category,
                    emojis: emojis
                })).sort((a, b)=>state.customCategorySorting(a.category, b.category));
        }
        const newEmojisWithCategories = calculateCurrentEmojisWithCategories();
        updateCurrentEmojisWithCategories(newEmojisWithCategories);
    });
    //
    // Handle active search item (i.e. pressing up or down while searching)
    //
    createEffect(()=>{
        state.activeSearchItemId = state.activeSearchItem !== -1 && state.currentEmojis[state.activeSearchItem].id;
    });
    //
    // Handle user input on the search input
    //
    createEffect(()=>{
        const { rawSearchText: rawSearchText } = state;
        $1e5dc5e467331cb9$var$rIC(()=>{
            state.searchText = (rawSearchText || "").trim(); // defer to avoid input delays, plus we can trim here
            state.activeSearchItem = -1;
        });
    });
    function onSearchKeydown(event) {
        if (!state.searchMode || !state.currentEmojis.length) return;
        const goToNextOrPrevious = (previous)=>{
            $1e5dc5e467331cb9$var$halt(event);
            state.activeSearchItem = $1e5dc5e467331cb9$var$incrementOrDecrement(previous, state.activeSearchItem, state.currentEmojis);
        };
        switch(event.key){
            case "ArrowDown":
                return goToNextOrPrevious(false);
            case "ArrowUp":
                return goToNextOrPrevious(true);
            case "Enter":
                if (state.activeSearchItem === -1) // focus the first option in the list since the list must be non-empty at this point (it's verified above)
                state.activeSearchItem = 0;
                else {
                    $1e5dc5e467331cb9$var$halt(event);
                    return clickEmoji(state.currentEmojis[state.activeSearchItem].id);
                }
        }
    }
    //
    // Handle user input on nav
    //
    function onNavClick(event) {
        const { target: target } = event;
        const closestTarget = target.closest(".nav-button");
        /* istanbul ignore if */ if (!closestTarget) return; // This should never happen, but makes me nervous not to have it
        const groupId = parseInt(closestTarget.dataset.groupId, 10);
        refs.searchElement.value = ""; // clear search box input
        state.rawSearchText = "";
        state.searchText = "";
        state.activeSearchItem = -1;
        state.currentGroupIndex = state.groups.findIndex((_)=>_.id === groupId);
    }
    function onNavKeydown(event) {
        const { target: target, key: key } = event;
        const doFocus = (el)=>{
            if (el) {
                $1e5dc5e467331cb9$var$halt(event);
                el.focus();
            }
        };
        switch(key){
            case "ArrowLeft":
                return doFocus(target.previousElementSibling);
            case "ArrowRight":
                return doFocus(target.nextElementSibling);
            case "Home":
                return doFocus(target.parentElement.firstElementChild);
            case "End":
                return doFocus(target.parentElement.lastElementChild);
        }
    }
    //
    // Handle user input on an emoji
    //
    async function clickEmoji(unicodeOrName) {
        const emoji = await state.database.getEmojiByUnicodeOrName(unicodeOrName);
        const emojiSummary = [
            ...state.currentEmojis,
            ...state.currentFavorites
        ].find((_)=>_.id === unicodeOrName);
        const skinTonedUnicode = emojiSummary.unicode && unicodeWithSkin(emojiSummary, state.currentSkinTone);
        await state.database.incrementFavoriteEmojiCount(unicodeOrName);
        fireEvent("emoji-click", {
            emoji: emoji,
            skinTone: state.currentSkinTone,
            ...skinTonedUnicode && {
                unicode: skinTonedUnicode
            },
            ...emojiSummary.name && {
                name: emojiSummary.name
            }
        });
    }
    async function onEmojiClick(event) {
        const { target: target } = event;
        /* istanbul ignore if */ if (!target.classList.contains("emoji")) // This should never happen, but makes me nervous not to have it
        return;
        $1e5dc5e467331cb9$var$halt(event);
        const id = target.id.substring(4); // replace 'emo-' or 'fav-' prefix
        /* no await */ clickEmoji(id);
    }
    //
    // Handle user input on the skintone picker
    //
    function changeSkinTone(skinTone) {
        state.currentSkinTone = skinTone;
        state.skinTonePickerExpanded = false;
        focus("skintone-button");
        fireEvent("skin-tone-change", {
            skinTone: skinTone
        });
        /* no await */ state.database.setPreferredSkinTone(skinTone);
    }
    function onSkinToneOptionsClick(event) {
        const { target: { id: id } } = event;
        const match = id && id.match(/^skintone-(\d)/); // skintone option format
        /* istanbul ignore if */ if (!match) return; // This should never happen, but makes me nervous not to have it
        $1e5dc5e467331cb9$var$halt(event);
        const skinTone = parseInt(match[1], 10); // remove 'skintone-' prefix
        changeSkinTone(skinTone);
    }
    function onClickSkinToneButton(event) {
        state.skinTonePickerExpanded = !state.skinTonePickerExpanded;
        state.activeSkinTone = state.currentSkinTone;
        // this should always be true, since the button is obscured by the listbox, so this `if` is just to be sure
        if (state.skinTonePickerExpanded) {
            $1e5dc5e467331cb9$var$halt(event);
            $1e5dc5e467331cb9$var$rAF(()=>focus("skintone-list"));
        }
    }
    // To make the animation nicer, change the z-index of the skintone picker button
    // *after* the animation has played. This makes it appear that the picker box
    // is expanding "below" the button
    createEffect(()=>{
        if (state.skinTonePickerExpanded) refs.skinToneDropdown.addEventListener("transitionend", ()=>{
            state.skinTonePickerExpandedAfterAnimation = true; // eslint-disable-line no-unused-vars
        }, {
            once: true
        });
        else state.skinTonePickerExpandedAfterAnimation = false; // eslint-disable-line no-unused-vars
    });
    function onSkinToneOptionsKeydown(event) {
        // this should never happen, but makes me nervous not to have it
        /* istanbul ignore if */ if (!state.skinTonePickerExpanded) return;
        const changeActiveSkinTone = async (nextSkinTone)=>{
            $1e5dc5e467331cb9$var$halt(event);
            state.activeSkinTone = nextSkinTone;
        };
        switch(event.key){
            case "ArrowUp":
                return changeActiveSkinTone($1e5dc5e467331cb9$var$incrementOrDecrement(true, state.activeSkinTone, state.skinTones));
            case "ArrowDown":
                return changeActiveSkinTone($1e5dc5e467331cb9$var$incrementOrDecrement(false, state.activeSkinTone, state.skinTones));
            case "Home":
                return changeActiveSkinTone(0);
            case "End":
                return changeActiveSkinTone(state.skinTones.length - 1);
            case "Enter":
                // enter on keydown, space on keyup. this is just how browsers work for buttons
                // https://lists.w3.org/Archives/Public/w3c-wai-ig/2019JanMar/0086.html
                $1e5dc5e467331cb9$var$halt(event);
                return changeSkinTone(state.activeSkinTone);
            case "Escape":
                $1e5dc5e467331cb9$var$halt(event);
                state.skinTonePickerExpanded = false;
                return focus("skintone-button");
        }
    }
    function onSkinToneOptionsKeyup(event) {
        // this should never happen, but makes me nervous not to have it
        /* istanbul ignore if */ if (!state.skinTonePickerExpanded) return;
        switch(event.key){
            case " ":
                // enter on keydown, space on keyup. this is just how browsers work for buttons
                // https://lists.w3.org/Archives/Public/w3c-wai-ig/2019JanMar/0086.html
                $1e5dc5e467331cb9$var$halt(event);
                return changeSkinTone(state.activeSkinTone);
        }
    }
    async function onSkinToneOptionsFocusOut(event) {
        // On blur outside of the skintone listbox, collapse the skintone picker.
        const { relatedTarget: relatedTarget } = event;
        // The `else` should never happen, but makes me nervous not to have it
        /* istanbul ignore else */ if (!relatedTarget || relatedTarget.id !== "skintone-list") state.skinTonePickerExpanded = false;
    }
    function onSearchInput(event) {
        state.rawSearchText = event.target.value;
    }
    return {
        $set (newState) {
            $1e5dc5e467331cb9$var$assign(state, newState);
        },
        $destroy () {
            abortController.abort();
        }
    };
}
const $1e5dc5e467331cb9$var$DEFAULT_DATA_SOURCE = "https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json";
const $1e5dc5e467331cb9$var$DEFAULT_LOCALE = "en";
var $1e5dc5e467331cb9$var$enI18n = {
    categoriesLabel: "Categories",
    emojiUnsupportedMessage: "Your browser does not support color emoji.",
    favoritesLabel: "Favorites",
    loadingMessage: "Loading\u2026",
    networkErrorMessage: "Could not load emoji.",
    regionLabel: "Emoji picker",
    searchDescription: "When search results are available, press up or down to select and enter to choose.",
    searchLabel: "Search",
    searchResultsLabel: "Search results",
    skinToneDescription: "When expanded, press up or down to select and enter to choose.",
    skinToneLabel: "Choose a skin tone (currently {skinTone})",
    skinTonesLabel: "Skin tones",
    skinTones: [
        "Default",
        "Light",
        "Medium-Light",
        "Medium",
        "Medium-Dark",
        "Dark"
    ],
    categories: {
        custom: "Custom",
        "smileys-emotion": "Smileys and emoticons",
        "people-body": "People and body",
        "animals-nature": "Animals and nature",
        "food-drink": "Food and drink",
        "travel-places": "Travel and places",
        activities: "Activities",
        objects: "Objects",
        symbols: "Symbols",
        flags: "Flags"
    }
};
var $1e5dc5e467331cb9$var$baseStyles = ':host{--emoji-size:1.375rem;--emoji-padding:0.5rem;--category-emoji-size:var(--emoji-size);--category-emoji-padding:var(--emoji-padding);--indicator-height:3px;--input-border-radius:0.5rem;--input-border-size:1px;--input-font-size:1rem;--input-line-height:1.5;--input-padding:0.25rem;--num-columns:8;--outline-size:2px;--border-size:1px;--border-radius:0;--skintone-border-radius:1rem;--category-font-size:1rem;display:flex;width:min-content;height:400px}:host,:host(.light){color-scheme:light;--background:#fff;--border-color:#e0e0e0;--indicator-color:#385ac1;--input-border-color:#999;--input-font-color:#111;--input-placeholder-color:#999;--outline-color:#999;--category-font-color:#111;--button-active-background:#e6e6e6;--button-hover-background:#d9d9d9}:host(.dark){color-scheme:dark;--background:#222;--border-color:#444;--indicator-color:#5373ec;--input-border-color:#ccc;--input-font-color:#efefef;--input-placeholder-color:#ccc;--outline-color:#fff;--category-font-color:#efefef;--button-active-background:#555555;--button-hover-background:#484848}@media (prefers-color-scheme:dark){:host{color-scheme:dark;--background:#222;--border-color:#444;--indicator-color:#5373ec;--input-border-color:#ccc;--input-font-color:#efefef;--input-placeholder-color:#ccc;--outline-color:#fff;--category-font-color:#efefef;--button-active-background:#555555;--button-hover-background:#484848}}:host([hidden]){display:none}button{margin:0;padding:0;border:0;background:0 0;box-shadow:none;-webkit-tap-highlight-color:transparent}button::-moz-focus-inner{border:0}input{padding:0;margin:0;line-height:1.15;font-family:inherit}input[type=search]{-webkit-appearance:none}:focus{outline:var(--outline-color) solid var(--outline-size);outline-offset:calc(-1*var(--outline-size))}:host([data-js-focus-visible]) :focus:not([data-focus-visible-added]){outline:0}:focus:not(:focus-visible){outline:0}.hide-focus{outline:0}*{box-sizing:border-box}.picker{contain:content;display:flex;flex-direction:column;background:var(--background);border:var(--border-size) solid var(--border-color);border-radius:var(--border-radius);width:100%;height:100%;overflow:hidden;--total-emoji-size:calc(var(--emoji-size) + (2 * var(--emoji-padding)));--total-category-emoji-size:calc(var(--category-emoji-size) + (2 * var(--category-emoji-padding)))}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.hidden{opacity:0;pointer-events:none}.abs-pos{position:absolute;left:0;top:0}.gone{display:none!important}.skintone-button-wrapper,.skintone-list{background:var(--background);z-index:3}.skintone-button-wrapper.expanded{z-index:1}.skintone-list{position:absolute;inset-inline-end:0;top:0;z-index:2;overflow:visible;border-bottom:var(--border-size) solid var(--border-color);border-radius:0 0 var(--skintone-border-radius) var(--skintone-border-radius);will-change:transform;transition:transform .2s ease-in-out;transform-origin:center 0}@media (prefers-reduced-motion:reduce){.skintone-list{transition-duration:.001s}}@supports not (inset-inline-end:0){.skintone-list{right:0}}.skintone-list.no-animate{transition:none}.tabpanel{overflow-y:auto;scrollbar-gutter:stable;-webkit-overflow-scrolling:touch;will-change:transform;min-height:0;flex:1;contain:content}.emoji-menu{display:grid;grid-template-columns:repeat(var(--num-columns),var(--total-emoji-size));justify-content:space-around;align-items:flex-start;width:100%}.emoji-menu.visibility-auto{content-visibility:auto;contain-intrinsic-size:calc(var(--num-columns)*var(--total-emoji-size)) calc(var(--num-rows)*var(--total-emoji-size))}.category{padding:var(--emoji-padding);font-size:var(--category-font-size);color:var(--category-font-color)}.emoji,button.emoji{font-size:var(--emoji-size);display:flex;align-items:center;justify-content:center;border-radius:100%;height:var(--total-emoji-size);width:var(--total-emoji-size);line-height:1;overflow:hidden;font-family:var(--emoji-font-family);cursor:pointer}@media (hover:hover) and (pointer:fine){.emoji:hover,button.emoji:hover{background:var(--button-hover-background)}}.emoji.active,.emoji:active,button.emoji.active,button.emoji:active{background:var(--button-active-background)}.onscreen .custom-emoji::after{content:"";width:var(--emoji-size);height:var(--emoji-size);background-repeat:no-repeat;background-position:center center;background-size:contain;background-image:var(--custom-emoji-background)}.nav,.nav-button{align-items:center}.nav{display:grid;justify-content:space-between;contain:content}.nav-button{display:flex;justify-content:center}.nav-emoji{font-size:var(--category-emoji-size);width:var(--total-category-emoji-size);height:var(--total-category-emoji-size)}.indicator-wrapper{display:flex;border-bottom:1px solid var(--border-color)}.indicator{width:calc(100%/var(--num-groups));height:var(--indicator-height);opacity:var(--indicator-opacity);background-color:var(--indicator-color);will-change:transform,opacity;transition:opacity .1s linear,transform .25s ease-in-out}@media (prefers-reduced-motion:reduce){.indicator{will-change:opacity;transition:opacity .1s linear}}.pad-top,input.search{background:var(--background);width:100%}.pad-top{height:var(--emoji-padding);z-index:3}.search-row{display:flex;align-items:center;position:relative;padding-inline-start:var(--emoji-padding);padding-bottom:var(--emoji-padding)}.search-wrapper{flex:1;min-width:0}input.search{padding:var(--input-padding);border-radius:var(--input-border-radius);border:var(--input-border-size) solid var(--input-border-color);color:var(--input-font-color);font-size:var(--input-font-size);line-height:var(--input-line-height)}input.search::placeholder{color:var(--input-placeholder-color)}.favorites{overflow-y:auto;scrollbar-gutter:stable;display:flex;flex-direction:row;border-top:var(--border-size) solid var(--border-color);contain:content}.message{padding:var(--emoji-padding)}';
const $1e5dc5e467331cb9$var$PROPS = [
    "customEmoji",
    "customCategorySorting",
    "database",
    "dataSource",
    "i18n",
    "locale",
    "skinToneEmoji",
    "emojiVersion"
];
// Styles injected ourselves, so we can declare the FONT_FAMILY variable in one place
const $1e5dc5e467331cb9$var$EXTRA_STYLES = `:host{--emoji-font-family:${$1e5dc5e467331cb9$var$FONT_FAMILY}}`;
class $1e5dc5e467331cb9$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(props){
        super();
        this.attachShadow({
            mode: "open"
        });
        const style = document.createElement("style");
        style.textContent = $1e5dc5e467331cb9$var$baseStyles + $1e5dc5e467331cb9$var$EXTRA_STYLES;
        this.shadowRoot.appendChild(style);
        this._ctx = {
            // Set defaults
            locale: $1e5dc5e467331cb9$var$DEFAULT_LOCALE,
            dataSource: $1e5dc5e467331cb9$var$DEFAULT_DATA_SOURCE,
            skinToneEmoji: $1e5dc5e467331cb9$var$DEFAULT_SKIN_TONE_EMOJI,
            customCategorySorting: $1e5dc5e467331cb9$var$DEFAULT_CATEGORY_SORTING,
            customEmoji: null,
            i18n: $1e5dc5e467331cb9$var$enI18n,
            emojiVersion: null,
            ...props
        };
        // Handle properties set before the element was upgraded
        for (const prop of $1e5dc5e467331cb9$var$PROPS)if (prop !== "database" && Object.prototype.hasOwnProperty.call(this, prop)) {
            this._ctx[prop] = this[prop];
            delete this[prop];
        }
        this._dbFlush(); // wait for a flush before creating the db, in case the user calls e.g. a setter or setAttribute
    }
    connectedCallback() {
        // The _cmp may be defined if the component was immediately disconnected and then reconnected. In that case,
        // do nothing (preserve the state)
        if (!this._cmp) this._cmp = $1e5dc5e467331cb9$var$createRoot(this.shadowRoot, this._ctx);
    }
    disconnectedCallback() {
        // Check in a microtask if the element is still connected. If so, treat this as a "move" rather than a disconnect
        // Inspired by Vue: https://vuejs.org/guide/extras/web-components.html#building-custom-elements-with-vue
        $1e5dc5e467331cb9$var$qM(()=>{
            // this._cmp may be defined if connect-disconnect-connect-disconnect occurs synchronously
            if (!this.isConnected && this._cmp) {
                this._cmp.$destroy();
                this._cmp = undefined;
                const { database: database } = this._ctx;
                database.close()// only happens if the database failed to load in the first place, so we don't care
                .catch((err)=>console.error(err));
            }
        });
    }
    static get observedAttributes() {
        return [
            "locale",
            "data-source",
            "skin-tone-emoji",
            "emoji-version"
        ] // complex objects aren't supported, also use kebab-case
        ;
    }
    attributeChangedCallback(attrName, oldValue, newValue) {
        this._set(// convert from kebab-case to camelcase
        // see https://github.com/sveltejs/svelte/issues/3852#issuecomment-665037015
        attrName.replace(/-([a-z])/g, (_, up)=>up.toUpperCase()), // convert string attribute to float if necessary
        attrName === "emoji-version" ? parseFloat(newValue) : newValue);
    }
    _set(prop, newValue) {
        this._ctx[prop] = newValue;
        if (this._cmp) this._cmp.$set({
            [prop]: newValue
        });
        if ([
            "locale",
            "dataSource"
        ].includes(prop)) this._dbFlush();
    }
    _dbCreate() {
        const { locale: locale, dataSource: dataSource, database: database } = this._ctx;
        // only create a new database if we really need to
        if (!database || database.locale !== locale || database.dataSource !== dataSource) this._set("database", new (0, $d1f26ac162b12b4a$export$2e2bcd8739ae039)({
            locale: locale,
            dataSource: dataSource
        }));
    }
    // Update the Database in one microtask if the locale/dataSource change. We do one microtask
    // so we don't create two Databases if e.g. both the locale and the dataSource change
    _dbFlush() {
        $1e5dc5e467331cb9$var$qM(()=>this._dbCreate());
    }
}
const $1e5dc5e467331cb9$var$definitions = {};
for (const prop of $1e5dc5e467331cb9$var$PROPS)$1e5dc5e467331cb9$var$definitions[prop] = {
    get () {
        if (prop === "database") // in rare cases, the microtask may not be flushed yet, so we need to instantiate the DB
        // now if the user is asking for it
        this._dbCreate();
        return this._ctx[prop];
    },
    set (val) {
        if (prop === "database") throw new Error("database is read-only");
        this._set(prop, val);
    }
};
Object.defineProperties($1e5dc5e467331cb9$export$2e2bcd8739ae039.prototype, $1e5dc5e467331cb9$var$definitions);
/* istanbul ignore else */ if (!customElements.get("emoji-picker")) customElements.define("emoji-picker", $1e5dc5e467331cb9$export$2e2bcd8739ae039);





var $dec5faeb65064cfd$var$browserSupportsTextareaTextNodes;
/**
 * @param {HTMLElement} input
 * @return {boolean}
 */ function $dec5faeb65064cfd$var$canManipulateViaTextNodes(input) {
    if (input.nodeName !== "TEXTAREA") return false;
    if (typeof $dec5faeb65064cfd$var$browserSupportsTextareaTextNodes === "undefined") {
        var textarea = document.createElement("textarea");
        textarea.value = 1;
        $dec5faeb65064cfd$var$browserSupportsTextareaTextNodes = !!textarea.firstChild;
    }
    return $dec5faeb65064cfd$var$browserSupportsTextareaTextNodes;
}
/**
 * @param {HTMLTextAreaElement|HTMLInputElement} input
 * @param {string} text
 * @returns {void}
 */ function $dec5faeb65064cfd$var$index(input, text) {
    // Most of the used APIs only work with the field selected
    input.focus(); // IE 8-10
    if (document.selection) {
        var ieRange = document.selection.createRange();
        ieRange.text = text; // Move cursor after the inserted text
        ieRange.collapse(false);
        ieRange.select();
        return;
    } // Webkit + Edge
    var isSuccess = document.execCommand("insertText", false, text);
    if (!isSuccess) {
        var start = input.selectionStart;
        var end = input.selectionEnd; // Firefox (non-standard method)
        if (typeof input.setRangeText === "function") input.setRangeText(text);
        else {
            // To make a change we just need a Range, not a Selection
            var range = document.createRange();
            var textNode = document.createTextNode(text);
            if ($dec5faeb65064cfd$var$canManipulateViaTextNodes(input)) {
                var node = input.firstChild; // If textarea is empty, just insert the text
                if (!node) input.appendChild(textNode);
                else {
                    // Otherwise we need to find a nodes for start and end
                    var offset = 0;
                    var startNode = null;
                    var endNode = null;
                    while(node && (startNode === null || endNode === null)){
                        var nodeLength = node.nodeValue.length; // if start of the selection falls into current node
                        if (start >= offset && start <= offset + nodeLength) range.setStart(startNode = node, start - offset);
                         // if end of the selection falls into current node
                        if (end >= offset && end <= offset + nodeLength) range.setEnd(endNode = node, end - offset);
                        offset += nodeLength;
                        node = node.nextSibling;
                    } // If there is some text selected, remove it as we should replace it
                    if (start !== end) range.deleteContents();
                }
            } // If the node is a textarea and the range doesn't span outside the element
            //
            // Get the commonAncestorContainer of the selected range and test its type
            // If the node is of type `#text` it means that we're still working with text nodes within our textarea element
            // otherwise, if it's of type `#document` for example it means our selection spans outside the textarea.
            if ($dec5faeb65064cfd$var$canManipulateViaTextNodes(input) && range.commonAncestorContainer.nodeName === "#text") // Finally insert a new node. The browser will automatically split start and end nodes into two if necessary
            range.insertNode(textNode);
            else {
                // If the node is not a textarea or the range spans outside a textarea the only way is to replace the whole value
                var value = input.value;
                input.value = value.slice(0, start) + text + value.slice(end);
            }
        } // Correct the cursor position to be at the end of the insertion
        input.setSelectionRange(start + text.length, start + text.length); // Notify any possible listeners of the change
        var e = document.createEvent("UIEvent");
        e.initEvent("input", true, false);
        input.dispatchEvent(e);
    }
}
var $dec5faeb65064cfd$export$2e2bcd8739ae039 = $dec5faeb65064cfd$var$index;


/*!
 * @georapbox/capture-photo-element
 * A custom element that implements the MediaDevices.getUserMedia() method of the MediaDevices interface to capture a photo in the browser.
 *
 * @version 5.0.0
 * @homepage https://github.com/georapbox/capture-photo-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $636b0cf1ed0b9f88$var$c = (r, t, e)=>(Number.isNaN(t) && (t = 0), Number.isNaN(e) && (e = 0), Math.min(Math.max(r, Math.min(t, e)), Math.max(t, e)));
var $636b0cf1ed0b9f88$var$a = "capture-photo", $636b0cf1ed0b9f88$var$d = `
  :host { display: block; box-sizing: border-box; }
  :host *, :host *::before, :host *::after { box-sizing: inherit;}
  :host([hidden]), [hidden], ::slotted([hidden]) { display: none; }
  video { display: block; }
  #output:empty { display: none; }
`, $636b0cf1ed0b9f88$var$u = document.createElement("template");
$636b0cf1ed0b9f88$var$u.innerHTML = `
  <style>${$636b0cf1ed0b9f88$var$d}</style>
  <video part="video" playsinline></video>
  <canvas hidden></canvas>
  <div part="actions-container">
    <slot name="capture-button">
      <button part="capture-button" type="button">
        <slot name="capture-button-content">Capture photo</slot>
      </button>
    </slot>
    <slot name="actions"></slot>
  </div>
  <slot></slot>
  <div part="output-container" id="output"></div>
`;
var $636b0cf1ed0b9f88$export$cc30a98fe3890794 = class r extends HTMLElement {
    #a = {};
    #t = null;
    #n = null;
    #h = null;
    #e = null;
    #r = null;
    #i = null;
    constructor(){
        super(), this.#a = this.getSupportedConstraints(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($636b0cf1ed0b9f88$var$u.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "no-image",
            "pan",
            "tilt",
            "zoom",
            "torch"
        ];
    }
    attributeChangedCallback(t, e, s) {
        if (!this.isConnected) return;
        let i = this.getTrackCapabilities();
        if (t === "no-image" && e !== s && this.#u(), t === "pan" && e !== s && "pan" in this.#a) {
            let o = "pan" in i && i.pan?.min && i.pan?.max ? this.pan >= i.pan.min && this.pan <= i.pan.max : !1;
            typeof this.pan == "number" && o && this.#o("pan", this.pan);
        }
        if (t === "tilt" && e !== s && "tilt" in this.#a) {
            let o = "tilt" in i && i.tilt?.min && i.tilt?.max ? this.tilt >= i.tilt.min && this.tilt <= i.tilt.max : !1;
            typeof this.tilt == "number" && o && this.#o("tilt", this.tilt);
        }
        if (t === "zoom" && e !== s && "zoom" in this.#a) {
            let o = "zoom" in i && i.zoom?.min && i.zoom?.max ? this.zoom >= i.zoom.min && this.zoom <= i.zoom.max : !1;
            typeof this.zoom == "number" && o && this.#o("zoom", this.zoom);
        }
        t === "torch" && e !== s && "torch" in this.#a && this.#o("torch", this.torch);
    }
    async connectedCallback() {
        if (this.#s("autoPlay"), this.#s("noImage"), this.#s("facingMode"), this.#s("cameraResolution"), this.#s("pan"), this.#s("tilt"), this.#s("zoom"), this.#s("torch"), this.#s("calculateFileSize"), this.#n = this.shadowRoot?.querySelector("canvas") || null, this.#h = this.shadowRoot?.getElementById("output") || null, this.#e = this.shadowRoot?.querySelector("video") || null, this.#r = this.shadowRoot?.querySelector('slot[name="capture-button"]') || null, this.#i = this.#m(), this.#e?.addEventListener("loadedmetadata", this.#c), this.#r?.addEventListener("slotchange", this.#d), this.#i?.addEventListener("click", this.#l), !r.isSupported()) return this.dispatchEvent(new CustomEvent(`${$636b0cf1ed0b9f88$var$a}:error`, {
            bubbles: !0,
            composed: !0,
            detail: {
                error: {
                    name: "NotSupportedError",
                    message: "Not supported"
                }
            }
        }));
        this.autoPlay && this.startVideoStream();
    }
    disconnectedCallback() {
        this.stopVideoStream(), this.#i?.removeEventListener("click", this.#l), this.#e?.removeEventListener("loadedmetadata", this.#c), this.#r?.removeEventListener("slotchange", this.#d);
    }
    get autoPlay() {
        return this.hasAttribute("auto-play");
    }
    set autoPlay(t) {
        this.toggleAttribute("auto-play", !!t);
    }
    get noImage() {
        return this.hasAttribute("no-image");
    }
    set noImage(t) {
        this.toggleAttribute("no-image", !!t);
    }
    get facingMode() {
        let t = this.getAttribute("facing-mode");
        return t !== "user" ? "environment" : t;
    }
    set facingMode(t) {
        this.setAttribute("facing-mode", t);
    }
    get cameraResolution() {
        return this.getAttribute("camera-resolution") || "";
    }
    set cameraResolution(t) {
        this.setAttribute("camera-resolution", t);
    }
    get pan() {
        return Number(this.getAttribute("pan")) || 0;
    }
    set pan(t) {
        this.setAttribute("pan", t != null ? t.toString() : t);
    }
    get tilt() {
        return Number(this.getAttribute("tilt")) || 0;
    }
    set tilt(t) {
        this.setAttribute("tilt", t != null ? t.toString() : t);
    }
    get zoom() {
        return Number(this.getAttribute("zoom")) || 1;
    }
    set zoom(t) {
        this.setAttribute("zoom", t != null ? t.toString() : t);
    }
    get torch() {
        return this.hasAttribute("torch");
    }
    set torch(t) {
        this.toggleAttribute("torch", !!t);
    }
    get calculateFileSize() {
        return this.hasAttribute("calculate-file-size");
    }
    set calculateFileSize(t) {
        this.toggleAttribute("calculate-file-size", !!t);
    }
    get loading() {
        return this.hasAttribute("loading");
    }
    #l = (t)=>{
        t.preventDefault(), this.capture();
    };
    #c = (t)=>{
        let e = t.target;
        e.play().then(()=>{
            this.dispatchEvent(new CustomEvent(`${$636b0cf1ed0b9f88$var$a}:video-play`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    video: e
                }
            }));
        }).catch((s)=>{
            this.dispatchEvent(new CustomEvent(`${$636b0cf1ed0b9f88$var$a}:error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: s
                }
            }));
        }).finally(()=>{
            this.removeAttribute("loading");
        });
    };
    #u() {
        this.#h && this.#h.replaceChildren();
    }
    #o(t, e) {
        if (!this.#t) return;
        let [s] = this.#t.getVideoTracks(), i = this.getTrackCapabilities(), o = this.getTrackSettings(), n = t === "pan" || t === "tilt" || t === "zoom" ? $636b0cf1ed0b9f88$var$c(Number(e), i[t]?.min || 1, i[t]?.max || 1) : e;
        t in o && s.applyConstraints({
            advanced: [
                {
                    [t]: n
                }
            ]
        }).catch(()=>{});
    }
    #d = (t)=>{
        t.target?.name === "capture-button" && (this.#i?.removeEventListener("click", this.#l), this.#i = this.#m(), this.#i && (this.#i.addEventListener("click", this.#l), this.#i.nodeName !== "BUTTON" && !this.#i.hasAttribute("role") && this.#i.setAttribute("role", "button")));
    };
    #m() {
        return this.#r && this.#r.assignedElements({
            flatten: !0
        }).find((t)=>t.nodeName === "BUTTON" || t.getAttribute("slot") === "capture-button") || null;
    }
    #s(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let s = e[t];
            delete e[t], e[t] = s;
        }
    }
    async startVideoStream(t) {
        if (!r.isSupported() || this.#t) return;
        this.setAttribute("loading", "");
        let e = {
            video: {
                facingMode: {
                    ideal: this.facingMode
                },
                pan: !0,
                tilt: !0,
                zoom: !0,
                torch: this.torch
            },
            audio: !1
        };
        if (typeof t == "string" && t.trim().length > 0 && (e.video.deviceId = {
            exact: t
        }), typeof this.cameraResolution == "string" && this.cameraResolution.trim().length > 0) {
            let [s = 0, i = 0] = this.cameraResolution.split("x").map((o)=>Number(o));
            s > 0 && i > 0 && (e.video.width = s, e.video.height = i);
        }
        try {
            this.#t = await navigator.mediaDevices.getUserMedia(e), this.#e && (this.#e.srcObject = this.#t), this.#o("pan", this.pan), this.#o("tilt", this.tilt), this.#o("zoom", this.zoom);
        } catch (s) {
            this.dispatchEvent(new CustomEvent(`${$636b0cf1ed0b9f88$var$a}:error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: s
                }
            }));
        } finally{
            this.removeAttribute("loading");
        }
    }
    restartVideoStream(t) {
        this.#t && this.#e && this.stopVideoStream(), this.startVideoStream(t);
    }
    stopVideoStream() {
        if (!this.#e || !this.#t) return;
        let [t] = this.#t.getVideoTracks();
        t?.stop(), this.#e.srcObject = null, this.#t = null;
    }
    async capture() {
        if (!(this.loading || !this.#n || !this.#e)) try {
            let t = this.#n.getContext("2d"), e = this.#e.videoWidth, s = this.#e.videoHeight;
            this.#n.width = e, this.#n.height = s, t?.drawImage(this.#e, 0, 0, e, s);
            let i = this.#n.toDataURL("image/png");
            if (typeof i == "string" && i.includes("data:image")) {
                if (!this.noImage) {
                    let n = new Image;
                    n.src = i, n.width = e, n.height = s, n.alt = "Captured photo", n.setAttribute("part", "output-image"), this.#u(), this.#h?.appendChild(n);
                }
                let o = {
                    dataURI: i,
                    width: e,
                    height: s
                };
                if (this.calculateFileSize) try {
                    let l = (await (await fetch(i)).blob()).size;
                    l && (o.size = l);
                } catch  {}
                this.dispatchEvent(new CustomEvent(`${$636b0cf1ed0b9f88$var$a}:success`, {
                    bubbles: !0,
                    composed: !0,
                    detail: o
                }));
            }
        } catch (t) {
            this.dispatchEvent(new CustomEvent(`${$636b0cf1ed0b9f88$var$a}:error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    getSupportedConstraints() {
        return r.isSupported() ? navigator.mediaDevices.getSupportedConstraints() || {} : {};
    }
    getTrackCapabilities() {
        if (!this.#t) return {};
        let [t] = this.#t.getVideoTracks();
        return t && typeof t.getCapabilities == "function" ? t.getCapabilities() || {} : {};
    }
    getTrackSettings() {
        if (!this.#t) return {};
        let [t] = this.#t.getVideoTracks();
        return t && typeof t.getSettings == "function" ? t.getSettings() || {} : {};
    }
    static async getVideoInputDevices() {
        return !navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices ? [] : (await navigator.mediaDevices.enumerateDevices() || []).filter((e)=>e.kind === "videoinput" && !!e.deviceId);
    }
    static isSupported() {
        return !!navigator.mediaDevices?.getUserMedia;
    }
    static defineCustomElement(t = $636b0cf1ed0b9f88$var$a) {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, r);
    }
};
$636b0cf1ed0b9f88$export$cc30a98fe3890794.defineCustomElement();


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $94933cc6427541bd$export$c37129e465f64ef0(a) {
    return a !== null && typeof a == "object" ? "share" in navigator && "canShare" in navigator && navigator.canShare(a) : "share" in navigator;
}


/*!
 * @georapbox/theme-toggle-element
 * A custom element that allows you to toggle between dark and light theme.
 *
 * @version 4.0.2
 * @homepage https://github.com/georapbox/theme-toggle-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $96c18cab0f87b248$var$n = "theme-toggle/theme-preference", $96c18cab0f87b248$var$r = "data-theme", $96c18cab0f87b248$var$a = document.createElement("template"), $96c18cab0f87b248$var$h = `
  :host {
    display: inline-block;
    box-sizing: border-box;
  }

  :host *,
  :host *:after,
  :host *:before {
    box-sizing: inherit;
  }

  .hidden {
    display: none !important;
  }

  .button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 0.375rem;
    border: none;
    background-color: transparent;
    color: inherit;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
  }

  .icon--hidden {
    display: none !important;
  }

  .label--hidden {
    display: inline !important;
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  .icon__svg {
    min-width: 1.5em;
    width: 1.5em;
    height: 1.5em;
  }

  .system-path {
    transform: scale(0.4) translateY(-4px);
    transform-origin: center;
  }
`;
$96c18cab0f87b248$var$a.innerHTML = `
  <style>${$96c18cab0f87b248$var$h}</style>

  <button type="button" part="base" id="theme-toggle" class="button">
    <slot name="light">
      <slot name="icon-light" part="icon icon-light" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="icon__svg" aria-hidden="true">
          <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"></path>
        </svg>
      </slot>
      <slot name="label-light" part="label label-light" class="label">Light theme</slot>
    </slot>

    <slot name="dark">
      <slot name="icon-dark" part="icon icon-dark" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="icon__svg" aria-hidden="true">
          <path d="M9.5 2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"></path>
        </svg>
      </slot>
      <slot name="label-dark" part="label label-dark" class="label">Dark theme</slot>
    </slot>

    <slot name="system">
      <slot name="icon-system" part="icon icon-system" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="icon__svg" aria-hidden="true">
          <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"></path>
          <path class="system-path system-path--light" d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"></path>
          <path class="system-path system-path--dark" d="M9.5 2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"></path>
        </svg>
      </slot>
      <slot name="label-system" part="label label-system" class="label">System theme</slot>
    </slot>
  </button>
`;
var $96c18cab0f87b248$export$173e0a822059eddc = class l extends HTMLElement {
    #i = [
        "light",
        "dark",
        "system"
    ];
    #t = "system";
    #s = 0;
    #e = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($96c18cab0f87b248$var$a.content.cloneNode(!0)), this.#e = this.shadowRoot?.getElementById("theme-toggle") || null;
    }
    static get observedAttributes() {
        return [
            "storage-key",
            "no-icon",
            "no-label"
        ];
    }
    attributeChangedCallback(t, e, s) {
        t === "storage-key" && e !== s && (this.#t = this.#a(), this.#s = this.#i.indexOf(this.#t) || 0, this.#o()), t === "no-icon" && e !== s && this.#e && this.#e.querySelectorAll('slot[name^="icon"]').forEach((o)=>{
            o.classList.toggle("icon--hidden", this.noIcon);
        }), t === "no-label" && e !== s && this.#e && this.#e.querySelectorAll('slot[name^="label"]').forEach((o)=>{
            o.classList.toggle("label--hidden", this.noLabel);
        });
    }
    get noStorage() {
        return this.hasAttribute("no-storage");
    }
    set noStorage(t) {
        t ? this.setAttribute("no-storage", "") : this.removeAttribute("no-storage");
    }
    get storageKey() {
        return this.getAttribute("storage-key");
    }
    set storageKey(t) {
        t != null && this.setAttribute("storage-key", t);
    }
    get noIcon() {
        return this.hasAttribute("no-icon");
    }
    set noIcon(t) {
        t ? this.setAttribute("no-icon", "") : this.removeAttribute("no-icon");
    }
    get noLabel() {
        return this.hasAttribute("no-label");
    }
    set noLabel(t) {
        t ? this.setAttribute("no-label", "") : this.removeAttribute("no-label");
    }
    connectedCallback() {
        this.#n("noStorage"), this.#n("storageKey"), this.#n("noIcon"), this.#n("noLabel"), this.#t = this.#a(), this.#s = this.#i.indexOf(this.#t) || 0, this.#o(), this.#e?.addEventListener("click", this.#l), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", this.#r);
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("click", this.#l), window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", this.#r);
    }
    #a() {
        if (this.noStorage) return "system";
        let t = "";
        try {
            t = window.localStorage.getItem(this.storageKey || $96c18cab0f87b248$var$n) || "";
        } catch  {}
        return t === "light" || t === "dark" || t === "system" ? t : "system";
    }
    #h() {
        if (!this.noStorage) try {
            window.localStorage.setItem(this.storageKey || $96c18cab0f87b248$var$n, this.#t);
        } catch  {}
    }
    #o() {
        if (this.#e?.querySelectorAll('slot[name="light"], slot[name="dark"], slot[name="system"]').forEach((t)=>{
            t.classList.toggle("hidden", !t.getAttribute("name")?.startsWith(this.#t));
        }), document.documentElement.setAttribute($96c18cab0f87b248$var$r, this.#t), this.#t === "system") {
            let t = window.matchMedia("(prefers-color-scheme: dark)").matches;
            this.#e?.querySelectorAll(".system-path").forEach((e)=>{
                e.classList.toggle("hidden", t ? e.classList.contains("system-path--light") : e.classList.contains("system-path--dark"));
            });
        }
    }
    #c() {
        return this.#s = (this.#s + 1) % this.#i.length, this.#i[this.#s];
    }
    #l = ()=>{
        this.#t = this.#c(), this.#h(), this.#o(), this.dispatchEvent(new CustomEvent("tt-theme-change", {
            bubbles: !0,
            composed: !0,
            detail: {
                theme: this.#t
            }
        }));
    };
    #r = ()=>{
        this.#o();
    };
    #n(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let s = e[t];
            delete e[t], e[t] = s;
        }
    }
    static defineCustomElement(t = "theme-toggle") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, l);
    }
};
$96c18cab0f87b248$export$173e0a822059eddc.defineCustomElement();


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $4f74a8126e204146$var$h = `
  :host {
    display: inline-block;
  }
`, $4f74a8126e204146$var$r = document.createElement("template");
$4f74a8126e204146$var$r.innerHTML = `
  <style>${$4f74a8126e204146$var$h}</style>
  <slot name="button"><button type="button" part="button"><slot name="button-content">Share</slot></button></slot>
`;
var $4f74a8126e204146$export$30b344bef3e55b67 = class a extends HTMLElement {
    #e;
    #t;
    #r = [];
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($4f74a8126e204146$var$r.content.cloneNode(!0)), this.#e = this.shadowRoot?.querySelector('slot[name="button"]') || null, this.#t = this.#h();
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(t, e, i) {
        t === "disabled" && e !== i && this.#t && (this.#t.toggleAttribute("disabled", this.disabled), this.#t.setAttribute("aria-disabled", this.disabled.toString()), this.#t.part && this.#t.part.contains("button") && this.#t.part.toggle("button--disabled", this.disabled));
    }
    connectedCallback() {
        this.#s("shareUrl"), this.#s("shareTitle"), this.#s("shareText"), this.#s("shareFiles"), this.#s("disabled"), this.#e?.addEventListener("slotchange", this.#a), this.#t?.addEventListener("click", this.#i);
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("slotchange", this.#a), this.#t?.removeEventListener("click", this.#i);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get shareUrl() {
        return this.getAttribute("share-url") || "";
    }
    set shareUrl(t) {
        this.setAttribute("share-url", t);
    }
    get shareTitle() {
        return this.getAttribute("share-title") || "";
    }
    set shareTitle(t) {
        this.setAttribute("share-title", t);
    }
    get shareText() {
        return this.getAttribute("share-text") || "";
    }
    set shareText(t) {
        this.setAttribute("share-text", t);
    }
    get shareFiles() {
        return this.#r;
    }
    set shareFiles(t) {
        Array.isArray(t) && t.length > 0 && (this.#r = t);
    }
    async share() {
        if (!this.disabled) try {
            let t = {};
            this.shareUrl && (t.url = this.shareUrl), this.shareTitle && (t.title = this.shareTitle), this.shareText && (t.text = this.shareText), Array.isArray(this.shareFiles) && this.shareFiles.length > 0 && navigator.canShare && navigator.canShare({
                files: this.shareFiles
            }) && (t.files = this.shareFiles), await navigator.share(t), this.dispatchEvent(new CustomEvent("web-share:success", {
                bubbles: !0,
                composed: !0,
                detail: {
                    shareData: t
                }
            }));
        } catch (t) {
            if (t instanceof Error && t.name === "AbortError") {
                this.dispatchEvent(new CustomEvent("web-share:abort", {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: t
                    }
                }));
                return;
            }
            this.dispatchEvent(new CustomEvent("web-share:error", {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    #i = (t)=>{
        t.preventDefault(), !this.disabled && this.share();
    };
    #a = (t)=>{
        t.target && t.target.name === "button" && (this.#t?.removeEventListener("click", this.#i), this.#t = this.#h(), this.#t && (this.#t.addEventListener("click", this.#i), this.#t.nodeName !== "BUTTON" && !this.#t.hasAttribute("role") && this.#t.setAttribute("role", "button")));
    };
    #h() {
        return this.#e && this.#e.assignedElements({
            flatten: !0
        }).find((t)=>t.nodeName === "BUTTON" || t.getAttribute("slot") === "button") || null;
    }
    #s(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let i = e[t];
            delete e[t], e[t] = i;
        }
    }
    static defineCustomElement(t = "web-share") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$4f74a8126e204146$export$30b344bef3e55b67.defineCustomElement();


/*!
 * @georapbox/modal-element
 * A custom element to create a modal, using the native dialog element under the hood.
 *
 * @version 1.8.0
 * @homepage https://github.com/georapbox/modal-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $4da30046ce6d9325$var$n = document.createElement("template"), $4da30046ce6d9325$var$r = `
  :host {
    --me-width: 32rem;
    --me-height: fit-content;
    --me-border-color: initial;
    --me-border-style: solid;
    --me-border-width: initial;
    --me-border-radius: 0;
    --me-box-shadow: none;
    --me-background-color: canvas;
    --me-color: canvastext;

    --me-header-spacing: 1rem;
    --me-footer-spacing: 1rem;
    --me-header-background-color: transparent;
    --me-header-color: initial;

    --me-body-spacing: 1rem;
    --me-body-background-color: transparent;
    --me-body-color: initial;
    --me-footer-background-color: transparent;
    --me-footer-color: initial;

    --me-close-padding: 0.4375rem;
    --me-close-border: none;
    --me-close-border-radius: 0;
    --me-close-background-color: transparent;
    --me-close-color: inherit;
    --me-close-font-size: 1rem;

    --me-backdrop-background: rgba(0, 0, 0, 0.5);
    --me-backdrop-filter: none;

    display: contents;
    box-sizing: border-box;
  }

  :host *,
  :host *:after,
  :host *:before {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  /* Dialog */
  .dialog {
    --dialog-placement-margin: calc((2em + 6px) / 2);

    width: var(--me-width);
    height: var(--me-height);
    padding: 0;
    border-color: var(--me-border-color);
    border-style: var(--me-border-style);
    border-width: var(--me-border-width);
    border-radius: var(--me-border-radius);
    box-shadow: var(--me-box-shadow);
    background-color: var(--me-background-color);
    color: var(--me-color);
  }

  .dialog[open] {
    display: flex;
  }

  :host([fullscreen]) .dialog {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
  }

  .dialog::backdrop {
    background: var(--me-backdrop-background, rgba(0, 0, 0, 0.5));
    backdrop-filter: var(--me-backdrop-filter, none);
    opacity: 0;
  }

  .dialog[open]::backdrop {
    opacity: 1;
  }

  /* Dialog placement */
  :host(:not([fullscreen])[placement="top-start"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-center"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-end"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center-start"]) .dialog {
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center"]) .dialog {
    margin: auto;
  }

  :host(:not([fullscreen])[placement="center-end"]) .dialog {
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-start"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-center"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-end"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  /* Dialog animations */
  @media (prefers-reduced-motion: no-preference) {
    .dialog:not(.dialog--no-animations),
    .dialog:not(.dialog--no-animations)::backdrop {
      transition: transform 0.3s, opacity 0.3s, display 0.3s allow-discrete, overlay 0.3s allow-discrete;
    }

    /* 1. IS-OPEN STATE */
    .dialog[open] {
      transform: scale(1);
      opacity: 1;
    }

    /* 2. EXIT STATE */
    .dialog {
      transform: scale(0.95);
      opacity: 0;
    }

    /* 0. BEFORE-OPEN STATE */
    @starting-style {
      .dialog[open] {
        transform: scale(0.95);
        opacity: 0;
      }

      .dialog[open]::backdrop {
        opacity: 0;
      }
    }

    .dialog--pulse:not(.dialog--no-animations) {
      animation-name: pulse;
      animation-duration: 300ms;
      animation-timing-function: cubic-bezier(0.2, 0, 0.38, 0.9);
    }

    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.02); }
      100% { transform: scale(1); }
    }
  }

  /* Dialog panel, header, body, footer */
  .dialog__panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
  }

  .dialog__header {
    display: flex;
    align-items: center;
    padding: var(--me-header-spacing);
    column-gap: 0.5rem;
    background-color: var(--me-header-background-color);
    color: var(--me-header-color);
  }

  :host([no-close-button]) .dialog__header {
    column-gap: 0;
  }

  .dialog__title {
    display: block;
    flex: 1 1 auto;
    padding: 0;
    margin: 0;
  }

  .dialog__body {
    display: block;
    flex: 1 1 auto;
    padding: var(--me-body-spacing);
    overflow: auto;
    background-color: var(--me-body-background-color);
    color: var(--me-body-color);
    overscroll-behavior: contain;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: end;
    padding: var(--me-footer-spacing);
    background-color: var(--me-footer-background-color);
    color: var(--me-footer-color);
  }

  .dialog__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--me-close-padding);
    border: var(--me-close-border);
    border-radius: var(--me-close-border-radius);
    background-color: var(--me-close-background-color);
    color: var(--me-close-color);
    font-size: var(--me-close-font-size);
  }

  .dialog__close:not(:disabled) {
    cursor: pointer;
  }

  .dialog__close:disabled {
    cursor: not-allowed;
  }
`;
$4da30046ce6d9325$var$n.innerHTML = `
  <style>${$4da30046ce6d9325$var$r}</style>

  <dialog part="base" class="dialog">
    <div part="panel" class="dialog__panel" aria-labelledby="title">
      <header part="header" class="dialog__header">
        <slot name="header" part="title" class="dialog__title" id="title"></slot>

        <form method="dialog">
          <button type="submit" part="close" class="dialog__close" aria-label="Close">
            <slot name="close">
              <svg part="close-icon" xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </slot>
          </button>
        </form>
      </header>

      <slot part="body" class="dialog__body"></slot>

      <footer part="footer" class="dialog__footer" hidden>
        <slot name="footer"></slot>
      </footer>
    </div>
  </dialog>
`;
var $4da30046ce6d9325$export$32589115725b904b = class s extends HTMLElement {
    #e = null;
    #i = null;
    #a = null;
    #o = void 0;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($4da30046ce6d9325$var$n.content.cloneNode(!0)), this.shadowRoot && (this.#e = this.shadowRoot.querySelector("dialog"), this.#i = this.shadowRoot.querySelector('slot[name="footer"]'), this.#a = this.shadowRoot.querySelector('slot[name="close"]'));
    }
    static get observedAttributes() {
        return [
            "open",
            "no-header",
            "no-animations",
            "no-close-button",
            "close-label"
        ];
    }
    attributeChangedCallback(e, t, i) {
        if (this.#e !== null) {
            if (e === "open" && t !== i && (this.open ? (this.#e.showModal(), this.dispatchEvent(new CustomEvent("me-open", {
                bubbles: !0,
                composed: !0,
                detail: {
                    element: this
                }
            })), document.body && !this.preserveOverflow && (document.body.style.overflow = "hidden")) : this.#e.close()), e === "no-header" && t !== i) {
                let o = this.#e.querySelector(".dialog__header");
                o !== null && (o.hidden = this.noHeader);
            }
            if (e === "no-animations" && t !== i && this.#e.classList.toggle("dialog--no-animations", this.noAnimations), e === "no-close-button" && t !== i) {
                let o = this.#e.querySelector(".dialog__close");
                o !== null && (o.hidden = this.noCloseButton);
            }
            e === "close-label" && t !== i && this.#r();
        }
    }
    connectedCallback() {
        this.#t("open"), this.#t("staticBackdrop"), this.#t("noHeader"), this.#t("noAnimations"), this.#t("noCloseButton"), this.#t("fullscreen"), this.#t("preserveOverflow"), this.#t("placement"), this.#t("closeLabel"), this.#e?.addEventListener("click", this.#h), this.#e?.addEventListener("close", this.#l), this.#e?.addEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.addEventListener("submit", this.#c), this.#i?.addEventListener("slotchange", this.#m), this.#a?.addEventListener("slotchange", this.#g);
    }
    disconnectedCallback() {
        this.#o && clearTimeout(this.#o), this.#e?.addEventListener("click", this.#h), this.#e?.removeEventListener("close", this.#l), this.#e?.removeEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.removeEventListener("submit", this.#c), this.#i?.removeEventListener("slotchange", this.#m), this.#a?.removeEventListener("slotchange", this.#g);
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(e) {
        this.toggleAttribute("open", !!e);
    }
    get staticBackdrop() {
        return this.hasAttribute("static-backdrop");
    }
    set staticBackdrop(e) {
        this.toggleAttribute("static-backdrop", !!e);
    }
    get noHeader() {
        return this.hasAttribute("no-header");
    }
    set noHeader(e) {
        this.toggleAttribute("no-header", !!e);
    }
    get noAnimations() {
        return this.hasAttribute("no-animations");
    }
    set noAnimations(e) {
        this.toggleAttribute("no-animations", !!e);
    }
    get noCloseButton() {
        return this.hasAttribute("no-close-button");
    }
    set noCloseButton(e) {
        this.toggleAttribute("no-close-button", !!e);
    }
    get fullscreen() {
        return this.hasAttribute("fullscreen");
    }
    set fullscreen(e) {
        this.toggleAttribute("fullscreen", !!e);
    }
    get preserveOverflow() {
        return this.hasAttribute("preserve-overflow");
    }
    set preserveOverflow(e) {
        this.toggleAttribute("preserve-overflow", !!e);
    }
    get placement() {
        return this.getAttribute("placement") || "center";
    }
    set placement(e) {
        this.setAttribute("placement", e != null ? e.toString() : e);
    }
    get closeLabel() {
        return this.getAttribute("close-label") || "Close";
    }
    set closeLabel(e) {
        this.setAttribute("close-label", e != null ? e.toString() : e);
    }
    #r() {
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__close");
        if (e === null) return;
        (this.#a?.assignedElements() || [])?.some((o)=>o.textContent?.replace(/\s/g, "") !== "") ? e.removeAttribute("aria-label") : e.setAttribute("aria-label", this.closeLabel);
    }
    #n() {
        this.#o || (this.#e?.classList.add("dialog--pulse"), this.#o = setTimeout(()=>{
            this.#e?.classList.remove("dialog--pulse"), clearTimeout(this.#o), this.#o = void 0;
        }, 300));
    }
    #l = ()=>{
        this.open = !1, this.dispatchEvent(new CustomEvent("me-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                element: this
            }
        })), document.body && !this.preserveOverflow && (document.body.style.overflow = "");
    };
    #d = (e)=>{
        let t = this.#s("escape-key");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), !this.noAnimations && this.#n());
    };
    #c = (e)=>{
        let t = this.#s("close-button");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), !this.noAnimations && this.#n());
    };
    #h = (e)=>{
        let t = e.target, i = e.currentTarget;
        if (t === i) {
            let o = this.#s("backdrop-click");
            this.dispatchEvent(o), o.defaultPrevented || this.staticBackdrop ? !this.noAnimations && this.#n() : this.hide();
        }
        if (t instanceof HTMLElement && t.closest("[data-me-close]") !== null) {
            let o = this.#s("external-invoker");
            this.dispatchEvent(o), o.defaultPrevented ? !this.noAnimations && this.#n() : this.hide();
        }
    };
    #m = ()=>{
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__footer");
        if (e === null) return;
        let t = this.#i?.assignedNodes(), i = t ? t.length > 0 : !1;
        e.hidden = !i;
    };
    #g = ()=>{
        this.#r();
    };
    #s(e) {
        return new CustomEvent("me-request-close", {
            bubbles: !0,
            composed: !0,
            cancelable: !0,
            detail: {
                reason: e,
                element: this
            }
        });
    }
    #t(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    show() {
        this.open || (this.open = !0);
    }
    hide() {
        this.open && (this.open = !1);
    }
    static defineCustomElement(e = "modal-element") {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, s);
    }
};
$4da30046ce6d9325$export$32589115725b904b.defineCustomElement();


/*!
 * @georapbox/files-dropzone-element
 * A custom element that creates a drag and drop zone for files
 *
 * @version 2.0.1
 * @homepage https://github.com/georapbox/files-dropzone-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $7aad62ebc3d6fae8$var$u(o, e = "") {
    if (!e) return !0;
    let t = [
        ...new Set(e.split(",").map((r)=>r.trim()).filter(Boolean))
    ], i = o.type, s = i.replace(/\/.*$/, "");
    for (let r of t)if (r.charAt(0) === ".") {
        if (o.name.toLowerCase().indexOf(r.toLowerCase(), o.name.length - r.length) !== -1) return !0;
    } else if (/\/\*$/.test(r)) {
        if (s === r.replace(/\/.*$/, "")) return !0;
    } else if (i === r) return !0;
    return !1;
}
var $7aad62ebc3d6fae8$var$x = new Map([
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "jxl",
        "image/jxl"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "markdown",
        "text/markdown"
    ],
    [
        "md",
        "text/markdown"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]), $7aad62ebc3d6fae8$var$b = [
    ".DS_Store",
    "Thumbs.db"
], $7aad62ebc3d6fae8$var$y = (o)=>{
    let { name: e } = o;
    if (e && e.lastIndexOf(".") !== -1 && !o.type) {
        let i = (e.split(".").pop() || "").toLowerCase(), s = $7aad62ebc3d6fae8$var$x.get(i);
        s && Object.defineProperty(o, "type", {
            value: s,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return o;
}, $7aad62ebc3d6fae8$var$g = (o, e)=>{
    let t = $7aad62ebc3d6fae8$var$y(o);
    if (typeof t.path != "string") {
        let { webkitRelativePath: i } = o;
        Object.defineProperty(t, "path", {
            value: typeof e == "string" ? e : i || o.name,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return t;
}, $7aad62ebc3d6fae8$var$m = async (o)=>await new Promise((e, t)=>{
        o.readEntries(e, t);
    }), $7aad62ebc3d6fae8$var$w = async (o)=>{
    let e = [], t = await $7aad62ebc3d6fae8$var$m(o);
    for(; t.length > 0;)e.push(...t), t = await $7aad62ebc3d6fae8$var$m(o);
    return e;
}, $7aad62ebc3d6fae8$var$E = (o)=>new Promise((e, t)=>{
        o.file((i)=>e($7aad62ebc3d6fae8$var$g(i, o.fullPath)), t);
    }), $7aad62ebc3d6fae8$var$F = async (o)=>{
    let e = [], t = [];
    for (let i of o){
        if (i.kind !== "file") continue;
        let s = i.getAsEntry ? i.getAsEntry() : i.webkitGetAsEntry();
        t.push(s);
    }
    for(; t.length > 0;){
        let i = t.shift();
        if (i) {
            if (i.isFile) {
                let s = await $7aad62ebc3d6fae8$var$E(i);
                $7aad62ebc3d6fae8$var$b.indexOf(s.name) === -1 && e.push(s);
            } else i.isDirectory && t.push(...await $7aad62ebc3d6fae8$var$w(i.createReader()));
        } else continue;
    }
    return e;
}, $7aad62ebc3d6fae8$var$f = async (o)=>{
    let e = [];
    for (let t of o)$7aad62ebc3d6fae8$var$b.indexOf(t.name) === -1 && e.push($7aad62ebc3d6fae8$var$g(t));
    return e;
}, $7aad62ebc3d6fae8$var$l = async (o)=>o.dataTransfer ? o.dataTransfer.items ? await $7aad62ebc3d6fae8$var$F(o.dataTransfer.items) : await $7aad62ebc3d6fae8$var$f(o.dataTransfer.files) : await $7aad62ebc3d6fae8$var$f(o.target.files);
var $7aad62ebc3d6fae8$var$n = "files-dropzone", $7aad62ebc3d6fae8$var$v = "TOO_MANY_FILES", $7aad62ebc3d6fae8$var$L = "FILE_TOO_LARGE", $7aad62ebc3d6fae8$var$k = "FILE_TOO_SMALL", $7aad62ebc3d6fae8$var$A = "INVALID_MIME_TYPE", $7aad62ebc3d6fae8$var$z = document.createElement("template"), $7aad62ebc3d6fae8$var$S = `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host {
    --dropzone-border-width: 2px;
    --dropzone-border-style: dashed;
    --dropzone-border-radius: 0.25rem;
    --dropzone-border-color: #6c757d;
    --dropzone-border-color-dragover: #0d6efd;
    --dropzone-border-color-hover: var(--dropzone-border-color-dragover);
    --dropzone-background-color: #ffffff;
    --dropzone-background-color-dragover: #f4f4f5;
    --dropzone-background-color-hover: var(--dropzone-background-color-dragover);
    --dropzone-body-color: #3f3f46;
    --dropzone-body-color-dragover: var(--dropzone-body-color);
    --dropzone-body-color-hover: var(--dropzone-body-color-dragover);
    --dropzone-focus-shadow-rgb: 49,132,253;
    --dropzone-focus-box-shadow: 0 0 0 0.25rem rgba(var(--dropzone-focus-shadow-rgb), 0.5);
    --transition-duration: 0.2s; /* for backwards compatibility */
    --dropzone-transition-duration: var(--transition-duration);

    display: block;
  }

  :host(:not([no-style])) .dropzone {
    border: var(--dropzone-border-width) var(--dropzone-border-style) var(--dropzone-border-color);
    border-radius: var(--dropzone-border-radius);
    padding: 3rem 1rem;
    overflow: hidden;
    background-color: var(--dropzone-background-color);
    color: var(--dropzone-body-color);
    text-align: center;
    cursor: pointer;
    transition: border var(--dropzone-transition-duration) ease-in-out, background-color var(--dropzone-transition-duration) ease-in-out, color var(--dropzone-transition-duration) ease-in-out, box-shadow var(--dropzone-transition-duration) ease-in-out;
  }

  :host(:not([no-style])[disabled]) .dropzone {
    opacity: 0.8;
    cursor: not-allowed;
    user-select: none;
  }

  :host(:not([no-style]):not([disabled])) .dropzone--dragover {
    border-color: var(--dropzone-border-color-dragover);
    background-color: var(--dropzone-background-color-dragover);
    color: var(--dropzone-body-color-dragover);
  }

  :host(:not([no-style]):not([disabled])) .dropzone:focus-visible {
    outline: none;
    box-shadow: var(--dropzone-focus-box-shadow);
  }

  @media (hover: hover) {
    :host(:not([no-style]):not([disabled])) .dropzone:not(.dropzone--dragover):hover {
      border-color: var(--dropzone-border-color-hover);
      background-color: var(--dropzone-background-color-hover);
      color: var(--dropzone-body-color-hover);
    }
  }
`;
$7aad62ebc3d6fae8$var$z.innerHTML = `
  <style>
    ${$7aad62ebc3d6fae8$var$S}
  </style>

  <input type="file" id="file-input" hidden>

  <div part="dropzone" class="dropzone" id="dropzone" tabindex="0" role="button" aria-disabled="false">
    <slot>Drag 'n' drop files here, or click to select files</slot>
  </div>
`;
var $7aad62ebc3d6fae8$export$6ccd1735166caad9 = class o extends HTMLElement {
    #t = null;
    #e = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($7aad62ebc3d6fae8$var$z.content.cloneNode(!0)), this.shadowRoot && (this.#t = this.shadowRoot.getElementById("file-input"), this.#e = this.shadowRoot.getElementById("dropzone"));
    }
    static get observedAttributes() {
        return [
            "accept",
            "disabled",
            "multiple"
        ];
    }
    attributeChangedCallback(e, t, i) {
        e === "accept" && t !== i && this.#t && (this.#t.accept = this.accept), e === "disabled" && t !== i && this.#t && (this.#t.disabled = this.disabled, this.disabled ? (this.#e?.removeAttribute("tabindex"), this.#e?.setAttribute("aria-disabled", "true")) : (this.#e?.setAttribute("tabindex", "0"), this.#e?.setAttribute("aria-disabled", "false"))), e === "multiple" && t !== i && this.#t && (this.#t.multiple = this.multiple);
    }
    connectedCallback() {
        this.#o("accept"), this.#o("disabled"), this.#o("maxFiles"), this.#o("maxSize"), this.#o("minSize"), this.#o("multiple"), this.#o("autoFocus"), this.#o("noStyle"), this.#t?.addEventListener("change", this.#i), this.#e?.addEventListener("dragenter", this.#r), this.#e?.addEventListener("dragover", this.#s), this.#e?.addEventListener("dragleave", this.#n), this.#e?.addEventListener("drop", this.#a), this.#e?.addEventListener("click", this.#d), this.#e?.addEventListener("keyup", this.#l), this.autoFocus && this.#e?.focus();
    }
    disconnectedCallback() {
        this.#t?.removeEventListener("change", this.#i), this.#e?.removeEventListener("dragenter", this.#r), this.#e?.removeEventListener("dragover", this.#s), this.#e?.removeEventListener("dragleave", this.#n), this.#e?.removeEventListener("drop", this.#a), this.#e?.removeEventListener("click", this.#d), this.#e?.removeEventListener("keyup", this.#l);
    }
    get accept() {
        return this.getAttribute("accept") || "";
    }
    set accept(e) {
        this.setAttribute("accept", e != null ? e.toString() : e);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(e) {
        this.toggleAttribute("disabled", !!e);
    }
    get maxFiles() {
        let e = Number(this.getAttribute("max-files")) || 0;
        return e <= 0 ? 1 / 0 : Math.floor(Math.abs(e));
    }
    set maxFiles(e) {
        this.setAttribute("max-files", e != null ? e.toString() : e);
    }
    get maxSize() {
        let e = this.getAttribute("max-size");
        if (e === null) return 1 / 0;
        let t = Number(e);
        return Number.isNaN(t) ? 1 / 0 : t;
    }
    set maxSize(e) {
        this.setAttribute("max-size", e != null ? e.toString() : e);
    }
    get minSize() {
        let e = this.getAttribute("min-size");
        if (e === null) return 0;
        let t = Number(e);
        return Number.isNaN(t) ? 0 : t;
    }
    set minSize(e) {
        this.setAttribute("min-size", e != null ? e.toString() : e);
    }
    get multiple() {
        return this.hasAttribute("multiple");
    }
    set multiple(e) {
        this.toggleAttribute("multiple", !!e);
    }
    get autoFocus() {
        return this.hasAttribute("auto-focus");
    }
    set autoFocus(e) {
        this.toggleAttribute("auto-focus", !!e);
    }
    get noStyle() {
        return this.hasAttribute("no-style");
    }
    set noStyle(e) {
        this.toggleAttribute("no-style", !!e);
    }
    #i = async (e)=>{
        try {
            this.#c(await $7aad62ebc3d6fae8$var$l(e));
        } catch (t) {
            this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$n}-error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    };
    #r = ()=>{
        this.disabled || this.dispatchEvent(new Event(`${$7aad62ebc3d6fae8$var$n}-dragenter`, {
            bubbles: !0,
            composed: !0
        }));
    };
    #s = (e)=>{
        if (e.preventDefault(), this.disabled) {
            e.dataTransfer.dropEffect = "none";
            return;
        }
        e.dataTransfer.dropEffect = "copy", this.#e && (this.#e.classList.add("dropzone--dragover"), this.#e.part.add("dropzone--dragover")), this.dispatchEvent(new Event(`${$7aad62ebc3d6fae8$var$n}-dragover`, {
            bubbles: !0,
            composed: !0
        }));
    };
    #n = ()=>{
        this.disabled || (this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover")), this.dispatchEvent(new Event(`${$7aad62ebc3d6fae8$var$n}-dragleave`, {
            bubbles: !0,
            composed: !0
        })));
    };
    #a = async (e)=>{
        if (!this.disabled) {
            e.preventDefault(), this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover"));
            try {
                this.#c(await $7aad62ebc3d6fae8$var$l(e));
            } catch (t) {
                this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$n}-error`, {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: t
                    }
                }));
            }
        }
    };
    #d = ()=>{
        this.disabled || this.#t?.click();
    };
    #l = (e)=>{
        this.disabled || (e.key === " " || e.key === "Enter") && this.#t?.click();
    };
    #c(e) {
        if (!Array.isArray(e) || !e.length) return;
        let t = [], i = [], s = e.length;
        if (!this.multiple && s > 1) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: $7aad62ebc3d6fae8$var$v,
                    message: "Too many files selected. Only 1 file is allowed."
                }
            ]
        });
        else if (this.multiple && s > this.maxFiles) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: $7aad62ebc3d6fae8$var$v,
                    message: `Too many files selected. Only ${this.maxFiles} ${this.maxFiles > 1 ? "files are" : "file is"} allowed.`
                }
            ]
        });
        else for (let r of e){
            let c = $7aad62ebc3d6fae8$var$u(r, this.accept), p = r.size > this.maxSize, h = r.size < this.minSize;
            if (c && !p && !h) t.push(r);
            else {
                let a = [];
                c || a.push({
                    code: $7aad62ebc3d6fae8$var$A,
                    message: `File type "${r.type}" is not accepted.`
                }), p && a.push({
                    code: $7aad62ebc3d6fae8$var$L,
                    message: `File size ${r.size} exceeds the maximum size of ${this.maxSize}.`
                }), h && a.push({
                    code: $7aad62ebc3d6fae8$var$k,
                    message: `File size ${r.size} is smaller than the minimum size of ${this.minSize}.`
                }), i.push({
                    file: r,
                    errors: a
                });
            }
        }
        this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$n}-drop`, {
            bubbles: !0,
            composed: !0,
            detail: {
                acceptedFiles: t,
                rejectedFiles: i
            }
        })), t.length > 0 && this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$n}-drop-accepted`, {
            bubbles: !0,
            composed: !0,
            detail: {
                acceptedFiles: t
            }
        })), i.length > 0 && this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$n}-drop-rejected`, {
            bubbles: !0,
            composed: !0,
            detail: {
                rejectedFiles: i
            }
        })), this.#t && (this.#t.value = this.#t.defaultValue);
    }
    openFileDialog() {
        this.disabled || this.#t?.click();
    }
    #o(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    static defineCustomElement(e = $7aad62ebc3d6fae8$var$n) {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, o);
    }
};
$7aad62ebc3d6fae8$export$6ccd1735166caad9.defineCustomElement();




const $33dea9d9a6da4c9a$export$63e7bed68b07a85c = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/apng",
    "image/gif",
    "image/webp",
    "image/avif"
];
const $33dea9d9a6da4c9a$export$62045be72fe457b4 = 20;
const $33dea9d9a6da4c9a$export$8f089f0a062560ff = 20;
const $33dea9d9a6da4c9a$export$d3f4819a57998cf7 = 360;


/**
 * Generates a unique id of the form `${prefix}-${randomString}-${suffix}`.
 *
 * @param {string} [prefix=''] - The prefix to use for the id.
 * @param {string} [suffix=''] - The suffix to use for the id.
 * @returns {string} - The unique id.
 */ const $21c3f3a8dccfa4fd$export$e2a22331486dcca0 = (prefix = "", suffix = "")=>{
    const prefixString = typeof prefix === "string" && prefix !== "" ? prefix + "-" : "";
    const suffixString = typeof suffix === "string" && suffix !== "" ? "-" + suffix : "";
    const randomString = Math.random().toString(36).substring(2, 8); // Pseudo-random string of six alphanumeric characters.
    return `${prefixString}${randomString}${suffixString}`;
};



const $c3d7e05a1ce34ed5$export$6539e087749cf9d3 = async (options = {})=>{
    const res = await fetch(options.url);
    const blob = await res.blob();
    const mimeType = options.mimeType || blob.type || "";
    if (!(0, $33dea9d9a6da4c9a$export$63e7bed68b07a85c).includes(mimeType)) throw new Error(`This is not an accepted image format. Accepted MIME types are: ${(0, $33dea9d9a6da4c9a$export$63e7bed68b07a85c).join(", ")}`);
    return new File([
        blob
    ], options.filename || "", blob);
};


/**
 * A class representing a storage utility for managing data in `localStorage` or `sessionStorage`.
 */ class $f0a2ccd611c71db8$export$bf2a15d34f3c441c {
    /**
   * The prefix to be added to all keys.
   *
   * @type {string}
   * @private
   */ #keyPrefix = null;
    /**
   * The storage provider (`localStorage` or `sessionStorage`).
   *
   * @type {Storage}
   * @private
   */ #provider = null;
    /**
   * Creates an instance of Storage.
   *
   * @param {string} prefix - The prefix to be added to all keys when storing/retrieving data.
   * @param {Storage} [provider=localStorage] - The storage provider (`localStorage` or `sessionStorage`).
   * @throws {Error} If prefix is not provided or if the provider is not supported.
   */ constructor(prefix, provider = localStorage){
        if (!prefix) throw new Error("Storage prefix is required");
        if (provider !== localStorage && provider !== sessionStorage) throw new Error("Storage provider is not supported");
        this.#keyPrefix = prefix;
        this.#provider = provider;
    }
    /**
   * Sets a key-value pair in the storage.
   *
   * @param {string} key - The key for the data.
   * @param {*} value - The value to be stored (will be converted to JSON string).
   */ set(key, value) {
        try {
            this.#provider.setItem(`${this.#keyPrefix}${key}`, JSON.stringify(value));
        } catch (err) {
            console.error("Error saving to storage", err);
        }
    }
    /**
   * Retrieves the value associated with the given key from the storage.
   *
   * @param {string} key - The key to retrieve the value for.
   * @returns {*} The value associated with the key, or `null` if key is not found or an error occurs.
   */ get(key) {
        try {
            const value = this.#provider.getItem(`${this.#keyPrefix}${key}`);
            return value ? JSON.parse(value) : null;
        } catch (err) {
            console.error("Error getting from storage", err);
            return null;
        }
    }
}
const $f0a2ccd611c71db8$var$DEFAULT_STORAGE_PREFIX = "meme-generator/";
const $f0a2ccd611c71db8$var$DEFAULT_STORAGE_PROVIDER = localStorage;
const $f0a2ccd611c71db8$export$ddcffe0146c8f882 = new $f0a2ccd611c71db8$export$bf2a15d34f3c441c($f0a2ccd611c71db8$var$DEFAULT_STORAGE_PREFIX, $f0a2ccd611c71db8$var$DEFAULT_STORAGE_PROVIDER);


const $fbb55a96d78c7ba0$export$de75f46579dcf24 = (selectedImage)=>{
    return typeof selectedImage === "string";
};


var $eccf21b2da8f185e$exports = {};

$eccf21b2da8f185e$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "Pressuru.684952ea.ttf";


var $8b39befa0ccb8cfb$exports = {};

$8b39befa0ccb8cfb$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "LoudNoises.565ccd21.ttf";


var $4e9367b4637ab0b3$exports = {};

$4e9367b4637ab0b3$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "Oswald-Regular.89ec7d89.ttf";


var $98768b53aac35bcc$exports = {};

$98768b53aac35bcc$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "Oswald-Bold.0f6a7ca6.ttf";


var $81873ad161a9f996$exports = {};

$81873ad161a9f996$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "Roboto-Regular.ca197847.ttf";


var $f1c993919e45d5c2$exports = {};

$f1c993919e45d5c2$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "Roboto-Bold.fdb9b54a.ttf";


var $8f40b96e34825d38$exports = {};

$8f40b96e34825d38$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "RobotoCondensed-Regular.d585f5c7.ttf";


var $51e3f333db254f7d$exports = {};

$51e3f333db254f7d$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "RobotoCondensed-Bold.e1f96d4b.ttf";


var $0d878777045f8608$exports = {};

$0d878777045f8608$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "CourierPrime-Regular.3a25a501.ttf";


var $da7f4261981c6446$exports = {};

$da7f4261981c6446$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "CourierPrime-Bold.3d6bf689.ttf";


var $553eebead4d87493$exports = {};

$553eebead4d87493$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "OpenSans-Regular.edf9e01b.ttf";


var $e4f4da01dd92f98a$exports = {};

$e4f4da01dd92f98a$exports = (parcelRequire("aNJCr")).getBundleURL("9p9yL") + "OpenSans-Bold.8fceb72b.ttf";


const $055531bbd0af154c$export$6874249d87f2602a = [
    {
        name: "LoudNoises",
        label: "Loud Noises",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($8b39befa0ccb8cfb$exports))),
        style: "normal",
        weight: "400"
    },
    {
        name: "Pressuru",
        label: "Pressuru",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($eccf21b2da8f185e$exports))),
        style: "normal",
        weight: "400"
    },
    {
        name: "Oswald-Regular",
        label: "Oswald",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($4e9367b4637ab0b3$exports))),
        style: "normal",
        weight: "400"
    },
    {
        name: "Oswald-Bold",
        label: "Oswald Bold",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($98768b53aac35bcc$exports))),
        style: "normal",
        weight: "700"
    },
    {
        name: "Roboto-Regular",
        label: "Roboto",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($81873ad161a9f996$exports))),
        style: "normal",
        weight: "400"
    },
    {
        name: "Roboto-Bold",
        label: "Roboto Bold",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($f1c993919e45d5c2$exports))),
        style: "normal",
        weight: "700"
    },
    {
        name: "RobotoCondensed-Regular",
        label: "Roboto Condensed",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($8f40b96e34825d38$exports))),
        style: "normal",
        weight: "400"
    },
    {
        name: "RobotoCondensed-Bold",
        label: "Roboto Condensed Bold",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($51e3f333db254f7d$exports))),
        style: "normal",
        weight: "700"
    },
    {
        name: "CourierPrime-Regular",
        label: "Courier Prime",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($0d878777045f8608$exports))),
        style: "normal",
        weight: "400"
    },
    {
        name: "CourierPrime-Bold",
        label: "Courier Prime Bold",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($da7f4261981c6446$exports))),
        style: "normal",
        weight: "700"
    },
    {
        name: "OpenSans-Regular",
        label: "Open Sans",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($553eebead4d87493$exports))),
        style: "normal",
        weight: "400"
    },
    {
        name: "OpenSans-Bold",
        label: "Open Sans Bold",
        path: (0, (/*@__PURE__*/$parcel$interopDefault($e4f4da01dd92f98a$exports))),
        style: "normal",
        weight: "400"
    }
];
const $055531bbd0af154c$export$59eceaef0c7797b2 = async (name, path, options = {})=>{
    try {
        const font = new FontFace(name, `url(${path})`, {
            ...options
        });
        await font.load();
        document.fonts.add(font);
    } catch (err) {
        console.error(err);
    }
};


const $166cfb2484b08c80$var$errorsContainer = document.getElementById("errorsContainer");
const $166cfb2484b08c80$var$hideError = (evt)=>{
    const target = evt.currentTarget;
    target.removeEventListener("click", $166cfb2484b08c80$var$hideError);
    $166cfb2484b08c80$var$errorsContainer.removeChild(target.parentNode);
};
const $166cfb2484b08c80$export$af04143326425dbd = (message = "", type = "info")=>{
    const types = [
        "info",
        "warning",
        "danger"
    ];
    if (!types.includes(type)) type = "info";
    const template = /* html */ `
    ${message}
    <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close"></button>
  `;
    const div = document.createElement("div");
    div.className = `alert alert-${type} alert-dismissible text-break mb-2 fade`;
    div.innerHTML = template;
    div.querySelector("button").addEventListener("click", $166cfb2484b08c80$var$hideError);
    $166cfb2484b08c80$var$errorsContainer.appendChild(div);
    setTimeout(()=>div.classList.add("show"), 100);
};





const $f0ee20a32c2bc385$var$defaultTextboxData = {
    id: "",
    text: "",
    fillColor: "#ffffff",
    strokeColor: "#000000",
    font: "Pressuru",
    fontSize: 40,
    fontWeight: "normal",
    textAlign: "center",
    shadowBlur: 0,
    strokeWidth: 1.5,
    offsetY: 0,
    offsetX: 0,
    rotate: 0,
    allCaps: true
};
const $f0ee20a32c2bc385$var$textboxes = new Map();
class $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b {
    constructor(data){
        const id = (0, $21c3f3a8dccfa4fd$export$e2a22331486dcca0)("textbox", Date.now().toString(36));
        this.data = data ? {
            ...data,
            id: id
        } : {
            ...$f0ee20a32c2bc385$var$defaultTextboxData,
            id: id
        };
        $f0ee20a32c2bc385$var$textboxes.set(id, this);
        document.dispatchEvent(new CustomEvent(`textbox-create`, {
            bubbles: true,
            composed: true,
            detail: {
                textbox: this
            }
        }));
    }
    getData() {
        return this.data;
    }
    static create(data) {
        return new $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b(data);
    }
    static getAll() {
        return $f0ee20a32c2bc385$var$textboxes;
    }
    static getById(id) {
        return $f0ee20a32c2bc385$var$textboxes.get(id);
    }
    static remove(id) {
        $f0ee20a32c2bc385$var$textboxes.delete(id);
        document.dispatchEvent(new CustomEvent(`textbox-remove`, {
            bubbles: true,
            composed: true,
            detail: {
                id: id
            }
        }));
    }
    static createElement(textbox, autoFocus = true) {
        if (!(textbox instanceof $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b)) return;
        const data = textbox.getData();
        const { id: id, text: text, fillColor: fillColor, strokeColor: strokeColor, fontSize: fontSize, shadowBlur: shadowBlur, strokeWidth: strokeWidth, offsetX: offsetX, offsetY: offsetY, rotate: rotate } = data;
        const template = /* html */ `
    <div class="d-flex align-items-center">
      <button type="button" class="btn btn-link" data-button="duplicate-text-box" title="Duplicate text box"></button>
      <button type="button" class="btn btn-link" data-button="delete-text-box" title="Remove text box"></button>

      <textarea class="form-control meme-text" type="text" data-input="text" autocomplete="off" rows="1" placeholder="${`Text #${$f0ee20a32c2bc385$var$textboxes.size}`}">${text}</textarea>

      <div class="d-flex align-items-center pe-2">
        <label for="fillColorInput" class="visually-hidden">Fill color</label>
        <input class="form-control" type="color" value="${fillColor}" id="fillColorInput" data-input="fillColor" title="Fill color">

        <label for="strokeColorInput" class="visually-hidden">Outline color</label>
        <input class="form-control" type="color" value="${strokeColor}" id="strokeColorInput" data-input="strokeColor" title="Outline color">

        <button type="button" class="btn btn-secondary settings-button" data-button="settings" title="Settings"></button>
      </div>
    </div>

    <div class="p-2" data-section="settings" hidden>
      <div class="row g-2">
        <div class="col-12">
          <details class="emoji-picker-details">
            <summary>Emoji picker</summary>
            <emoji-picker class="light"></emoji-picker>
          </details>
        </div>

        <div class="col-4 mb-3">
          <label for="fontInput_${id}" class="mb-1 d-block text-truncate">Font: </label>

          <select class="form-select" data-input="font" id="fontInput_${id}">
            <optgroup label="Web fonts">
              <option value="Impact">Impact</option>
              <option value="Arial">Arial</option>
              <option value="Arial Black">Arial Black</option>
              <option value="Helvetica">Helvetica</option>
              <option value="Comic Sans MS">Comic Sans MS</option>
              <option value="Times">Times</option>
              <option value="Times New Roman">Times New Roman</option>
              <option value="Courier New">Courier New</option>
              <option value="Verdana">Verdana</option>
              <option value="Georgia">Georgia</option>
              <option value="Palatino">Palatino</option>
              <option value="Garamond">Garamond</option>
              <option value="Bookman">Bookman</option>
              <option value="Trebuchet MS">Trebuchet MS</option>
            </optgroup>
            <optgroup label="Google fonts">
              ${(0, $055531bbd0af154c$export$6874249d87f2602a).map(({ name: name, label: label })=>`<option value="${name}">${label}</option>`)}
            </optgroup>
          </select>
        </div>

        <div class="col-4 mb-3">
          <label for="fontSizeInput_${id}" class="mb-1 d-block text-truncate">Size:</label>
          <input class="form-control" type="number" min="1" value="${fontSize}" data-input="fontSize" id="fontSizeInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label for="fontWeightInput_${id}" class="mb-1 d-block text-truncate">Weight:</label>
          <select class="form-select" data-input="fontWeight" id="fontWeightInput_${id}">
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
          </select>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-4 mb-3">
          <label for="shadowWidthInput_${id}" class="mb-1 d-block text-truncate">Shadow size:</label>
          <input class="form-control" type="number" min="0" max="${(0, $33dea9d9a6da4c9a$export$62045be72fe457b4)}" value="${shadowBlur}" data-input="shadowBlur" id="shadowWidthInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="strokeWidthInput_${id}">Outline size:</label>
          <input class="form-control" type="number" min="0" max="${(0, $33dea9d9a6da4c9a$export$8f089f0a062560ff)}" step="0.5" value="${strokeWidth}" data-input="strokeWidth" id="strokeWidthInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label for="textAlignInput_${id}" class="mb-1 d-block text-truncate">Text align:</label>
          <select class="form-select" data-input="textAlign" id="textAlignInput_${id}" value="right">
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="offsetYInput_${id}">Vertical offset:</label>
          <input class="form-control" type="number" value="${offsetY}" data-input="offsetY" id="offsetYInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="offsetXInput_${id}">Horizontal offset:</label>
          <input class="form-control" type="number" value="${offsetX}" data-input="offsetX" id="offsetXInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="textRotateInput_${id}">Rotate:</label>
          <input class="form-control" type="number" value="${rotate}" data-input="rotate" id="textRotateInput_${id}" min="-360" max="${(0, $33dea9d9a6da4c9a$export$d3f4819a57998cf7)}">
        </div>

        <div class="col-12">
          <div class="move-text-actions mb-3">
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Up"></button>
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Right"></button>
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Down"></button>
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Left"></button>
          </div>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-lg-12">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="allCapsCheckbox_${id}" data-input="allCaps">
            <label class="form-check-label" for="allCapsCheckbox_${id}">ALL CAPS</label>
          </div>
        </div>
      </div>
    </div>
  `;
        const fragment = document.createDocumentFragment();
        const div = document.createElement("div");
        div.setAttribute("id", id);
        div.setAttribute("data-section", "textbox");
        div.className = "bg-body-tertiary border shadow-sm mb-3 rounded";
        div.innerHTML = template;
        div.querySelectorAll("select").forEach((el)=>el.value = data[el.dataset.input]);
        div.querySelectorAll('input[type="checkbox"]').forEach((el)=>el.checked = data[el.dataset.input]);
        const textboxEl = fragment.appendChild(div);
        if (autoFocus) setTimeout(()=>textboxEl.querySelector('[data-input="text"]').focus(), 0);
        return textboxEl;
    }
}




class $68e654e91d7a7392$export$8d01c972ee8b14a9 {
    #canvas = null;
    #ctx = null;
    constructor(canvasEl){
        this.#canvas = canvasEl;
        this.#ctx = this.#canvas.getContext("2d");
    }
    get width() {
        return this.#canvas.width;
    }
    set width(value) {
        this.#canvas.width = value;
    }
    get height() {
        return this.#canvas.height;
    }
    set height(value) {
        this.#canvas.height = value;
    }
    getDimensions() {
        return {
            width: this.width,
            height: this.height
        };
    }
    setDimensions({ width: width, height: height }) {
        this.width = width;
        this.height = height;
        return this;
    }
    toDataURL() {
        return this.#canvas.toDataURL();
    }
    draw(image, textboxes = new Map()) {
        if (image == null) return;
        const canvas = this.#canvas;
        const ctx = this.#ctx;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if ((0, $fbb55a96d78c7ba0$export$de75f46579dcf24)(image)) {
            ctx.fillStyle = image;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        } else ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        let multiplier = 0;
        textboxes.forEach((textbox)=>{
            const { data: data } = textbox;
            multiplier += 1;
            ctx.save();
            ctx.font = `${data.fontWeight} ${data.fontSize * canvas.width / 1000}px ${data.font}`;
            ctx.fillStyle = data.fillColor;
            ctx.textAlign = data.textAlign;
            ctx.strokeStyle = data.strokeColor;
            const lineHeight = ctx.measureText("M").width + data.fontSize / 2;
            const xPos = canvas.width / 2;
            const shadowBlur = data.shadowBlur;
            const text = data.allCaps === true ? data.text.toUpperCase() : data.text;
            const textLines = text.split("\n");
            if (shadowBlur !== 0) {
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
                ctx.shadowBlur = Math.min(shadowBlur, (0, $33dea9d9a6da4c9a$export$62045be72fe457b4));
                ctx.shadowColor = data.strokeColor;
            }
            ctx.translate(xPos + data.offsetX, lineHeight * multiplier + data.offsetY);
            ctx.rotate(Math.min(data.rotate, (0, $33dea9d9a6da4c9a$export$d3f4819a57998cf7)) * Math.PI / 180);
            // First draw each line with shadow.
            textLines.forEach((text, index)=>ctx.fillText(text, 0, index * lineHeight));
            // Since shadows of multiline text may be drawn over letters of neighbour lines
            // (when shadow blur is big enough), re-draw text without shadows.
            if (shadowBlur !== 0) {
                ctx.shadowBlur = 0;
                textLines.forEach((text, index)=>ctx.fillText(text, 0, index * lineHeight));
            }
            if (data.strokeWidth > 0) {
                ctx.lineWidth = Math.min(data.strokeWidth, (0, $33dea9d9a6da4c9a$export$8f089f0a062560ff));
                textLines.forEach((text, index)=>ctx.strokeText(text, 0, index * lineHeight));
            }
            ctx.restore();
        });
        return this;
    }
    clear() {
        this.#ctx.clearRect(0, 0, this.#canvas.width, this.#canvas.height);
        return this;
    }
    show() {
        this.#canvas.hidden = false;
        return this;
    }
    hide() {
        this.#canvas.hidden = true;
        return this;
    }
    static createInstance(canvasEl) {
        return new $68e654e91d7a7392$export$8d01c972ee8b14a9(canvasEl);
    }
}


var $cd9a1f5526d5caac$exports = {};
$cd9a1f5526d5caac$exports = JSON.parse('["James meme 1.jpg","James meme 10.jpg","James meme 11.jpg","James meme 12.jpg","James meme 13.jpg","James meme 14.jpg","James meme 15.jpg","James meme 2.jpg","James meme 3.jpg","James meme 4.jpg","James meme 5.jpg","James meme 6.jpg","James meme 7.jpg","James meme 8.jpg","James meme 9.jpg"]');


const $44ae6d9db4eaca0f$var$canvas = (0, $68e654e91d7a7392$export$8d01c972ee8b14a9).createInstance(document.getElementById("canvas"));
const $44ae6d9db4eaca0f$var$videoModal = document.getElementById("videoModal");
const $44ae6d9db4eaca0f$var$downloadModal = document.getElementById("downloadModal");
const $44ae6d9db4eaca0f$var$capturePhotoEl = document.querySelector("capture-photo");
const $44ae6d9db4eaca0f$var$cameraSelect = document.getElementById("cameraSelect");
const $44ae6d9db4eaca0f$var$capturePhotoButton = document.getElementById("capturePhotoButton");
const $44ae6d9db4eaca0f$var$torchButton = document.getElementById("torchButton");
const $44ae6d9db4eaca0f$var$dropzoneEl = document.querySelector("files-dropzone");
const $44ae6d9db4eaca0f$var$instructionsEl = document.getElementById("instructions");
// const imageUploadMethodSelect = document.getElementById('imageUploadMethodSelect');
const $44ae6d9db4eaca0f$var$fileSelectBtn = document.getElementById("fileSelectBtn");
const $44ae6d9db4eaca0f$var$imageUrlForm = document.getElementById("imageUrlForm");
const $44ae6d9db4eaca0f$var$addTextboxBtn = document.getElementById("addTextboxBtn");
const $44ae6d9db4eaca0f$var$textboxesContainer = document.getElementById("textboxesContainer");
const $44ae6d9db4eaca0f$var$generateMemeBtn = document.getElementById("generateMemeBtn");
const $44ae6d9db4eaca0f$var$openVideoModalBtn = document.getElementById("openVideoModalBtn");
const $44ae6d9db4eaca0f$var$downloadMemeBtn = document.getElementById("downloadMemeBtn");
const $44ae6d9db4eaca0f$var$downloadMemePreview = document.getElementById("downloadMemePreview");
const $44ae6d9db4eaca0f$var$webShareComponent = document.querySelector("web-share");
const $44ae6d9db4eaca0f$var$galleryEl = document.getElementById("gallery");
const $44ae6d9db4eaca0f$var$gallerySearchEl = document.getElementById("gallerySearch");
const $44ae6d9db4eaca0f$var$galleryNoResultsEl = $44ae6d9db4eaca0f$var$galleryEl.querySelector(".gallery__no-results");
const $44ae6d9db4eaca0f$var$solidColorForm = document.getElementById("solidColorForm");
const $44ae6d9db4eaca0f$var$uploadMethodEls = document.querySelectorAll(".upload-method");
const $44ae6d9db4eaca0f$var$removeConfirmationModal = document.getElementById("removeConfirmationModal");
const $44ae6d9db4eaca0f$var$removeTextForm = document.getElementById("removeTextForm");
const $44ae6d9db4eaca0f$var$maxImageDimensionsForm = document.getElementById("maxImageDimensionsForm");
const $44ae6d9db4eaca0f$var$maxImageDimensionsSelect = $44ae6d9db4eaca0f$var$maxImageDimensionsForm["maxImageDimensions"];
const $44ae6d9db4eaca0f$var$clearCanvasBtn = document.getElementById("clearCanvasBtn");
const $44ae6d9db4eaca0f$var$maxImageDimensionsFromStorage = (0, $f0a2ccd611c71db8$export$ddcffe0146c8f882).get("maxImageDimensions");
let $44ae6d9db4eaca0f$var$shouldFocusOnTextboxCreate = false;
let $44ae6d9db4eaca0f$var$selectedImage = null;
let $44ae6d9db4eaca0f$var$reqAnimFrame = null;
const $44ae6d9db4eaca0f$var$galleryContainer = $44ae6d9db4eaca0f$var$galleryEl.querySelector(".gallery");
const $44ae6d9db4eaca0f$var$generateGalleryButtons = (images)=>{
    return images.map((image)=>{
        const button = document.createElement("button");
        button.type = "button";
        button.className = "btn btn-link";
        const img = document.createElement("img");
        img.loading = "lazy";
        img.src = `/meme-templates/${image}`;
        img.alt = image.replace(/-/g, " ").replace(/\.[^/.]+$/, "").replace(/\b\w/g, (c)=>c.toUpperCase());
        img.title = img.alt;
        button.appendChild(img);
        return button;
    });
};
const $44ae6d9db4eaca0f$var$renderAcceptedImageFormats = (acceptedMimeTypes, rootEl)=>{
    if (!rootEl) return;
};
const $44ae6d9db4eaca0f$var$generateMeme = async ()=>{
    const dataUrl = $44ae6d9db4eaca0f$var$canvas.toDataURL("image/png");
    const filename = `${(0, $21c3f3a8dccfa4fd$export$e2a22331486dcca0)("meme")}.png`;
    // Prepare download link
    const downloadLink = dataUrl.replace("image/png", "image/octet-stream");
    $44ae6d9db4eaca0f$var$downloadMemeBtn.download = filename;
    $44ae6d9db4eaca0f$var$downloadMemeBtn.href = downloadLink;
    $44ae6d9db4eaca0f$var$downloadMemePreview.width = $44ae6d9db4eaca0f$var$canvas.getDimensions().width;
    $44ae6d9db4eaca0f$var$downloadMemePreview.height = $44ae6d9db4eaca0f$var$canvas.getDimensions().height;
    $44ae6d9db4eaca0f$var$downloadMemePreview.src = downloadLink;
    // Prepare for sharing file
    if ((0, $94933cc6427541bd$export$c37129e465f64ef0)()) try {
        const file = await (0, $c3d7e05a1ce34ed5$export$6539e087749cf9d3)({
            url: dataUrl,
            filename: filename,
            mimeType: "image/png"
        }).catch((err)=>(0, $166cfb2484b08c80$export$af04143326425dbd)(err.message, "danger"));
        if (file && (0, $94933cc6427541bd$export$c37129e465f64ef0)({
            files: [
                file
            ]
        })) {
            $44ae6d9db4eaca0f$var$webShareComponent.shareFiles = [
                file
            ];
            $44ae6d9db4eaca0f$var$webShareComponent.hidden = false;
        }
    } catch (error) {
        console.error(error);
    }
    window.requestAnimationFrame(()=>{
        $44ae6d9db4eaca0f$var$downloadModal.open = true;
    });
};
const $44ae6d9db4eaca0f$var$setImageMaxDimensions = (image)=>{
    const maxImageDimensionsSelect = $44ae6d9db4eaca0f$var$maxImageDimensionsForm["maxImageDimensions"];
    const [maxWidthValue, maxHeightValue] = maxImageDimensionsSelect.value.split("x");
    const MAX_WIDTH = Number(maxWidthValue) || 800;
    const MAX_HEIGHT = Number(maxHeightValue) || 600;
    let width = image.width;
    let height = image.height;
    if (width > height) {
        if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
        }
    } else if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
    }
    $44ae6d9db4eaca0f$var$canvas.setDimensions({
        width: width,
        height: height
    });
};
const $44ae6d9db4eaca0f$var$afterImageSelect = ()=>{
    $44ae6d9db4eaca0f$var$canvas.draw($44ae6d9db4eaca0f$var$selectedImage, (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getAll()).show();
    $44ae6d9db4eaca0f$var$generateMemeBtn.disabled = false;
    $44ae6d9db4eaca0f$var$instructionsEl.hidden = true;
    $44ae6d9db4eaca0f$var$clearCanvasBtn.hidden = false;
};
const $44ae6d9db4eaca0f$var$handleImageLoad = (evt)=>{
    $44ae6d9db4eaca0f$var$selectedImage = evt.target;
    $44ae6d9db4eaca0f$var$setImageMaxDimensions($44ae6d9db4eaca0f$var$selectedImage);
    $44ae6d9db4eaca0f$var$afterImageSelect();
};
const $44ae6d9db4eaca0f$var$handleSolidColorFormInput = (evt)=>{
    const DEFAULT_WIDTH = 800;
    const DEFAULT_HEIGHT = 600;
    if (evt.target === $44ae6d9db4eaca0f$var$solidColorForm["canvasColor"]) $44ae6d9db4eaca0f$var$selectedImage = evt.target.value;
    if ((0, $fbb55a96d78c7ba0$export$de75f46579dcf24)($44ae6d9db4eaca0f$var$selectedImage)) {
        $44ae6d9db4eaca0f$var$canvas.setDimensions({
            width: Number($44ae6d9db4eaca0f$var$solidColorForm["canvasWidth"].value) || DEFAULT_WIDTH,
            height: Number($44ae6d9db4eaca0f$var$solidColorForm["canvasHeight"].value) || DEFAULT_HEIGHT
        });
        $44ae6d9db4eaca0f$var$afterImageSelect();
    }
};
const $44ae6d9db4eaca0f$var$handleFileSelect = (file)=>{
    if (!file) return;
    const image = new Image();
    const reader = new FileReader();
    reader.addEventListener("load", function(evt) {
        const data = evt.target.result;
        image.addEventListener("load", $44ae6d9db4eaca0f$var$handleImageLoad);
        image.src = data;
    });
    reader.readAsDataURL(file);
};
const $44ae6d9db4eaca0f$var$handleOpenVideoModalButtonClick = ()=>{
    $44ae6d9db4eaca0f$var$videoModal.open = true;
};
const $44ae6d9db4eaca0f$var$handleTextPropChange = (element, textboxId, prop)=>{
    const textboxData = (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getById(textboxId).getData();
    switch(element.type){
        case "checkbox":
            textboxData[prop] = element.checked;
            break;
        case "number":
            textboxData[prop] = Number(element.value);
            break;
        default:
            textboxData[prop] = element.value;
    }
    $44ae6d9db4eaca0f$var$canvas.draw($44ae6d9db4eaca0f$var$selectedImage, (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getAll());
};
const $44ae6d9db4eaca0f$var$handleAddTextboxBtnClick = ()=>(0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).create();
const $44ae6d9db4eaca0f$var$handleImageUploadFromURL = async (evt)=>{
    evt.preventDefault();
    const form = evt.target;
    const submitButton = form.querySelector('button[type="submit"]');
    const imageUrl = form["imageUrl"].value;
    if (!imageUrl.trim()) return;
    submitButton.disabled = true;
    submitButton.querySelector(".spinner").hidden = false;
    submitButton.querySelector(".label").hidden = true;
    try {
        const file = await (0, $c3d7e05a1ce34ed5$export$6539e087749cf9d3)({
            url: imageUrl
        }).catch((err)=>(0, $166cfb2484b08c80$export$af04143326425dbd)(err.message, "danger"));
        if (file) $44ae6d9db4eaca0f$var$handleFileSelect(file);
    } catch  {
        (0, $166cfb2484b08c80$export$af04143326425dbd)(`Failed to load image from "${imageUrl}".`, "danger");
    } finally{
        submitButton.disabled = false;
        submitButton.querySelector(".spinner").hidden = true;
        submitButton.querySelector(".label").hidden = false;
    }
};
const $44ae6d9db4eaca0f$var$moveTextUsingArrowbuttons = (textboxId, direction)=>()=>{
        const textboxEl = document.getElementById(textboxId);
        const offsetYInput = textboxEl.querySelector('[data-input="offsetY"]');
        const offsetXInput = textboxEl.querySelector('[data-input="offsetX"]');
        const textbox = (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getById(textboxId);
        if (!textbox) return;
        const textboxData = textbox.getData();
        direction = direction.toLowerCase();
        switch(direction){
            case "up":
                textboxData.offsetY -= 1;
                offsetYInput.value = textboxData.offsetY;
                break;
            case "down":
                textboxData.offsetY += 1;
                offsetYInput.value = textboxData.offsetY;
                break;
            case "left":
                textboxData.offsetX -= 1;
                offsetXInput.value = textboxData.offsetX;
                break;
            case "right":
                textboxData.offsetX += 1;
                offsetXInput.value = textboxData.offsetX;
                break;
        }
        $44ae6d9db4eaca0f$var$canvas.draw($44ae6d9db4eaca0f$var$selectedImage, (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getAll());
        $44ae6d9db4eaca0f$var$reqAnimFrame = requestAnimationFrame($44ae6d9db4eaca0f$var$moveTextUsingArrowbuttons(textboxId, direction));
    };
const $44ae6d9db4eaca0f$var$handleUploadMethodChange = (evt)=>{
    $44ae6d9db4eaca0f$var$uploadMethodEls.forEach((el)=>el.hidden = el.id !== evt.target.value);
    $44ae6d9db4eaca0f$var$maxImageDimensionsForm.hidden = evt.target.value === "solidColorForm";
};
const $44ae6d9db4eaca0f$var$handleFileSelectClick = ()=>{
    if (typeof $44ae6d9db4eaca0f$var$dropzoneEl.openFileDialog === "function") $44ae6d9db4eaca0f$var$dropzoneEl.openFileDialog();
};
const $44ae6d9db4eaca0f$var$handleDropFilesAccepted = (evt)=>{
    const [file] = evt.detail.acceptedFiles;
    if (file) $44ae6d9db4eaca0f$var$handleFileSelect(file);
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerInput = (evt)=>{
    const element = evt.target;
    const textboxId = element.closest('[data-section="textbox"]').id;
    let prop;
    if (element.matches('[data-input="text"]')) prop = "text";
    else if (element.matches('[data-input="fillColor"]')) prop = "fillColor";
    else if (element.matches('[data-input="strokeColor"]')) prop = "strokeColor";
    else if (element.matches('[data-input="font"]')) prop = "font";
    else if (element.matches('[data-input="fontSize"]')) prop = "fontSize";
    else if (element.matches('[data-input="fontWeight"]')) prop = "fontWeight";
    else if (element.matches('[data-input="textAlign"]')) prop = "textAlign";
    else if (element.matches('[data-input="shadowBlur"]')) prop = "shadowBlur";
    else if (element.matches('[data-input="offsetY"]')) prop = "offsetY";
    else if (element.matches('[data-input="offsetX"]')) prop = "offsetX";
    else if (element.matches('[data-input="rotate"]')) prop = "rotate";
    else if (element.matches('[data-input="strokeWidth"]')) prop = "strokeWidth";
    if (prop) $44ae6d9db4eaca0f$var$handleTextPropChange(element, textboxId, prop);
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerChange = (evt)=>{
    const element = evt.target;
    const textboxId = element.closest('[data-section="textbox"]').id;
    let prop;
    if (element.matches('[data-input="allCaps"]')) prop = "allCaps";
    if (prop) $44ae6d9db4eaca0f$var$handleTextPropChange(element, textboxId, prop);
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerClick = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-button="settings"]')) {
        const textboxEl = element.closest('[data-section="textbox"]');
        const textboxSettingsEl = textboxEl?.querySelector('[data-section="settings"]');
        if (textboxSettingsEl) textboxSettingsEl.hidden = !textboxSettingsEl.hidden;
    }
    if (element.matches('[data-button="duplicate-text-box"')) {
        const currentTextboxEl = element.closest('[data-section="textbox"]');
        const currentTextboxData = (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getById(currentTextboxEl.id);
        (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).create({
            ...currentTextboxData.data
        });
    }
    if (element.matches('[data-button="delete-text-box"]')) {
        const textboxId = element.closest('[data-section="textbox"]').id;
        const textboxToDelete = (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getById(textboxId);
        if (textboxToDelete && textboxToDelete.data.text.trim()) {
            const textboxIdInput = $44ae6d9db4eaca0f$var$removeTextForm["textbox-id"];
            if (textboxIdInput) {
                textboxIdInput.value = textboxId;
                $44ae6d9db4eaca0f$var$removeConfirmationModal.open = true;
            }
        } else (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).remove(textboxId);
    }
};
const $44ae6d9db4eaca0f$var$handleTextRemoveFormSubmit = (evt)=>{
    evt.preventDefault();
    const textboxId = evt.target["textbox-id"].value;
    if (textboxId) {
        (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).remove(textboxId);
        $44ae6d9db4eaca0f$var$removeConfirmationModal.open = false;
    }
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerPointerdown = (evt)=>{
    const element = evt.target;
    const textboxEl = element.closest('[data-section="textbox"]');
    if (!textboxEl) return;
    if (element.matches('[data-action="move-text"]')) $44ae6d9db4eaca0f$var$reqAnimFrame = requestAnimationFrame($44ae6d9db4eaca0f$var$moveTextUsingArrowbuttons(textboxEl.id, element.getAttribute("aria-label")));
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerPointerup = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-action="move-text"]')) {
        cancelAnimationFrame && cancelAnimationFrame($44ae6d9db4eaca0f$var$reqAnimFrame);
        $44ae6d9db4eaca0f$var$reqAnimFrame = null;
    }
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerPointerout = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-action="move-text"]')) {
        cancelAnimationFrame && cancelAnimationFrame($44ae6d9db4eaca0f$var$reqAnimFrame);
        $44ae6d9db4eaca0f$var$reqAnimFrame = null;
    }
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerKeyDown = (evt)=>{
    const element = evt.target;
    const textboxEl = element.closest('[data-section="textbox"]');
    if (element.matches('[data-action="move-text"]')) {
        if (evt.key === " " || evt.key === "Enter") {
            $44ae6d9db4eaca0f$var$reqAnimFrame && cancelAnimationFrame($44ae6d9db4eaca0f$var$reqAnimFrame);
            $44ae6d9db4eaca0f$var$reqAnimFrame = requestAnimationFrame($44ae6d9db4eaca0f$var$moveTextUsingArrowbuttons(textboxEl.id, element.getAttribute("aria-label")));
        }
    }
};
const $44ae6d9db4eaca0f$var$handleTextboxesContainerKeyUp = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-action="move-text"]')) {
        if (evt.key === " " || evt.key === "Enter") {
            $44ae6d9db4eaca0f$var$reqAnimFrame && cancelAnimationFrame($44ae6d9db4eaca0f$var$reqAnimFrame);
            $44ae6d9db4eaca0f$var$reqAnimFrame = null;
        }
    }
};
const $44ae6d9db4eaca0f$var$handleGalleryClick = async (evt)=>{
    const button = evt.target.closest("button");
    if (!button) return;
    const img = button.querySelector("img");
    try {
        const file = await (0, $c3d7e05a1ce34ed5$export$6539e087749cf9d3)({
            url: img.src
        }).catch((err)=>(0, $166cfb2484b08c80$export$af04143326425dbd)(err.message, "danger"));
        if (file) $44ae6d9db4eaca0f$var$handleFileSelect(file);
    } catch  {
        (0, $166cfb2484b08c80$export$af04143326425dbd)(`Failed to load image: "${img.alt}".`, "danger");
    }
};
const $44ae6d9db4eaca0f$var$handleGallerySearchInput = (evt)=>{
    const query = evt.target.value.toLowerCase().trim();
    const galleryItems = $44ae6d9db4eaca0f$var$galleryEl.querySelectorAll("button");
    galleryItems.forEach((item)=>{
        const alt = (item.querySelector("img").getAttribute("alt") || "").toLowerCase();
        item.hidden = !alt.includes(query);
    });
    $44ae6d9db4eaca0f$var$galleryNoResultsEl.hidden = !!$44ae6d9db4eaca0f$var$galleryEl.querySelector("button:not([hidden])");
};
const $44ae6d9db4eaca0f$var$handleWebShareError = ()=>{
    $44ae6d9db4eaca0f$var$downloadModal.open = false;
    (0, $166cfb2484b08c80$export$af04143326425dbd)("There was an error while trying to share your meme.", "danger");
};
const $44ae6d9db4eaca0f$var$handleCapturePhotoError = (evt)=>{
    const error = evt.detail.error;
    let errorMessage = "An error occurred while trying to capture photo.";
    if (error instanceof Error && (error.name === "NotAllowedError" || error.name === "NotFoundError")) errorMessage += " Make sure you have a camera connected and you have granted the appropriate permissions.";
    (0, $166cfb2484b08c80$export$af04143326425dbd)(errorMessage, "danger");
    $44ae6d9db4eaca0f$var$videoModal.open = false;
    console.error(error);
};
const $44ae6d9db4eaca0f$var$handleCapturePhotoSuccess = (evt)=>{
    $44ae6d9db4eaca0f$var$videoModal.open = false;
    const image = new Image();
    image.addEventListener("load", $44ae6d9db4eaca0f$var$handleImageLoad);
    image.src = evt.detail.dataURI;
};
const $44ae6d9db4eaca0f$var$handleModalOpen = (evt)=>{
    if (evt.target.id === "videoModal") {
        if ($44ae6d9db4eaca0f$var$capturePhotoEl && typeof $44ae6d9db4eaca0f$var$capturePhotoEl.startVideoStream === "function") $44ae6d9db4eaca0f$var$capturePhotoEl.startVideoStream();
    }
};
const $44ae6d9db4eaca0f$var$handleModalClose = (evt)=>{
    if (evt.target.id === "videoModal") {
        if ($44ae6d9db4eaca0f$var$capturePhotoEl && typeof $44ae6d9db4eaca0f$var$capturePhotoEl.stopVideoStream === "function") $44ae6d9db4eaca0f$var$capturePhotoEl.stopVideoStream();
    }
    if (evt.target.id === "removeConfirmationModal") $44ae6d9db4eaca0f$var$removeTextForm.reset();
};
const $44ae6d9db4eaca0f$var$handleEmojiPickerSelection = (evt)=>{
    const textboxEl = evt.target.closest('[data-section="textbox"]');
    if (textboxEl) {
        const input = textboxEl.querySelector('[data-input="text"]');
        const emoji = evt.detail.unicode;
        if (input) (0, $dec5faeb65064cfd$export$2e2bcd8739ae039)(input, emoji);
    }
};
const $44ae6d9db4eaca0f$var$handleMaxImageDimensionsFormChange = (evt)=>{
    if (evt.target.matches('[name="maxImageDimensions"]')) (0, $f0a2ccd611c71db8$export$ddcffe0146c8f882).set("maxImageDimensions", evt.target.value);
    if (!$44ae6d9db4eaca0f$var$selectedImage || (0, $fbb55a96d78c7ba0$export$de75f46579dcf24)($44ae6d9db4eaca0f$var$selectedImage)) return;
    $44ae6d9db4eaca0f$var$setImageMaxDimensions($44ae6d9db4eaca0f$var$selectedImage);
    $44ae6d9db4eaca0f$var$canvas.draw($44ae6d9db4eaca0f$var$selectedImage, (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getAll());
};
const $44ae6d9db4eaca0f$var$handleTextboxCreate = (evt)=>{
    const textbox = evt.detail.textbox;
    const textboxEl = (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).createElement(textbox, $44ae6d9db4eaca0f$var$shouldFocusOnTextboxCreate);
    $44ae6d9db4eaca0f$var$shouldFocusOnTextboxCreate = true;
    $44ae6d9db4eaca0f$var$textboxesContainer.appendChild(textboxEl);
    if (textbox.getData().text) $44ae6d9db4eaca0f$var$canvas.draw($44ae6d9db4eaca0f$var$selectedImage, (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getAll());
};
const $44ae6d9db4eaca0f$var$handleTextboxDelete = (evt)=>{
    const textboxEl = document.getElementById(evt.detail.id);
    textboxEl && textboxEl.remove();
    $44ae6d9db4eaca0f$var$textboxesContainer.querySelectorAll('[data-section="textbox"]').forEach((el, idx)=>{
        el.querySelector('[data-input="text"]').setAttribute("placeholder", `Text #${idx + 1}`);
    });
    $44ae6d9db4eaca0f$var$canvas.draw($44ae6d9db4eaca0f$var$selectedImage, (0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).getAll());
};
const $44ae6d9db4eaca0f$var$handleClearCanvas = (evt)=>{
    if (!$44ae6d9db4eaca0f$var$selectedImage) return;
    evt.stopPropagation();
    $44ae6d9db4eaca0f$var$selectedImage = null;
    $44ae6d9db4eaca0f$var$dropzoneEl.classList.remove("dropzone--accepted");
    $44ae6d9db4eaca0f$var$generateMemeBtn.disabled = true;
    $44ae6d9db4eaca0f$var$instructionsEl.hidden = false;
    $44ae6d9db4eaca0f$var$clearCanvasBtn.hidden = true;
    $44ae6d9db4eaca0f$var$dropzoneEl.disabled = false;
    $44ae6d9db4eaca0f$var$canvas.clear().hide();
};
const $44ae6d9db4eaca0f$var$toggleTorchButtonStatus = (options = {})=>{
    const defaults = {
        el: document.getElementById("torchButton"),
        isTorchOn: false
    };
    const { el: el, isTorchOn: isTorchOn } = {
        ...defaults,
        ...options
    };
    const iconPaths = el.querySelectorAll("svg path");
    if (iconPaths.length !== 2) return;
    iconPaths[0].style.display = isTorchOn ? "none" : "block";
    iconPaths[1].style.display = isTorchOn ? "block" : "none";
    el.setAttribute("aria-label", `Turn ${isTorchOn ? "off" : "on"} flash`);
};
const $44ae6d9db4eaca0f$var$handleTorchButtonClick = (evt)=>{
    if ($44ae6d9db4eaca0f$var$capturePhotoEl === null) return;
    $44ae6d9db4eaca0f$var$capturePhotoEl.torch = !$44ae6d9db4eaca0f$var$capturePhotoEl.torch;
    $44ae6d9db4eaca0f$var$toggleTorchButtonStatus({
        el: evt.currentTarget,
        isTorchOn: $44ae6d9db4eaca0f$var$capturePhotoEl.hasAttribute("torch")
    });
};
const $44ae6d9db4eaca0f$var$handleCapturePhotoVideoPlay = async (evt)=>{
    const trackCapabilities = evt.target.getTrackCapabilities();
    if (trackCapabilities?.torch) {
        $44ae6d9db4eaca0f$var$torchButton?.removeAttribute("hidden");
        if ($44ae6d9db4eaca0f$var$capturePhotoEl?.hasAttribute("torch")) $44ae6d9db4eaca0f$var$toggleTorchButtonStatus({
            el: $44ae6d9db4eaca0f$var$torchButton,
            isTorchOn: true
        });
    }
    const videoInputDevices = await (0, $636b0cf1ed0b9f88$export$cc30a98fe3890794).getVideoInputDevices();
    videoInputDevices.forEach((device, index)=>{
        const option = document.createElement("option");
        option.value = device.deviceId;
        option.textContent = device.label || `Camera ${index + 1}`;
        $44ae6d9db4eaca0f$var$cameraSelect.appendChild(option);
    });
    if (videoInputDevices.length > 1) $44ae6d9db4eaca0f$var$cameraSelect?.removeAttribute("hidden");
};
const $44ae6d9db4eaca0f$var$handleCameraSelectChange = (evt)=>{
    if ($44ae6d9db4eaca0f$var$capturePhotoEl === null || typeof $44ae6d9db4eaca0f$var$capturePhotoEl.restartVideoStream !== "function" || $44ae6d9db4eaca0f$var$capturePhotoEl.hasAttribute("loading")) return;
    const videoDeviceId = evt.target.value || undefined;
    $44ae6d9db4eaca0f$var$capturePhotoEl.restartVideoStream(videoDeviceId);
};
const $44ae6d9db4eaca0f$var$handleCapturePhotoButtonClick = ()=>{
    if ($44ae6d9db4eaca0f$var$capturePhotoEl === null || typeof $44ae6d9db4eaca0f$var$capturePhotoEl.capture !== "function" || $44ae6d9db4eaca0f$var$capturePhotoEl.hasAttribute("loading")) return;
    $44ae6d9db4eaca0f$var$capturePhotoEl.capture();
};
const $44ae6d9db4eaca0f$var$handlethemeChange = (evt)=>{
    const theme = evt.detail.theme;
    const deviceTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    document.documentElement.setAttribute("data-bs-theme", theme === "system" ? deviceTheme : theme);
};
document.addEventListener("tt-theme-change", $44ae6d9db4eaca0f$var$handlethemeChange);
document.addEventListener("web-share:error", $44ae6d9db4eaca0f$var$handleWebShareError);
document.addEventListener("capture-photo:video-play", $44ae6d9db4eaca0f$var$handleCapturePhotoVideoPlay, {
    once: true
});
document.addEventListener("capture-photo:error", $44ae6d9db4eaca0f$var$handleCapturePhotoError);
document.addEventListener("capture-photo:success", $44ae6d9db4eaca0f$var$handleCapturePhotoSuccess);
document.addEventListener("me-open", $44ae6d9db4eaca0f$var$handleModalOpen);
document.addEventListener("me-close", $44ae6d9db4eaca0f$var$handleModalClose);
document.addEventListener("emoji-click", $44ae6d9db4eaca0f$var$handleEmojiPickerSelection);
document.addEventListener("textbox-create", $44ae6d9db4eaca0f$var$handleTextboxCreate);
document.addEventListener("textbox-remove", $44ae6d9db4eaca0f$var$handleTextboxDelete);
$44ae6d9db4eaca0f$var$fileSelectBtn.addEventListener("click", $44ae6d9db4eaca0f$var$handleFileSelectClick);
$44ae6d9db4eaca0f$var$openVideoModalBtn.addEventListener("click", $44ae6d9db4eaca0f$var$handleOpenVideoModalButtonClick);
$44ae6d9db4eaca0f$var$addTextboxBtn.addEventListener("click", $44ae6d9db4eaca0f$var$handleAddTextboxBtnClick);
$44ae6d9db4eaca0f$var$generateMemeBtn.addEventListener("click", $44ae6d9db4eaca0f$var$generateMeme);
$44ae6d9db4eaca0f$var$downloadMemeBtn.addEventListener("click", ()=>$44ae6d9db4eaca0f$var$downloadModal.open = false);
$44ae6d9db4eaca0f$var$imageUrlForm.addEventListener("submit", $44ae6d9db4eaca0f$var$handleImageUploadFromURL);
// dropzoneEl.addEventListener('files-dropzone-drop-accepted', handleDropFilesAccepted);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("input", $44ae6d9db4eaca0f$var$handleTextboxesContainerInput);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("change", $44ae6d9db4eaca0f$var$handleTextboxesContainerChange);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("click", $44ae6d9db4eaca0f$var$handleTextboxesContainerClick);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("pointerdown", $44ae6d9db4eaca0f$var$handleTextboxesContainerPointerdown);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("pointerup", $44ae6d9db4eaca0f$var$handleTextboxesContainerPointerup);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("pointerout", $44ae6d9db4eaca0f$var$handleTextboxesContainerPointerout);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("keydown", $44ae6d9db4eaca0f$var$handleTextboxesContainerKeyDown);
$44ae6d9db4eaca0f$var$textboxesContainer.addEventListener("keyup", $44ae6d9db4eaca0f$var$handleTextboxesContainerKeyUp);
// imageUploadMethodSelect.addEventListener('change', handleUploadMethodChange);
$44ae6d9db4eaca0f$var$galleryEl.addEventListener("click", $44ae6d9db4eaca0f$var$handleGalleryClick);
// gallerySearchEl.addEventListener('input', handleGallerySearchInput);
$44ae6d9db4eaca0f$var$solidColorForm.addEventListener("input", $44ae6d9db4eaca0f$var$handleSolidColorFormInput);
$44ae6d9db4eaca0f$var$removeTextForm.addEventListener("submit", $44ae6d9db4eaca0f$var$handleTextRemoveFormSubmit);
$44ae6d9db4eaca0f$var$maxImageDimensionsForm.addEventListener("change", $44ae6d9db4eaca0f$var$handleMaxImageDimensionsFormChange);
$44ae6d9db4eaca0f$var$clearCanvasBtn.addEventListener("click", $44ae6d9db4eaca0f$var$handleClearCanvas);
$44ae6d9db4eaca0f$var$cameraSelect.addEventListener("change", $44ae6d9db4eaca0f$var$handleCameraSelectChange);
$44ae6d9db4eaca0f$var$capturePhotoButton.addEventListener("click", $44ae6d9db4eaca0f$var$handleCapturePhotoButtonClick);
$44ae6d9db4eaca0f$var$torchButton.addEventListener("click", $44ae6d9db4eaca0f$var$handleTorchButtonClick);
$44ae6d9db4eaca0f$var$galleryEl.querySelectorAll("button > img")?.forEach((image)=>{
    image.setAttribute("title", image.getAttribute("alt"));
});
(0, $f0ee20a32c2bc385$export$8e3dca5fa4d5f04b).create();
// dropzoneEl.accept = ACCEPTED_MIME_TYPES;
$44ae6d9db4eaca0f$var$renderAcceptedImageFormats((0, $33dea9d9a6da4c9a$export$63e7bed68b07a85c), $44ae6d9db4eaca0f$var$instructionsEl);
(0, $055531bbd0af154c$export$6874249d87f2602a).forEach(({ name: name, path: path, style: style, weight: weight })=>{
    (0, $055531bbd0af154c$export$59eceaef0c7797b2)(name, path, {
        style: style,
        weight: weight
    });
});
if ($44ae6d9db4eaca0f$var$maxImageDimensionsFromStorage) $44ae6d9db4eaca0f$var$maxImageDimensionsSelect.value = $44ae6d9db4eaca0f$var$maxImageDimensionsFromStorage;
$44ae6d9db4eaca0f$var$maxImageDimensionsSelect.disabled = false;
const $44ae6d9db4eaca0f$var$initGallery = ()=>{
    const buttons = $44ae6d9db4eaca0f$var$generateGalleryButtons((0, (/*@__PURE__*/$parcel$interopDefault($cd9a1f5526d5caac$exports))));
    buttons.forEach((button)=>$44ae6d9db4eaca0f$var$galleryContainer.appendChild(button));
};
$44ae6d9db4eaca0f$var$initGallery();

})();
//# sourceMappingURL=index.22873d16.js.map
